// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/dotted_bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Fonts/Gebes.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Fonts/AudiowideRegular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Fonts/BebasNeue-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Fonts/Good Times Rg.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./Fonts/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./Fonts/Bartomes.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./Fonts/AntonSC-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./Fonts//Jaro-Regular-VariableFont_opsz.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./Fonts//BOXIGEN.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../public/images/dotted_bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../public/images/dotted_bg_light.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-4 {
  inset: 1rem;
}
.inset-8 {
  inset: 2rem;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-12 {
  bottom: -3rem;
}
.-bottom-2 {
  bottom: -0.5rem;
}
.-bottom-2\\.5 {
  bottom: -0.625rem;
}
.-bottom-\\[1px\\] {
  bottom: -1px;
}
.-right-1 {
  right: -0.25rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-4 {
  right: -1rem;
}
.-top-0 {
  top: -0px;
}
.-top-1 {
  top: -0.25rem;
}
.-top-10 {
  top: -2.5rem;
}
.-top-11 {
  top: -2.75rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-3 {
  top: -0.75rem;
}
.-top-4 {
  top: -1rem;
}
.-top-8 {
  top: -2rem;
}
.-top-\\[50px\\] {
  top: -50px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-1\\.5 {
  bottom: 0.375rem;
}
.bottom-1\\/2 {
  bottom: 50%;
}
.bottom-10 {
  bottom: 2.5rem;
}
.bottom-14 {
  bottom: 3.5rem;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-7 {
  bottom: 1.75rem;
}
.bottom-8 {
  bottom: 2rem;
}
.bottom-9 {
  bottom: 2.25rem;
}
.bottom-\\[-20px\\] {
  bottom: -20px;
}
.bottom-\\[10px\\] {
  bottom: 10px;
}
.bottom-\\[125px\\] {
  bottom: 125px;
}
.bottom-\\[150\\%\\] {
  bottom: 150%;
}
.bottom-\\[15px\\] {
  bottom: 15px;
}
.bottom-\\[20px\\] {
  bottom: 20px;
}
.bottom-\\[30px\\] {
  bottom: 30px;
}
.bottom-\\[50px\\] {
  bottom: 50px;
}
.bottom-\\[57px\\] {
  bottom: 57px;
}
.bottom-\\[60px\\] {
  bottom: 60px;
}
.bottom-\\[70px\\] {
  bottom: 70px;
}
.bottom-full {
  bottom: 100%;
}
.left-0 {
  left: 0px;
}
.left-0\\.5 {
  left: 0.125rem;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-1\\/4 {
  left: 25%;
}
.left-10 {
  left: 2.5rem;
}
.left-2 {
  left: 0.5rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-5 {
  left: 1.25rem;
}
.left-6 {
  left: 1.5rem;
}
.left-7 {
  left: 1.75rem;
}
.left-8 {
  left: 2rem;
}
.left-9 {
  left: 2.25rem;
}
.left-\\[-12px\\] {
  left: -12px;
}
.left-\\[-16px\\] {
  left: -16px;
}
.left-\\[-20px\\] {
  left: -20px;
}
.left-\\[-240px\\] {
  left: -240px;
}
.left-\\[-24px\\] {
  left: -24px;
}
.left-\\[-25\\.2rem\\] {
  left: -25.2rem;
}
.left-\\[-25rem\\] {
  left: -25rem;
}
.left-\\[-30\\.5px\\] {
  left: -30.5px;
}
.left-\\[-35px\\] {
  left: -35px;
}
.left-\\[-76\\.4rem\\] {
  left: -76.4rem;
}
.left-\\[0px\\] {
  left: 0px;
}
.left-\\[10px\\] {
  left: 10px;
}
.left-\\[120\\%\\] {
  left: 120%;
}
.left-\\[130px\\] {
  left: 130px;
}
.left-\\[15\\%\\] {
  left: 15%;
}
.left-\\[15px\\] {
  left: 15px;
}
.left-\\[15rem\\] {
  left: 15rem;
}
.left-\\[16\\%\\] {
  left: 16%;
}
.left-\\[16px\\] {
  left: 16px;
}
.left-\\[170px\\] {
  left: 170px;
}
.left-\\[17rem\\] {
  left: 17rem;
}
.left-\\[200px\\] {
  left: 200px;
}
.left-\\[22px\\] {
  left: 22px;
}
.left-\\[230px\\] {
  left: 230px;
}
.left-\\[240px\\] {
  left: 240px;
}
.left-\\[3\\%\\] {
  left: 3%;
}
.left-\\[30px\\] {
  left: 30px;
}
.left-\\[32\\%\\] {
  left: 32%;
}
.left-\\[342px\\] {
  left: 342px;
}
.left-\\[3px\\] {
  left: 3px;
}
.left-\\[410px\\] {
  left: 410px;
}
.left-\\[425px\\] {
  left: 425px;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.left-\\[50\\.5\\%\\] {
  left: 50.5%;
}
.left-\\[51\\%\\] {
  left: 51%;
}
.left-\\[6px\\] {
  left: 6px;
}
.left-\\[8px\\] {
  left: 8px;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\/2 {
  right: 50%;
}
.right-10 {
  right: 2.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-5 {
  right: 1.25rem;
}
.right-6 {
  right: 1.5rem;
}
.right-7 {
  right: 1.75rem;
}
.right-8 {
  right: 2rem;
}
.right-9 {
  right: 2.25rem;
}
.right-\\[-10px\\] {
  right: -10px;
}
.right-\\[-14px\\] {
  right: -14px;
}
.right-\\[-20px\\] {
  right: -20px;
}
.right-\\[-50px\\] {
  right: -50px;
}
.right-\\[-5px\\] {
  right: -5px;
}
.right-\\[0\\.4rem\\] {
  right: 0.4rem;
}
.right-\\[0px\\] {
  right: 0px;
}
.right-\\[0rem\\] {
  right: 0rem;
}
.right-\\[10px\\] {
  right: 10px;
}
.right-\\[110px\\] {
  right: 110px;
}
.right-\\[140px\\] {
  right: 140px;
}
.right-\\[150px\\] {
  right: 150px;
}
.right-\\[15px\\] {
  right: 15px;
}
.right-\\[160px\\] {
  right: 160px;
}
.right-\\[19px\\] {
  right: 19px;
}
.right-\\[1px\\] {
  right: 1px;
}
.right-\\[2px\\] {
  right: 2px;
}
.right-\\[5px\\] {
  right: 5px;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-11 {
  top: 2.75rem;
}
.top-16 {
  top: 4rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-2\\/3 {
  top: 66.666667%;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-6 {
  top: 1.5rem;
}
.top-9 {
  top: 2.25rem;
}
.top-\\[-1\\.5rem\\] {
  top: -1.5rem;
}
.top-\\[-100px\\] {
  top: -100px;
}
.top-\\[-10px\\] {
  top: -10px;
}
.top-\\[-11px\\] {
  top: -11px;
}
.top-\\[-12px\\] {
  top: -12px;
}
.top-\\[-16px\\] {
  top: -16px;
}
.top-\\[-24px\\] {
  top: -24px;
}
.top-\\[-30px\\] {
  top: -30px;
}
.top-\\[-3px\\] {
  top: -3px;
}
.top-\\[-55px\\] {
  top: -55px;
}
.top-\\[-5px\\] {
  top: -5px;
}
.top-\\[-8px\\] {
  top: -8px;
}
.top-\\[0\\.2rem\\] {
  top: 0.2rem;
}
.top-\\[0\\.7rem\\] {
  top: 0.7rem;
}
.top-\\[0px\\] {
  top: 0px;
}
.top-\\[0rem\\] {
  top: 0rem;
}
.top-\\[1\\.1rem\\] {
  top: 1.1rem;
}
.top-\\[10\\%\\] {
  top: 10%;
}
.top-\\[10\\.5\\%\\] {
  top: 10.5%;
}
.top-\\[10px\\] {
  top: 10px;
}
.top-\\[10rem\\] {
  top: 10rem;
}
.top-\\[11\\%\\] {
  top: 11%;
}
.top-\\[115px\\] {
  top: 115px;
}
.top-\\[11px\\] {
  top: 11px;
}
.top-\\[12px\\] {
  top: 12px;
}
.top-\\[13px\\] {
  top: 13px;
}
.top-\\[15\\%\\] {
  top: 15%;
}
.top-\\[15px\\] {
  top: 15px;
}
.top-\\[15rem\\] {
  top: 15rem;
}
.top-\\[165px\\] {
  top: 165px;
}
.top-\\[16px\\] {
  top: 16px;
}
.top-\\[175px\\] {
  top: 175px;
}
.top-\\[180px\\] {
  top: 180px;
}
.top-\\[1rem\\] {
  top: 1rem;
}
.top-\\[20\\%\\] {
  top: 20%;
}
.top-\\[200px\\] {
  top: 200px;
}
.top-\\[201px\\] {
  top: 201px;
}
.top-\\[20px\\] {
  top: 20px;
}
.top-\\[215px\\] {
  top: 215px;
}
.top-\\[221px\\] {
  top: 221px;
}
.top-\\[24px\\] {
  top: 24px;
}
.top-\\[26px\\] {
  top: 26px;
}
.top-\\[28\\.5\\%\\] {
  top: 28.5%;
}
.top-\\[2px\\] {
  top: 2px;
}
.top-\\[35px\\] {
  top: 35px;
}
.top-\\[38px\\] {
  top: 38px;
}
.top-\\[41px\\] {
  top: 41px;
}
.top-\\[44\\%\\] {
  top: 44%;
}
.top-\\[45\\%\\] {
  top: 45%;
}
.top-\\[450px\\] {
  top: 450px;
}
.top-\\[45px\\] {
  top: 45px;
}
.top-\\[4rem\\] {
  top: 4rem;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[5px\\] {
  top: 5px;
}
.top-\\[5rem\\] {
  top: 5rem;
}
.top-\\[66px\\] {
  top: 66px;
}
.top-\\[69\\%\\] {
  top: 69%;
}
.top-\\[70\\%\\] {
  top: 70%;
}
.top-\\[81px\\] {
  top: 81px;
}
.top-\\[8px\\] {
  top: 8px;
}
.top-full {
  top: 100%;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[1001\\] {
  z-index: 1001;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[999999999\\] {
  z-index: 999999999;
}
.z-\\[99999999\\] {
  z-index: 99999999;
}
.z-\\[9999999\\] {
  z-index: 9999999;
}
.z-\\[999999\\] {
  z-index: 999999;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-\\[99\\] {
  z-index: 99;
}
.z-\\[9\\] {
  z-index: 9;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-full {
  grid-column: 1 / -1;
}
.col-start-2 {
  grid-column-start: 2;
}
.col-end-4 {
  grid-column-end: 4;
}
.row-start-1 {
  grid-row-start: 1;
}
.row-end-4 {
  grid-row-end: 4;
}
.float-right {
  float: right;
}
.m-0\\.5 {
  margin: 0.125rem;
}
.m-1 {
  margin: 0.25rem;
}
.m-2 {
  margin: 0.5rem;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-\\[10px\\] {
  margin: 10px;
}
.m-auto {
  margin: auto;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-10 {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-\\[16px\\] {
  margin-left: 16px;
  margin-right: 16px;
}
.mx-\\[50px\\] {
  margin-left: 50px;
  margin-right: 50px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-2\\.5 {
  margin-top: 0.625rem;
  margin-bottom: 0.625rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-7 {
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}
.-ml-2 {
  margin-left: -0.5rem;
}
.-mt-\\[30px\\] {
  margin-top: -30px;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-9 {
  margin-bottom: 2.25rem;
}
.mb-\\[-3px\\] {
  margin-bottom: -3px;
}
.mb-\\[-5px\\] {
  margin-bottom: -5px;
}
.mb-\\[0\\.5px\\] {
  margin-bottom: 0.5px;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[1px\\] {
  margin-bottom: 1px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[3px\\] {
  margin-bottom: 3px;
}
.mb-\\[5px\\] {
  margin-bottom: 5px;
}
.me-1 {
  margin-inline-end: 0.25rem;
}
.me-1\\.5 {
  margin-inline-end: 0.375rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-3 {
  margin-inline-end: 0.75rem;
}
.me-4 {
  margin-inline-end: 1rem;
}
.me-6 {
  margin-inline-end: 1.5rem;
}
.me-\\[20px\\] {
  margin-inline-end: 20px;
}
.me-auto {
  margin-inline-end: auto;
}
.ml-0 {
  margin-left: 0px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-3\\.5 {
  margin-left: 0.875rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-8 {
  margin-left: 2rem;
}
.ml-9 {
  margin-left: 2.25rem;
}
.ml-\\[-0\\.3rem\\] {
  margin-left: -0.3rem;
}
.ml-\\[-11rem\\] {
  margin-left: -11rem;
}
.ml-\\[-16px\\] {
  margin-left: -16px;
}
.ml-\\[-20px\\] {
  margin-left: -20px;
}
.ml-\\[-30px\\] {
  margin-left: -30px;
}
.ml-\\[-52px\\] {
  margin-left: -52px;
}
.ml-\\[-64px\\] {
  margin-left: -64px;
}
.ml-\\[10px\\] {
  margin-left: 10px;
}
.ml-\\[120px\\] {
  margin-left: 120px;
}
.ml-\\[12px\\] {
  margin-left: 12px;
}
.ml-\\[15\\%\\] {
  margin-left: 15%;
}
.ml-\\[16px\\] {
  margin-left: 16px;
}
.ml-\\[1px\\] {
  margin-left: 1px;
}
.ml-\\[20\\%\\] {
  margin-left: 20%;
}
.ml-\\[20px\\] {
  margin-left: 20px;
}
.ml-\\[25\\%\\] {
  margin-left: 25%;
}
.ml-\\[26px\\] {
  margin-left: 26px;
}
.ml-\\[40\\%\\] {
  margin-left: 40%;
}
.ml-\\[5px\\] {
  margin-left: 5px;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.mr-6 {
  margin-right: 1.5rem;
}
.mr-\\[-11rem\\] {
  margin-right: -11rem;
}
.mr-\\[-1rem\\] {
  margin-right: -1rem;
}
.mr-\\[-8px\\] {
  margin-right: -8px;
}
.mr-\\[10px\\] {
  margin-right: 10px;
}
.mr-\\[16px\\] {
  margin-right: 16px;
}
.mr-\\[20px\\] {
  margin-right: 20px;
}
.mr-\\[5px\\] {
  margin-right: 5px;
}
.ms-0 {
  margin-inline-start: 0px;
}
.ms-0\\.5 {
  margin-inline-start: 0.125rem;
}
.ms-1 {
  margin-inline-start: 0.25rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.ms-20 {
  margin-inline-start: 5rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.ms-3\\.5 {
  margin-inline-start: 0.875rem;
}
.ms-4 {
  margin-inline-start: 1rem;
}
.ms-5 {
  margin-inline-start: 1.25rem;
}
.ms-\\[100px\\] {
  margin-inline-start: 100px;
}
.ms-\\[103px\\] {
  margin-inline-start: 103px;
}
.ms-\\[104px\\] {
  margin-inline-start: 104px;
}
.ms-\\[105px\\] {
  margin-inline-start: 105px;
}
.ms-\\[107px\\] {
  margin-inline-start: 107px;
}
.ms-\\[110px\\] {
  margin-inline-start: 110px;
}
.ms-\\[115px\\] {
  margin-inline-start: 115px;
}
.ms-\\[125px\\] {
  margin-inline-start: 125px;
}
.ms-\\[130px\\] {
  margin-inline-start: 130px;
}
.ms-\\[15px\\] {
  margin-inline-start: 15px;
}
.ms-\\[17px\\] {
  margin-inline-start: 17px;
}
.ms-\\[20px\\] {
  margin-inline-start: 20px;
}
.ms-\\[25px\\] {
  margin-inline-start: 25px;
}
.ms-\\[35px\\] {
  margin-inline-start: 35px;
}
.ms-\\[37px\\] {
  margin-inline-start: 37px;
}
.ms-\\[40px\\] {
  margin-inline-start: 40px;
}
.ms-\\[47px\\] {
  margin-inline-start: 47px;
}
.ms-\\[72px\\] {
  margin-inline-start: 72px;
}
.ms-\\[75px\\] {
  margin-inline-start: 75px;
}
.ms-\\[78px\\] {
  margin-inline-start: 78px;
}
.ms-\\[88px\\] {
  margin-inline-start: 88px;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[-10px\\] {
  margin-top: -10px;
}
.mt-\\[-15px\\] {
  margin-top: -15px;
}
.mt-\\[-29px\\] {
  margin-top: -29px;
}
.mt-\\[-2px\\] {
  margin-top: -2px;
}
.mt-\\[-3px\\] {
  margin-top: -3px;
}
.mt-\\[-4px\\] {
  margin-top: -4px;
}
.mt-\\[-5px\\] {
  margin-top: -5px;
}
.mt-\\[-65px\\] {
  margin-top: -65px;
}
.mt-\\[-6px\\] {
  margin-top: -6px;
}
.mt-\\[-7px\\] {
  margin-top: -7px;
}
.mt-\\[-8px\\] {
  margin-top: -8px;
}
.mt-\\[-9px\\] {
  margin-top: -9px;
}
.mt-\\[0\\.125rem\\] {
  margin-top: 0.125rem;
}
.mt-\\[10\\%\\] {
  margin-top: 10%;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[15px\\] {
  margin-top: 15px;
}
.mt-\\[18px\\] {
  margin-top: 18px;
}
.mt-\\[2\\%\\] {
  margin-top: 2%;
}
.mt-\\[20\\%\\] {
  margin-top: 20%;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.mt-\\[25px\\] {
  margin-top: 25px;
}
.mt-\\[27rem\\] {
  margin-top: 27rem;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-\\[3\\%\\] {
  margin-top: 3%;
}
.mt-\\[30\\%\\] {
  margin-top: 30%;
}
.mt-\\[31px\\] {
  margin-top: 31px;
}
.mt-\\[33px\\] {
  margin-top: 33px;
}
.mt-\\[34px\\] {
  margin-top: 34px;
}
.mt-\\[4px\\] {
  margin-top: 4px;
}
.mt-\\[5\\%\\] {
  margin-top: 5%;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-\\[8\\%\\] {
  margin-top: 8%;
}
.mt-\\[8px\\] {
  margin-top: 8px;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.\\!table {
  display: table !important;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[1\\/1\\] {
  aspect-ratio: 1/1;
}
.\\!h-\\[36px\\] {
  height: 36px !important;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-1\\/2 {
  height: 50%;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-52 {
  height: 13rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[0\\.5px\\] {
  height: 0.5px;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[105px\\] {
  height: 105px;
}
.h-\\[107px\\] {
  height: 107px;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[10vh\\] {
  height: 10vh;
}
.h-\\[110px\\] {
  height: 110px;
}
.h-\\[115px\\] {
  height: 115px;
}
.h-\\[117px\\] {
  height: 117px;
}
.h-\\[119px\\] {
  height: 119px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[124px\\] {
  height: 124px;
}
.h-\\[12px\\] {
  height: 12px;
}
.h-\\[130px\\] {
  height: 130px;
}
.h-\\[136px\\] {
  height: 136px;
}
.h-\\[139px\\] {
  height: 139px;
}
.h-\\[140px\\] {
  height: 140px;
}
.h-\\[143px\\] {
  height: 143px;
}
.h-\\[145px\\] {
  height: 145px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[156px\\] {
  height: 156px;
}
.h-\\[15px\\] {
  height: 15px;
}
.h-\\[15vh\\] {
  height: 15vh;
}
.h-\\[160px\\] {
  height: 160px;
}
.h-\\[162px\\] {
  height: 162px;
}
.h-\\[16px\\] {
  height: 16px;
}
.h-\\[170px\\] {
  height: 170px;
}
.h-\\[172px\\] {
  height: 172px;
}
.h-\\[175px\\] {
  height: 175px;
}
.h-\\[176px\\] {
  height: 176px;
}
.h-\\[178px\\] {
  height: 178px;
}
.h-\\[17px\\] {
  height: 17px;
}
.h-\\[180px\\] {
  height: 180px;
}
.h-\\[185px\\] {
  height: 185px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[190px\\] {
  height: 190px;
}
.h-\\[192px\\] {
  height: 192px;
}
.h-\\[198px\\] {
  height: 198px;
}
.h-\\[19px\\] {
  height: 19px;
}
.h-\\[1px\\] {
  height: 1px;
}
.h-\\[2\\.1rem\\] {
  height: 2.1rem;
}
.h-\\[20\\%\\] {
  height: 20%;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[205px\\] {
  height: 205px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[225px\\] {
  height: 225px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[230px\\] {
  height: 230px;
}
.h-\\[240px\\] {
  height: 240px;
}
.h-\\[245px\\] {
  height: 245px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[250px\\] {
  height: 250px;
}
.h-\\[253px\\] {
  height: 253px;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[25vh\\] {
  height: 25vh;
}
.h-\\[265px\\] {
  height: 265px;
}
.h-\\[267\\.55px\\] {
  height: 267.55px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[270px\\] {
  height: 270px;
}
.h-\\[275px\\] {
  height: 275px;
}
.h-\\[280px\\] {
  height: 280px;
}
.h-\\[282px\\] {
  height: 282px;
}
.h-\\[284px\\] {
  height: 284px;
}
.h-\\[285px\\] {
  height: 285px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[29\\%\\] {
  height: 29%;
}
.h-\\[290px\\] {
  height: 290px;
}
.h-\\[294px\\] {
  height: 294px;
}
.h-\\[295px\\] {
  height: 295px;
}
.h-\\[29px\\] {
  height: 29px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30\\%\\] {
  height: 30%;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[305px\\] {
  height: 305px;
}
.h-\\[309px\\] {
  height: 309px;
}
.h-\\[30dvh\\] {
  height: 30dvh;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[30vh\\] {
  height: 30vh;
}
.h-\\[310px\\] {
  height: 310px;
}
.h-\\[314px\\] {
  height: 314px;
}
.h-\\[315px\\] {
  height: 315px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[325px\\] {
  height: 325px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[330px\\] {
  height: 330px;
}
.h-\\[335px\\] {
  height: 335px;
}
.h-\\[33px\\] {
  height: 33px;
}
.h-\\[33vh\\] {
  height: 33vh;
}
.h-\\[340px\\] {
  height: 340px;
}
.h-\\[342px\\] {
  height: 342px;
}
.h-\\[345px\\] {
  height: 345px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[350px\\] {
  height: 350px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[365px\\] {
  height: 365px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[380px\\] {
  height: 380px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[40\\%\\] {
  height: 40%;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[40vh\\] {
  height: 40vh;
}
.h-\\[420px\\] {
  height: 420px;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[42vh\\] {
  height: 42vh;
}
.h-\\[436px\\] {
  height: 436px;
}
.h-\\[43px\\] {
  height: 43px;
}
.h-\\[440px\\] {
  height: 440px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[450px\\] {
  height: 450px;
}
.h-\\[452px\\] {
  height: 452px;
}
.h-\\[45px\\] {
  height: 45px;
}
.h-\\[45vh\\] {
  height: 45vh;
}
.h-\\[460px\\] {
  height: 460px;
}
.h-\\[46px\\] {
  height: 46px;
}
.h-\\[470px\\] {
  height: 470px;
}
.h-\\[479px\\] {
  height: 479px;
}
.h-\\[47px\\] {
  height: 47px;
}
.h-\\[480px\\] {
  height: 480px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[492px\\] {
  height: 492px;
}
.h-\\[49px\\] {
  height: 49px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[50vh\\] {
  height: 50vh;
}
.h-\\[51px\\] {
  height: 51px;
}
.h-\\[52px\\] {
  height: 52px;
}
.h-\\[532px\\] {
  height: 532px;
}
.h-\\[53px\\] {
  height: 53px;
}
.h-\\[540px\\] {
  height: 540px;
}
.h-\\[550px\\] {
  height: 550px;
}
.h-\\[555px\\] {
  height: 555px;
}
.h-\\[55px\\] {
  height: 55px;
}
.h-\\[55vh\\] {
  height: 55vh;
}
.h-\\[56px\\] {
  height: 56px;
}
.h-\\[580px\\] {
  height: 580px;
}
.h-\\[5px\\] {
  height: 5px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[60vh\\] {
  height: 60vh;
}
.h-\\[616px\\] {
  height: 616px;
}
.h-\\[61px\\] {
  height: 61px;
}
.h-\\[61vh\\] {
  height: 61vh;
}
.h-\\[64px\\] {
  height: 64px;
}
.h-\\[65px\\] {
  height: 65px;
}
.h-\\[65vh\\] {
  height: 65vh;
}
.h-\\[68px\\] {
  height: 68px;
}
.h-\\[68vh\\] {
  height: 68vh;
}
.h-\\[690px\\] {
  height: 690px;
}
.h-\\[6px\\] {
  height: 6px;
}
.h-\\[70\\%\\] {
  height: 70%;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-\\[71px\\] {
  height: 71px;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[75\\%\\] {
  height: 75%;
}
.h-\\[75vh\\] {
  height: 75vh;
}
.h-\\[76vh\\] {
  height: 76vh;
}
.h-\\[78vh\\] {
  height: 78vh;
}
.h-\\[79vh\\] {
  height: 79vh;
}
.h-\\[7px\\] {
  height: 7px;
}
.h-\\[80\\%\\] {
  height: 80%;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[80vh\\] {
  height: 80vh;
}
.h-\\[84vh\\] {
  height: 84vh;
}
.h-\\[85\\%\\] {
  height: 85%;
}
.h-\\[85px\\] {
  height: 85px;
}
.h-\\[85vh\\] {
  height: 85vh;
}
.h-\\[86vh\\] {
  height: 86vh;
}
.h-\\[87vh\\] {
  height: 87vh;
}
.h-\\[88px\\] {
  height: 88px;
}
.h-\\[88vh\\] {
  height: 88vh;
}
.h-\\[8px\\] {
  height: 8px;
}
.h-\\[90\\%\\] {
  height: 90%;
}
.h-\\[90px\\] {
  height: 90px;
}
.h-\\[90vh\\] {
  height: 90vh;
}
.h-\\[92vh\\] {
  height: 92vh;
}
.h-\\[96px\\] {
  height: 96px;
}
.h-\\[98\\%\\] {
  height: 98%;
}
.h-\\[98vh\\] {
  height: 98vh;
}
.h-\\[9999\\] {
  height: 9999;
}
.h-\\[calc\\(100\\%\\+74px\\)\\] {
  height: calc(100% + 74px);
}
.h-\\[calc\\(100\\%-1rem\\)\\] {
  height: calc(100% - 1rem);
}
.h-\\[calc\\(100\\%-50px\\)\\] {
  height: calc(100% - 50px);
}
.h-\\[calc\\(100vh-100px\\)\\] {
  height: calc(100vh - 100px);
}
.h-auto {
  height: auto;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-\\[1000px\\] {
  max-height: 1000px;
}
.max-h-\\[100px\\] {
  max-height: 100px;
}
.max-h-\\[10rem\\] {
  max-height: 10rem;
}
.max-h-\\[120px\\] {
  max-height: 120px;
}
.max-h-\\[130px\\] {
  max-height: 130px;
}
.max-h-\\[140px\\] {
  max-height: 140px;
}
.max-h-\\[160px\\] {
  max-height: 160px;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[20rem\\] {
  max-height: 20rem;
}
.max-h-\\[22px\\] {
  max-height: 22px;
}
.max-h-\\[240px\\] {
  max-height: 240px;
}
.max-h-\\[25px\\] {
  max-height: 25px;
}
.max-h-\\[285px\\] {
  max-height: 285px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[320px\\] {
  max-height: 320px;
}
.max-h-\\[330px\\] {
  max-height: 330px;
}
.max-h-\\[340px\\] {
  max-height: 340px;
}
.max-h-\\[348px\\] {
  max-height: 348px;
}
.max-h-\\[34px\\] {
  max-height: 34px;
}
.max-h-\\[350px\\] {
  max-height: 350px;
}
.max-h-\\[40\\%\\] {
  max-height: 40%;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[45vh\\] {
  max-height: 45vh;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[50px\\] {
  max-height: 50px;
}
.max-h-\\[50vh\\] {
  max-height: 50vh;
}
.max-h-\\[550px\\] {
  max-height: 550px;
}
.max-h-\\[600px\\] {
  max-height: 600px;
}
.max-h-\\[75\\%\\] {
  max-height: 75%;
}
.max-h-\\[75px\\] {
  max-height: 75px;
}
.max-h-\\[75vh\\] {
  max-height: 75vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[83vh\\] {
  max-height: 83vh;
}
.max-h-\\[85\\%\\] {
  max-height: 85%;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[87px\\] {
  max-height: 87px;
}
.max-h-\\[87vh\\] {
  max-height: 87vh;
}
.max-h-\\[90px\\] {
  max-height: 90px;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[none\\] {
  max-height: none;
}
.max-h-full {
  max-height: 100%;
}
.\\!min-h-full {
  min-height: 100% !important;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.min-h-\\[12rem\\] {
  min-height: 12rem;
}
.min-h-\\[16px\\] {
  min-height: 16px;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[212px\\] {
  min-height: 212px;
}
.min-h-\\[244px\\] {
  min-height: 244px;
}
.min-h-\\[250px\\] {
  min-height: 250px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[330px\\] {
  min-height: 330px;
}
.min-h-\\[350px\\] {
  min-height: 350px;
}
.min-h-\\[35vh\\] {
  min-height: 35vh;
}
.min-h-\\[36px\\] {
  min-height: 36px;
}
.min-h-\\[380px\\] {
  min-height: 380px;
}
.min-h-\\[38px\\] {
  min-height: 38px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[40vh\\] {
  min-height: 40vh;
}
.min-h-\\[410px\\] {
  min-height: 410px;
}
.min-h-\\[45px\\] {
  min-height: 45px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[532px\\] {
  min-height: 532px;
}
.min-h-\\[580px\\] {
  min-height: 580px;
}
.min-h-\\[60vh\\] {
  min-height: 60vh;
}
.min-h-\\[65vh\\] {
  min-height: 65vh;
}
.min-h-\\[75vh\\] {
  min-height: 75vh;
}
.min-h-\\[79vh\\] {
  min-height: 79vh;
}
.min-h-\\[96px\\] {
  min-height: 96px;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-80 {
  width: 20rem !important;
}
.\\!w-\\[30\\%\\] {
  width: 30% !important;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-1\\/5 {
  width: 20%;
}
.w-10 {
  width: 2.5rem;
}
.w-10\\/12 {
  width: 83.333333%;
}
.w-11\\/12 {
  width: 91.666667%;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-4\\/5 {
  width: 80%;
}
.w-4\\/6 {
  width: 66.666667%;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-5\\/6 {
  width: 83.333333%;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-96 {
  width: 24rem;
}
.w-\\[0\\%\\] {
  width: 0%;
}
.w-\\[1\\%\\] {
  width: 1%;
}
.w-\\[1\\.5px\\] {
  width: 1.5px;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[100\\] {
  width: 100;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[101\\.8\\%\\] {
  width: 101.8%;
}
.w-\\[102px\\] {
  width: 102px;
}
.w-\\[103\\%\\] {
  width: 103%;
}
.w-\\[105px\\] {
  width: 105px;
}
.w-\\[107\\%\\] {
  width: 107%;
}
.w-\\[108px\\] {
  width: 108px;
}
.w-\\[10px\\] {
  width: 10px;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[12\\%\\] {
  width: 12%;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[12px\\] {
  width: 12px;
}
.w-\\[13\\%\\] {
  width: 13%;
}
.w-\\[1300px\\] {
  width: 1300px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[13px\\] {
  width: 13px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[143px\\] {
  width: 143px;
}
.w-\\[148px\\] {
  width: 148px;
}
.w-\\[149px\\] {
  width: 149px;
}
.w-\\[15\\%\\] {
  width: 15%;
}
.w-\\[150\\.5px\\] {
  width: 150.5px;
}
.w-\\[150\\.9px\\] {
  width: 150.9px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[156px\\] {
  width: 156px;
}
.w-\\[15px\\] {
  width: 15px;
}
.w-\\[16\\%\\] {
  width: 16%;
}
.w-\\[16\\.5\\%\\] {
  width: 16.5%;
}
.w-\\[160px\\] {
  width: 160px;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[170px\\] {
  width: 170px;
}
.w-\\[175px\\] {
  width: 175px;
}
.w-\\[17px\\] {
  width: 17px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[190px\\] {
  width: 190px;
}
.w-\\[196\\.4vh\\] {
  width: 196.4vh;
}
.w-\\[198px\\] {
  width: 198px;
}
.w-\\[19px\\] {
  width: 19px;
}
.w-\\[1px\\] {
  width: 1px;
}
.w-\\[20\\%\\] {
  width: 20%;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[20rem\\] {
  width: 20rem;
}
.w-\\[210px\\] {
  width: 210px;
}
.w-\\[212px\\] {
  width: 212px;
}
.w-\\[217px\\] {
  width: 217px;
}
.w-\\[22\\%\\] {
  width: 22%;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[223px\\] {
  width: 223px;
}
.w-\\[225px\\] {
  width: 225px;
}
.w-\\[226px\\] {
  width: 226px;
}
.w-\\[228px\\] {
  width: 228px;
}
.w-\\[22px\\] {
  width: 22px;
}
.w-\\[23\\%\\] {
  width: 23%;
}
.w-\\[230px\\] {
  width: 230px;
}
.w-\\[240px\\] {
  width: 240px;
}
.w-\\[249px\\] {
  width: 249px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[25\\%\\] {
  width: 25%;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[255px\\] {
  width: 255px;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[25rem\\] {
  width: 25rem;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[270px\\] {
  width: 270px;
}
.w-\\[272px\\] {
  width: 272px;
}
.w-\\[28\\%\\] {
  width: 28%;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[29\\%\\] {
  width: 29%;
}
.w-\\[290px\\] {
  width: 290px;
}
.w-\\[293px\\] {
  width: 293px;
}
.w-\\[298px\\] {
  width: 298px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[307px\\] {
  width: 307px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[32\\%\\] {
  width: 32%;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[324px\\] {
  width: 324px;
}
.w-\\[325px\\] {
  width: 325px;
}
.w-\\[32px\\] {
  width: 32px;
}
.w-\\[33\\%\\] {
  width: 33%;
}
.w-\\[330px\\] {
  width: 330px;
}
.w-\\[332px\\] {
  width: 332px;
}
.w-\\[33px\\] {
  width: 33px;
}
.w-\\[34\\%\\] {
  width: 34%;
}
.w-\\[340px\\] {
  width: 340px;
}
.w-\\[345px\\] {
  width: 345px;
}
.w-\\[34px\\] {
  width: 34px;
}
.w-\\[35\\%\\] {
  width: 35%;
}
.w-\\[35\\.65\\%\\] {
  width: 35.65%;
}
.w-\\[350px\\] {
  width: 350px;
}
.w-\\[352px\\] {
  width: 352px;
}
.w-\\[35px\\] {
  width: 35px;
}
.w-\\[360px\\] {
  width: 360px;
}
.w-\\[362px\\] {
  width: 362px;
}
.w-\\[36px\\] {
  width: 36px;
}
.w-\\[38\\%\\] {
  width: 38%;
}
.w-\\[380px\\] {
  width: 380px;
}
.w-\\[382px\\] {
  width: 382px;
}
.w-\\[385px\\] {
  width: 385px;
}
.w-\\[38px\\] {
  width: 38px;
}
.w-\\[390px\\] {
  width: 390px;
}
.w-\\[398px\\] {
  width: 398px;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[40rem\\] {
  width: 40rem;
}
.w-\\[413px\\] {
  width: 413px;
}
.w-\\[42\\%\\] {
  width: 42%;
}
.w-\\[420px\\] {
  width: 420px;
}
.w-\\[42px\\] {
  width: 42px;
}
.w-\\[430px\\] {
  width: 430px;
}
.w-\\[439px\\] {
  width: 439px;
}
.w-\\[440px\\] {
  width: 440px;
}
.w-\\[44px\\] {
  width: 44px;
}
.w-\\[45\\%\\] {
  width: 45%;
}
.w-\\[450px\\] {
  width: 450px;
}
.w-\\[45px\\] {
  width: 45px;
}
.w-\\[46px\\] {
  width: 46px;
}
.w-\\[47\\%\\] {
  width: 47%;
}
.w-\\[47px\\] {
  width: 47px;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[49\\%\\] {
  width: 49%;
}
.w-\\[49px\\] {
  width: 49px;
}
.w-\\[5\\%\\] {
  width: 5%;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[502px\\] {
  width: 502px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[52px\\] {
  width: 52px;
}
.w-\\[55\\%\\] {
  width: 55%;
}
.w-\\[550px\\] {
  width: 550px;
}
.w-\\[55px\\] {
  width: 55px;
}
.w-\\[57px\\] {
  width: 57px;
}
.w-\\[58\\%\\] {
  width: 58%;
}
.w-\\[59\\%\\] {
  width: 59%;
}
.w-\\[590px\\] {
  width: 590px;
}
.w-\\[59px\\] {
  width: 59px;
}
.w-\\[60\\%\\] {
  width: 60%;
}
.w-\\[600px\\] {
  width: 600px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[64px\\] {
  width: 64px;
}
.w-\\[65\\%\\] {
  width: 65%;
}
.w-\\[65px\\] {
  width: 65px;
}
.w-\\[67px\\] {
  width: 67px;
}
.w-\\[68\\%\\] {
  width: 68%;
}
.w-\\[680px\\] {
  width: 680px;
}
.w-\\[690px\\] {
  width: 690px;
}
.w-\\[6px\\] {
  width: 6px;
}
.w-\\[70\\%\\] {
  width: 70%;
}
.w-\\[700px\\] {
  width: 700px;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[712px\\] {
  width: 712px;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[73\\%\\] {
  width: 73%;
}
.w-\\[75\\%\\] {
  width: 75%;
}
.w-\\[750px\\] {
  width: 750px;
}
.w-\\[75px\\] {
  width: 75px;
}
.w-\\[78px\\] {
  width: 78px;
}
.w-\\[7px\\] {
  width: 7px;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[81\\%\\] {
  width: 81%;
}
.w-\\[82\\%\\] {
  width: 82%;
}
.w-\\[84px\\] {
  width: 84px;
}
.w-\\[85\\%\\] {
  width: 85%;
}
.w-\\[85px\\] {
  width: 85px;
}
.w-\\[86\\%\\] {
  width: 86%;
}
.w-\\[87\\%\\] {
  width: 87%;
}
.w-\\[88px\\] {
  width: 88px;
}
.w-\\[88vw\\] {
  width: 88vw;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[90vw\\] {
  width: 90vw;
}
.w-\\[91\\%\\] {
  width: 91%;
}
.w-\\[92px\\] {
  width: 92px;
}
.w-\\[92vw\\] {
  width: 92vw;
}
.w-\\[94\\.5\\%\\] {
  width: 94.5%;
}
.w-\\[95\\%\\] {
  width: 95%;
}
.w-\\[96\\%\\] {
  width: 96%;
}
.w-\\[96px\\] {
  width: 96px;
}
.w-\\[97\\%\\] {
  width: 97%;
}
.w-\\[98\\%\\] {
  width: 98%;
}
.w-\\[99\\%\\] {
  width: 99%;
}
.w-\\[calc\\(100\\%-19px\\)\\] {
  width: calc(100% - 19px);
}
.w-\\[full\\] {
  width: full;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[100\\%\\] {
  min-width: 100%;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[190px\\] {
  min-width: 190px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[30\\%\\] {
  min-width: 30%;
}
.min-w-\\[40\\%\\] {
  min-width: 40%;
}
.min-w-\\[500px\\] {
  min-width: 500px;
}
.min-w-\\[50px\\] {
  min-width: 50px;
}
.min-w-\\[526px\\] {
  min-width: 526px;
}
.min-w-\\[600px\\] {
  min-width: 600px;
}
.min-w-\\[70px\\] {
  min-width: 70px;
}
.min-w-\\[8\\%\\] {
  min-width: 8%;
}
.min-w-\\[80px\\] {
  min-width: 80px;
}
.min-w-\\[90px\\] {
  min-width: 90px;
}
.min-w-\\[91vw\\] {
  min-width: 91vw;
}
.min-w-full {
  min-width: 100%;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-40 {
  max-width: 10rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-56 {
  max-width: 14rem;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[110px\\] {
  max-width: 110px;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[130px\\] {
  max-width: 130px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[145px\\] {
  max-width: 145px;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[277px\\] {
  max-width: 277px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[375px\\] {
  max-width: 375px;
}
.max-w-\\[40\\%\\] {
  max-width: 40%;
}
.max-w-\\[450px\\] {
  max-width: 450px;
}
.max-w-\\[500px\\] {
  max-width: 500px;
}
.max-w-\\[540px\\] {
  max-width: 540px;
}
.max-w-\\[600px\\] {
  max-width: 600px;
}
.max-w-\\[60px\\] {
  max-width: 60px;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[90vw\\] {
  max-width: 90vw;
}
.max-w-\\[calc\\(100vw-170px\\)\\] {
  max-width: calc(100vw - 170px);
}
.max-w-fit {
  max-width: fit-content;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.basis-\\[10\\%\\] {
  flex-basis: 10%;
}
.basis-\\[20\\%\\] {
  flex-basis: 20%;
}
.basis-\\[35\\%\\] {
  flex-basis: 35%;
}
.table-auto {
  table-layout: auto;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-\\[0\\] {
  transform-origin: 0;
}
.origin-center {
  transform-origin: center;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2 {
  --tw-translate-x: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[415px\\] {
  --tw-translate-x: -415px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[420px\\] {
  --tw-translate-x: -420px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-0\\.5 {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2 {
  --tw-translate-y: -0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-3 {
  --tw-translate-y: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-5 {
  --tw-translate-y: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-10px\\] {
  --tw-translate-x: -10px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-120px\\] {
  --tw-translate-x: -120px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-20px\\] {
  --tw-translate-x: -20px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[0px\\] {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[10px\\] {
  --tw-translate-x: 10px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[18px\\] {
  --tw-translate-x: 18px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[24px\\] {
  --tw-translate-x: 24px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0\\.5 {
  --tw-translate-y: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2 {
  --tw-translate-y: 0.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4 {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-6px\\] {
  --tw-translate-y: -6px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-45 {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-135deg\\] {
  --tw-rotate: -135deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-45deg\\] {
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-50deg\\] {
  --tw-rotate: -50deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-skew-x-12 {
  --tw-skew-x: -12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-0 {
  --tw-scale-x: 0;
  --tw-scale-y: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.98\\] {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[2\\] {
  --tw-scale-x: 2;
  --tw-scale-y: 2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-none {
  transform: none;
}
.animate-\\[heart-bounce_0\\.5s_cubic-bezier\\(\\.7\\2c 0\\2c \\.3\\2c 1\\)\\] {
  animation: heart-bounce 0.5s cubic-bezier(.7,0,.3,1);
}
.animate-\\[zoomIn_0\\.3s_ease-out_forwards\\] {
  animation: zoomIn 0.3s ease-out forwards;
}
@keyframes edgeToCenterBounce {

  0% {
    transform: scale(0);
    opacity: 0;
  }

  60% {
    transform: scale(1.2);
    opacity: 1;
  }

  100% {
    transform: scale(1);
  }
}
.animate-edgeToCenterBounce {
  animation: edgeToCenterBounce 0.4s ease-out;
}
.animate-none {
  animation: none;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes slideUp {

  0% {
    transform: translateY(50%);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.animate-slideUp {
  animation: slideUp 0.7s ease-out;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-move {
  cursor: move;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-text {
  cursor: text;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.scroll-mt-\\[10px\\] {
  scroll-margin-top: 10px;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.appearance-none {
  appearance: none;
}
.grid-flow-row {
  grid-auto-flow: row;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.place-items-center {
  place-items: center;
}
.content-start {
  align-content: flex-start;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-evenly {
  justify-content: space-evenly;
}
.justify-items-center {
  justify-items: center;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-11 {
  gap: 2.75rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-40 {
  gap: 10rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[12px\\] {
  gap: 12px;
}
.gap-\\[1px\\] {
  gap: 1px;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[2px\\] {
  gap: 2px;
}
.gap-\\[2rem\\] {
  gap: 2rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-darkSilver > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(112 112 112 / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.justify-self-end {
  justify-self: end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-scroll {
  overflow: scroll;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-visible {
  overflow-x: visible;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.overflow-ellipsis {
  text-overflow: ellipsis;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.text-wrap {
  text-wrap: wrap;
}
.text-nowrap {
  text-wrap: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[0\\.125rem\\] {
  border-radius: 0.125rem;
}
.rounded-\\[0\\.5px\\] {
  border-radius: 0.5px;
}
.rounded-\\[10\\%\\] {
  border-radius: 10%;
}
.rounded-\\[100px\\] {
  border-radius: 100px;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[175px\\] {
  border-radius: 175px;
}
.rounded-\\[1px\\] {
  border-radius: 1px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[30px\\] {
  border-radius: 30px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[50\\%\\] {
  border-radius: 50%;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-\\[9px\\] {
  border-radius: 9px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-b-\\[10px\\] {
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
.rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-l-sm {
  border-top-left-radius: 0.125rem;
  border-bottom-left-radius: 0.125rem;
}
.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-\\[12px\\] {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.rounded-bl {
  border-bottom-left-radius: 0.25rem;
}
.rounded-bl-\\[50px\\] {
  border-bottom-left-radius: 50px;
}
.rounded-bl-\\[60px\\] {
  border-bottom-left-radius: 60px;
}
.rounded-bl-\\[80px\\] {
  border-bottom-left-radius: 80px;
}
.rounded-bl-md {
  border-bottom-left-radius: 0.375rem;
}
.rounded-br {
  border-bottom-right-radius: 0.25rem;
}
.rounded-br-md {
  border-bottom-right-radius: 0.375rem;
}
.rounded-tl {
  border-top-left-radius: 0.25rem;
}
.rounded-tl-\\[0\\.25rem\\] {
  border-top-left-radius: 0.25rem;
}
.rounded-tl-md {
  border-top-left-radius: 0.375rem;
}
.rounded-tr {
  border-top-right-radius: 0.25rem;
}
.rounded-tr-\\[20px\\] {
  border-top-right-radius: 20px;
}
.rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
.rounded-tr-md {
  border-top-right-radius: 0.375rem;
}
.\\!border-0 {
  border-width: 0px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-\\[0\\.5px\\] {
  border-width: 0.5px;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-\\[8px\\] {
  border-width: 8px;
}
.border-x {
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-b-\\[0\\.5px\\] {
  border-bottom-width: 0.5px;
}
.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}
.border-b-\\[2px\\] {
  border-bottom-width: 2px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-l-\\[15px\\] {
  border-left-width: 15px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-r-4 {
  border-right-width: 4px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-t-\\[0\\.5px\\] {
  border-top-width: 0.5px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-dotted {
  border-style: dotted;
}
.border-none {
  border-style: none;
}
.\\!border-errorColorTextBtn {
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 67 54 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#007BFF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 123 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#008CFF80\\] {
  border-color: #008CFF80;
}
.border-\\[\\#00c20f\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 194 15 / var(--tw-border-opacity, 1));
}
.border-\\[\\#0288D180\\] {
  border-color: #0288D180;
}
.border-\\[\\#03A9F480\\] {
  border-color: #03A9F480;
}
.border-\\[\\#0F903B\\] {
  --tw-border-opacity: 1;
  border-color: rgb(15 144 59 / var(--tw-border-opacity, 1));
}
.border-\\[\\#13DA5C\\] {
  --tw-border-opacity: 1;
  border-color: rgb(19 218 92 / var(--tw-border-opacity, 1));
}
.border-\\[\\#14243E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(20 36 62 / var(--tw-border-opacity, 1));
}
.border-\\[\\#142a4b\\] {
  --tw-border-opacity: 1;
  border-color: rgb(20 42 75 / var(--tw-border-opacity, 1));
}
.border-\\[\\#15CD5480\\] {
  border-color: #15CD5480;
}
.border-\\[\\#162e53\\] {
  --tw-border-opacity: 1;
  border-color: rgb(22 46 83 / var(--tw-border-opacity, 1));
}
.border-\\[\\#171d2c\\] {
  --tw-border-opacity: 1;
  border-color: rgb(23 29 44 / var(--tw-border-opacity, 1));
}
.border-\\[\\#193258\\] {
  --tw-border-opacity: 1;
  border-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1E2E46\\] {
  --tw-border-opacity: 1;
  border-color: rgb(30 46 70 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1E88E580\\] {
  border-color: #1E88E580;
}
.border-\\[\\#1e2b4a\\] {
  --tw-border-opacity: 1;
  border-color: rgb(30 43 74 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1f3a63\\] {
  --tw-border-opacity: 1;
  border-color: rgb(31 58 99 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1f81d1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(31 129 209 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2196F380\\] {
  border-color: #2196F380;
}
.border-\\[\\#2196F3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity, 1));
}
.border-\\[\\#233B59\\] {
  --tw-border-opacity: 1;
  border-color: rgb(35 59 89 / var(--tw-border-opacity, 1));
}
.border-\\[\\#23467A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(35 70 122 / var(--tw-border-opacity, 1));
}
.border-\\[\\#26323880\\] {
  border-color: #26323880;
}
.border-\\[\\#283851\\] {
  --tw-border-opacity: 1;
  border-color: rgb(40 56 81 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2C3E50\\] {
  --tw-border-opacity: 1;
  border-color: rgb(44 62 80 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2E7D3280\\] {
  border-color: #2E7D3280;
}
.border-\\[\\#2d3b5a\\] {
  --tw-border-opacity: 1;
  border-color: rgb(45 59 90 / var(--tw-border-opacity, 1));
}
.border-\\[\\#313b4c\\] {
  --tw-border-opacity: 1;
  border-color: rgb(49 59 76 / var(--tw-border-opacity, 1));
}
.border-\\[\\#37527e\\] {
  --tw-border-opacity: 1;
  border-color: rgb(55 82 126 / var(--tw-border-opacity, 1));
}
.border-\\[\\#388E3C80\\] {
  border-color: #388E3C80;
}
.border-\\[\\#388ECC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(56 142 204 / var(--tw-border-opacity, 1));
}
.border-\\[\\#434F63\\] {
  --tw-border-opacity: 1;
  border-color: rgb(67 79 99 / var(--tw-border-opacity, 1));
}
.border-\\[\\#434f63\\] {
  --tw-border-opacity: 1;
  border-color: rgb(67 79 99 / var(--tw-border-opacity, 1));
}
.border-\\[\\#455A6480\\] {
  border-color: #455A6480;
}
.border-\\[\\#4CAF5080\\] {
  border-color: #4CAF5080;
}
.border-\\[\\#4F20CF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(79 32 207 / var(--tw-border-opacity, 1));
}
.border-\\[\\#53ED88\\] {
  --tw-border-opacity: 1;
  border-color: rgb(83 237 136 / var(--tw-border-opacity, 1));
}
.border-\\[\\#607D8B80\\] {
  border-color: #607D8B80;
}
.border-\\[\\#673AB780\\] {
  border-color: #673AB780;
}
.border-\\[\\#6C757D\\] {
  --tw-border-opacity: 1;
  border-color: rgb(108 117 125 / var(--tw-border-opacity, 1));
}
.border-\\[\\#6D4C4180\\] {
  border-color: #6D4C4180;
}
.border-\\[\\#78869B\\] {
  --tw-border-opacity: 1;
  border-color: rgb(120 134 155 / var(--tw-border-opacity, 1));
}
.border-\\[\\#79554880\\] {
  border-color: #79554880;
}
.border-\\[\\#934204\\] {
  --tw-border-opacity: 1;
  border-color: rgb(147 66 4 / var(--tw-border-opacity, 1));
}
.border-\\[\\#938004\\] {
  --tw-border-opacity: 1;
  border-color: rgb(147 128 4 / var(--tw-border-opacity, 1));
}
.border-\\[\\#9E9E9E80\\] {
  border-color: #9E9E9E80;
}
.border-\\[\\#B20303\\] {
  --tw-border-opacity: 1;
  border-color: rgb(178 3 3 / var(--tw-border-opacity, 1));
}
.border-\\[\\#B94B8B\\] {
  --tw-border-opacity: 1;
  border-color: rgb(185 75 139 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BDBDBD80\\] {
  border-color: #BDBDBD80;
}
.border-\\[\\#BFCDDC80\\] {
  border-color: #BFCDDC80;
}
.border-\\[\\#C6282880\\] {
  border-color: #C6282880;
}
.border-\\[\\#D32F2F80\\] {
  border-color: #D32F2F80;
}
.border-\\[\\#E5393580\\] {
  border-color: #E5393580;
}
.border-\\[\\#F4433680\\] {
  border-color: #F4433680;
}
.border-\\[\\#F44336\\] {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity, 1));
}
.border-\\[\\#F57C0080\\] {
  border-color: #F57C0080;
}
.border-\\[\\#FF950080\\] {
  border-color: #FF950080;
}
.border-\\[\\#FF980080\\] {
  border-color: #FF980080;
}
.border-\\[\\#FFB000\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 176 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FFB30080\\] {
  border-color: #FFB30080;
}
.border-\\[\\#FFC10780\\] {
  border-color: #FFC10780;
}
.border-\\[\\#FFC107\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FFC61C\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 198 28 / var(--tw-border-opacity, 1));
}
.border-\\[\\#fff\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-\\[red\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 0 0 / var(--tw-border-opacity, 1));
}
.border-\\[rgb\\(25\\2c 50\\2c 88\\)\\] {
  --tw-border-opacity: 1;
  border-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-errorColorTextBtn {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-insideDiv {
  --tw-border-opacity: 1;
  border-color: rgb(9 24 47 / var(--tw-border-opacity, 1));
}
.border-lcontentUnderline {
  --tw-border-opacity: 1;
  border-color: rgb(159 239 4 / var(--tw-border-opacity, 1));
}
.border-lightSlateGray {
  --tw-border-opacity: 1;
  border-color: rgb(120 134 155 / var(--tw-border-opacity, 1));
}
.border-lsheenGreen {
  --tw-border-opacity: 1;
  border-color: rgb(0 195 16 / var(--tw-border-opacity, 1));
}
.border-lyankeesBlue {
  --tw-border-opacity: 1;
  border-color: rgb(248 251 255 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-secondaryHover {
  --tw-border-opacity: 1;
  border-color: rgb(43 88 155 / var(--tw-border-opacity, 1));
}
.border-sheenGreen {
  --tw-border-opacity: 1;
  border-color: rgb(0 195 16 / var(--tw-border-opacity, 1));
}
.border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.border-spaceCadet {
  --tw-border-opacity: 1;
  border-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
}
.border-springBud {
  --tw-border-opacity: 1;
  border-color: rgb(0 195 49 / var(--tw-border-opacity, 1));
}
.border-stone-600 {
  --tw-border-opacity: 1;
  border-color: rgb(87 83 78 / var(--tw-border-opacity, 1));
}
.border-sunsetOrange {
  --tw-border-opacity: 1;
  border-color: rgb(244 67 54 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.border-yankeesBlue {
  --tw-border-opacity: 1;
  border-color: rgb(20 36 62 / var(--tw-border-opacity, 1));
}
.border-x-lightSlateGray {
  --tw-border-opacity: 1;
  border-left-color: rgb(120 134 155 / var(--tw-border-opacity, 1));
  border-right-color: rgb(120 134 155 / var(--tw-border-opacity, 1));
}
.border-x-yankeesBlue {
  --tw-border-opacity: 1;
  border-left-color: rgb(20 36 62 / var(--tw-border-opacity, 1));
  border-right-color: rgb(20 36 62 / var(--tw-border-opacity, 1));
}
.border-y-spaceCadet {
  --tw-border-opacity: 1;
  border-top-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
  border-bottom-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#14294a\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(20 41 74 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#A7FC00\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(167 252 0 / var(--tw-border-opacity, 1));
}
.border-b-maastrichtBlue {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(6 17 35 / var(--tw-border-opacity, 1));
}
.border-b-secondaryHover {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(43 88 155 / var(--tw-border-opacity, 1));
}
.border-b-spaceCadet {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
}
.border-b-springBud {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(0 195 49 / var(--tw-border-opacity, 1));
}
.border-b-yankeesBlue {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(20 36 62 / var(--tw-border-opacity, 1));
}
.border-l-sheenGreen {
  --tw-border-opacity: 1;
  border-left-color: rgb(0 195 16 / var(--tw-border-opacity, 1));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-errorColorTextBtn {
  --tw-border-opacity: 1;
  border-top-color: rgb(244 67 54 / var(--tw-border-opacity, 1));
}
.border-t-lightSlateGray {
  --tw-border-opacity: 1;
  border-top-color: rgb(120 134 155 / var(--tw-border-opacity, 1));
}
.border-t-maastrichtBlue {
  --tw-border-opacity: 1;
  border-top-color: rgb(6 17 35 / var(--tw-border-opacity, 1));
}
.border-t-spaceCadet {
  --tw-border-opacity: 1;
  border-top-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
}
.border-t-springBud {
  --tw-border-opacity: 1;
  border-top-color: rgb(0 195 49 / var(--tw-border-opacity, 1));
}
.border-t-transparent {
  border-top-color: transparent;
}
.bg-\\[\\#\\#0F3350\\] {
  background-color: ##0F3350;
}
.bg-\\[\\#000000D9\\] {
  background-color: #000000D9;
}
.bg-\\[\\#000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#003336\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 51 54 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0075D2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 117 210 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#007BFF4D\\] {
  background-color: #007BFF4D;
}
.bg-\\[\\#0080FF33\\] {
  background-color: #0080FF33;
}
.bg-\\[\\#0095FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 149 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00B312\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 179 18 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00C31026\\] {
  background-color: #00C31026;
}
.bg-\\[\\#00C34E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 195 78 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00D12E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 209 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00D4A1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 212 161 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00EA13\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 234 19 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#01081B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(1 8 27 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#020716\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 7 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#021739\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 23 57 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0288D126\\] {
  background-color: #0288D126;
}
.bg-\\[\\#0288D1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(2 136 209 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#03A9F426\\] {
  background-color: #03A9F426;
}
.bg-\\[\\#03A9F4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#06366D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(6 54 109 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#081830\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(8 24 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#09182F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(9 24 47 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0C4784\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(12 71 132 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0C523D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(12 82 61 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0D1321\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(13 19 33 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0D162A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(13 22 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F3350\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 51 80 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0F903B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 144 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0b1e3c\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(11 30 60 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0e1c3f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 28 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#101c33\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(16 28 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#13DA5C4D\\] {
  background-color: #13DA5C4D;
}
.bg-\\[\\#14213d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 33 61 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#14243e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(20 36 62 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#15CD5433\\] {
  background-color: #15CD5433;
}
.bg-\\[\\#15CD54\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(21 205 84 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#162038\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 32 56 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#173b63\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(23 59 99 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#193258\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(25 50 88 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1A2640\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(26 38 64 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1B2A45\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(27 42 69 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E1A5F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 26 95 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E88E526\\] {
  background-color: #1E88E526;
}
.bg-\\[\\#1E88E5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 136 229 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1c2738\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 39 56 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1c2a4a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 42 74 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e2b4a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 43 74 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e2d45\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 45 69 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e2f48\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 47 72 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#213A5A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(33 58 90 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2196F31A\\] {
  background-color: #2196F31A;
}
.bg-\\[\\#2196F3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(33 150 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#23344e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 52 78 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#23467A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 70 122 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#26323826\\] {
  background-color: #26323826;
}
.bg-\\[\\#263238\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(38 50 56 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#273446\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(39 52 70 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2E7D3226\\] {
  background-color: #2E7D3226;
}
.bg-\\[\\#2E7D32\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(46 125 50 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#314665\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(49 70 101 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#334E68\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 78 104 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#337349\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 115 73 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3592ee\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(53 146 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#37474F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(55 71 79 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#388E3C26\\] {
  background-color: #388E3C26;
}
.bg-\\[\\#388E3C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(56 142 60 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3CC3DF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(60 195 223 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3a3b40\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(58 59 64 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3cc3df\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(60 195 223 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#434F6366\\] {
  background-color: #434F6366;
}
.bg-\\[\\#434F63\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(67 79 99 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#434f63\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(67 79 99 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#445f7d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(68 95 125 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#455A6426\\] {
  background-color: #455A6426;
}
.bg-\\[\\#455A64\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(69 90 100 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4CAF5026\\] {
  background-color: #4CAF5026;
}
.bg-\\[\\#4CAF50\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4F20CF4D\\] {
  background-color: #4F20CF4D;
}
.bg-\\[\\#514721\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(81 71 33 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#58975e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(88 151 94 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#5b5bff93\\] {
  background-color: #5b5bff93;
}
.bg-\\[\\#607D8B26\\] {
  background-color: #607D8B26;
}
.bg-\\[\\#607D8B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#61FF6E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(97 255 110 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#673AB726\\] {
  background-color: #673AB726;
}
.bg-\\[\\#673AB7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6D4C4126\\] {
  background-color: #6D4C4126;
}
.bg-\\[\\#6D4C41\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(109 76 65 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7350FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(115 80 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#79554826\\] {
  background-color: #79554826;
}
.bg-\\[\\#795548\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7DBCEE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(125 188 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8979FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(137 121 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8AE850\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(138 232 80 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#9E9E9E1F\\] {
  background-color: #9E9E9E1F;
}
.bg-\\[\\#9E9E9E26\\] {
  background-color: #9E9E9E26;
}
.bg-\\[\\#9E9E9E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#BDBDBD26\\] {
  background-color: #BDBDBD26;
}
.bg-\\[\\#BDBDBD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(189 189 189 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#BEC6D299\\] {
  background-color: #BEC6D299;
}
.bg-\\[\\#BFCDDC33\\] {
  background-color: #BFCDDC33;
}
.bg-\\[\\#BFCDDC4D\\] {
  background-color: #BFCDDC4D;
}
.bg-\\[\\#C6282826\\] {
  background-color: #C6282826;
}
.bg-\\[\\#C62828\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(198 40 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C9FFB6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(201 255 182 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D32F2F26\\] {
  background-color: #D32F2F26;
}
.bg-\\[\\#D32F2F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(211 47 47 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#DDBC0E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(221 188 14 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E25959\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(226 89 89 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E5393526\\] {
  background-color: #E5393526;
}
.bg-\\[\\#E53935\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(229 57 53 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E68900\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(230 137 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E7E7E7\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 231 231 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E93B3B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 59 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ECD732\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(236 215 50 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EDF0F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 240 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EE8432\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 132 50 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EF4444\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F1F1F133\\] {
  background-color: #F1F1F133;
}
.bg-\\[\\#F443361A\\] {
  background-color: #F443361A;
}
.bg-\\[\\#F4433666\\] {
  background-color: #F4433666;
}
.bg-\\[\\#F4433680\\] {
  background-color: #F4433680;
}
.bg-\\[\\#F57C0026\\] {
  background-color: #F57C0026;
}
.bg-\\[\\#F57C00\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 124 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF3B2C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 59 44 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF840033\\] {
  background-color: #FF840033;
}
.bg-\\[\\#FF928A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 146 138 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF980033\\] {
  background-color: #FF980033;
}
.bg-\\[\\#FF9800\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 152 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFAE00\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 174 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFB30026\\] {
  background-color: #FFB30026;
}
.bg-\\[\\#FFB300\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 179 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFC10726\\] {
  background-color: #FFC10726;
}
.bg-\\[\\#FFC10799\\] {
  background-color: #FFC10799;
}
.bg-\\[\\#FFC107\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFCC80\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 204 128 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f2f2f2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f9c0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(244 249 192 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ff928a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 146 138 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffff0f\\] {
  background-color: #ffffff0f;
}
.bg-\\[\\#ffffff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[black\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[transparent\\] {
  background-color: transparent;
}
.bg-\\[yankeesBlue\\] {
  background-color: yankeesBlue;
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/90 {
  background-color: rgb(0 0 0 / 0.9);
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-cardTitleBg {
  --tw-bg-opacity: 1;
  background-color: rgb(4 25 61 / var(--tw-bg-opacity, 1));
}
.bg-contentUnderline {
  --tw-bg-opacity: 1;
  background-color: rgb(159 239 4 / var(--tw-bg-opacity, 1));
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-errorColorTextBtn {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-400\\/10 {
  background-color: rgb(156 163 175 / 0.1);
}
.bg-gray-400\\/20 {
  background-color: rgb(156 163 175 / 0.2);
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-800\\/50 {
  background-color: rgb(31 41 55 / 0.5);
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity, 1));
}
.bg-insideDiv {
  --tw-bg-opacity: 1;
  background-color: rgb(9 24 47 / var(--tw-bg-opacity, 1));
}
.bg-lcontentUnderline {
  --tw-bg-opacity: 1;
  background-color: rgb(159 239 4 / var(--tw-bg-opacity, 1));
}
.bg-lightGrayShade {
  --tw-bg-opacity: 1;
  background-color: rgb(217 217 217 / var(--tw-bg-opacity, 1));
}
.bg-lightSlateGray {
  --tw-bg-opacity: 1;
  background-color: rgb(120 134 155 / var(--tw-bg-opacity, 1));
}
.bg-lightSlateGray\\/30 {
  background-color: rgb(120 134 155 / 0.3);
}
.bg-maastrichtBlue {
  --tw-bg-opacity: 1;
  background-color: rgb(6 17 35 / var(--tw-bg-opacity, 1));
}
.bg-malachite {
  --tw-bg-opacity: 1;
  background-color: rgb(30 215 96 / var(--tw-bg-opacity, 1));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-platinum {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 228 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-secondaryHover {
  --tw-bg-opacity: 1;
  background-color: rgb(43 88 155 / var(--tw-bg-opacity, 1));
}
.bg-sheenGreen {
  --tw-bg-opacity: 1;
  background-color: rgb(0 195 16 / var(--tw-bg-opacity, 1));
}
.bg-sky-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity, 1));
}
.bg-slate-500\\/20 {
  background-color: rgb(100 116 139 / 0.2);
}
.bg-slate-500\\/30 {
  background-color: rgb(100 116 139 / 0.3);
}
.bg-slate-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}
.bg-spaceCadet {
  --tw-bg-opacity: 1;
  background-color: rgb(25 50 88 / var(--tw-bg-opacity, 1));
}
.bg-spaceCadet\\/40 {
  background-color: rgb(25 50 88 / 0.4);
}
.bg-spanishGray {
  --tw-bg-opacity: 1;
  background-color: rgb(158 158 158 / var(--tw-bg-opacity, 1));
}
.bg-springBud {
  --tw-bg-opacity: 1;
  background-color: rgb(0 195 49 / var(--tw-bg-opacity, 1));
}
.bg-springBud\\/20 {
  background-color: rgb(0 195 49 / 0.2);
}
.bg-statusType {
  --tw-bg-opacity: 1;
  background-color: rgb(5 42 92 / var(--tw-bg-opacity, 1));
}
.bg-sunsetOrange {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity, 1));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-yankeesBlue {
  --tw-bg-opacity: 1;
  background-color: rgb(20 36 62 / var(--tw-bg-opacity, 1));
}
.bg-yankeesBlue\\/20 {
  background-color: rgb(20 36 62 / 0.2);
}
.bg-yellow {
  --tw-bg-opacity: 1;
  background-color: rgb(255 160 0 / var(--tw-bg-opacity, 1));
}
.bg-zinc-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity, 1));
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.bg-\\[linear-gradient\\(90deg\\2c \\#4CDBFF_0\\%\\2c \\#14243E_22\\.12\\%\\2c \\#14243E_50\\%\\2c \\#14243E_81\\.73\\%\\2c \\#4CDBFF_100\\%\\)\\] {
  background-image: linear-gradient(90deg,#4CDBFF 0%,#14243E 22.12%,#14243E 50%,#14243E 81.73%,#4CDBFF 100%);
}
.bg-\\[url\\(\\'\\.\\/images\\/dotted_bg\\.svg\\'\\)\\] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#09182F\\] {
  --tw-gradient-from: #09182F var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(9 24 47 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0A1832\\] {
  --tw-gradient-from: #0A1832 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(10 24 50 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#113161\\] {
  --tw-gradient-from: #113161 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 49 97 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#14243E\\] {
  --tw-gradient-from: #14243E var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 36 62 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#172B4B\\] {
  --tw-gradient-from: #172B4B var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(23 43 75 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1D4A8F\\] {
  --tw-gradient-from: #1D4A8F var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 74 143 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1f81d1\\] {
  --tw-gradient-from: #1f81d1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(31 129 209 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#2194f0\\] {
  --tw-gradient-from: #2194f0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(33 148 240 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#25883C\\] {
  --tw-gradient-from: #25883C var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 136 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#FFA000\\] {
  --tw-gradient-from: #FFA000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 160 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black {
  --tw-gradient-from: #000 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500 {
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-insideDiv {
  --tw-gradient-from: #09182f var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(9 24 47 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white\\/20 {
  --tw-gradient-from: rgb(255 255 255 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-0\\% {
  --tw-gradient-from-position: 0%;
}
.via-\\[\\#102650\\] {
  --tw-gradient-to: rgb(16 38 80 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #102650 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#111d2e\\] {
  --tw-gradient-to: rgb(17 29 46 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #111d2e var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#172B4B\\] {
  --tw-gradient-to: rgb(23 43 75 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #172B4B var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#193258\\] {
  --tw-gradient-to: rgb(25 50 88 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #193258 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#FFD467\\] {
  --tw-gradient-to: rgb(255 212 103 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FFD467 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-maastrichtBlue {
  --tw-gradient-to: rgb(6 17 35 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #061123 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-spaceCadet {
  --tw-gradient-to: rgb(25 50 88 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #193258 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-yankeesBlue {
  --tw-gradient-to: rgb(20 36 62 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #14243e var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#09182F\\] {
  --tw-gradient-to: #09182F var(--tw-gradient-to-position);
}
.to-\\[\\#0A1832\\] {
  --tw-gradient-to: #0A1832 var(--tw-gradient-to-position);
}
.to-\\[\\#121e32\\] {
  --tw-gradient-to: #121e32 var(--tw-gradient-to-position);
}
.to-\\[\\#14243E\\] {
  --tw-gradient-to: #14243E var(--tw-gradient-to-position);
}
.to-\\[\\#193258\\] {
  --tw-gradient-to: #193258 var(--tw-gradient-to-position);
}
.to-\\[\\#193259\\] {
  --tw-gradient-to: #193259 var(--tw-gradient-to-position);
}
.to-\\[\\#4CFF4F\\] {
  --tw-gradient-to: #4CFF4F var(--tw-gradient-to-position);
}
.to-\\[\\#FF2407\\] {
  --tw-gradient-to: #FF2407 var(--tw-gradient-to-position);
}
.to-blue-500 {
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-insideDiv {
  --tw-gradient-to: #09182f var(--tw-gradient-to-position);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-100\\% {
  --tw-gradient-to-position: 100%;
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.fill-\\[rgb\\(107\\2c 114\\2c 128\\)\\] {
  fill: rgb(107,114,128);
}
.fill-current {
  fill: currentColor;
}
.fill-gray-300 {
  fill: #d1d5db;
}
.fill-lightSlateGray {
  fill: #78869b;
}
.fill-springBud {
  fill: #00C331;
}
.stroke-springBud {
  stroke: #00C331;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[0px\\] {
  padding: 0px;
}
.p-\\[1\\.5px\\] {
  padding: 1.5px;
}
.p-\\[10px\\] {
  padding: 10px;
}
.p-\\[12px\\] {
  padding: 12px;
}
.p-\\[1px\\] {
  padding: 1px;
}
.p-\\[2px\\] {
  padding: 2px;
}
.p-\\[3\\.2px\\] {
  padding: 3.2px;
}
.p-\\[4px\\] {
  padding: 4px;
}
.p-\\[5px\\] {
  padding: 5px;
}
.p-\\[7px\\] {
  padding: 7px;
}
.p-\\[8px\\] {
  padding: 8px;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-11 {
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-9 {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[24px\\] {
  padding-left: 24px;
  padding-right: 24px;
}
.px-\\[3px\\] {
  padding-left: 3px;
  padding-right: 3px;
}
.px-\\[50px\\] {
  padding-left: 50px;
  padding-right: 50px;
}
.px-\\[8px\\] {
  padding-left: 8px;
  padding-right: 8px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-9 {
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[6\\.5px\\] {
  padding-top: 6.5px;
  padding-bottom: 6.5px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[0px\\] {
  padding-bottom: 0px;
}
.pb-\\[10px\\] {
  padding-bottom: 10px;
}
.pb-\\[60px\\] {
  padding-bottom: 60px;
}
.pb-\\[8px\\] {
  padding-bottom: 8px;
}
.pe-10 {
  padding-inline-end: 2.5rem;
}
.pe-2 {
  padding-inline-end: 0.5rem;
}
.pe-3 {
  padding-inline-end: 0.75rem;
}
.pe-4 {
  padding-inline-end: 1rem;
}
.pe-6 {
  padding-inline-end: 1.5rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-0\\.5 {
  padding-left: 0.125rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-1\\.5 {
  padding-left: 0.375rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-\\[12px\\] {
  padding-left: 12px;
}
.pl-\\[19px\\] {
  padding-left: 19px;
}
.pl-\\[25px\\] {
  padding-left: 25px;
}
.pl-\\[30px\\] {
  padding-left: 30px;
}
.pl-\\[35px\\] {
  padding-left: 35px;
}
.pl-\\[40px\\] {
  padding-left: 40px;
}
.pl-\\[8\\%\\] {
  padding-left: 8%;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-16 {
  padding-right: 4rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.pr-\\[10px\\] {
  padding-right: 10px;
}
.pr-\\[16px\\] {
  padding-right: 16px;
}
.pr-\\[30px\\] {
  padding-right: 30px;
}
.pr-\\[35px\\] {
  padding-right: 35px;
}
.pr-\\[5px\\] {
  padding-right: 5px;
}
.pr-\\[8\\%\\] {
  padding-right: 8%;
}
.ps-0\\.5 {
  padding-inline-start: 0.125rem;
}
.ps-1 {
  padding-inline-start: 0.25rem;
}
.ps-10 {
  padding-inline-start: 2.5rem;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.ps-2\\.5 {
  padding-inline-start: 0.625rem;
}
.ps-3 {
  padding-inline-start: 0.75rem;
}
.ps-3\\.5 {
  padding-inline-start: 0.875rem;
}
.ps-4 {
  padding-inline-start: 1rem;
}
.ps-8 {
  padding-inline-start: 2rem;
}
.ps-\\[10px\\] {
  padding-inline-start: 10px;
}
.ps-\\[15px\\] {
  padding-inline-start: 15px;
}
.ps-\\[20px\\] {
  padding-inline-start: 20px;
}
.ps-\\[25px\\] {
  padding-inline-start: 25px;
}
.ps-\\[30px\\] {
  padding-inline-start: 30px;
}
.ps-\\[35px\\] {
  padding-inline-start: 35px;
}
.ps-\\[45px\\] {
  padding-inline-start: 45px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-3\\.5 {
  padding-top: 0.875rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[30px\\] {
  padding-top: 30px;
}
.pt-\\[50px\\] {
  padding-top: 50px;
}
.pt-\\[55px\\] {
  padding-top: 55px;
}
.pt-\\[8px\\] {
  padding-top: 8px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.align-middle {
  vertical-align: middle;
}
.font-Inter {
  font-family: Inter;
}
.font-\\[AudiowideRegular\\] {
  font-family: AudiowideRegular;
}
.font-\\[Digital7\\] {
  font-family: Digital7;
}
.font-\\[Gebes\\] {
  font-family: Gebes;
}
.font-\\[Inter\\] {
  font-family: Inter;
}
.font-\\[antonsc\\] {
  font-family: antonsc;
}
.font-\\[boxigen\\] {
  font-family: boxigen;
}
.font-\\[goodtime\\] {
  font-family: goodtime;
}
.font-\\[jaro\\] {
  font-family: jaro;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[0\\.65rem\\] {
  font-size: 0.65rem;
}
.text-\\[0\\.75rem\\] {
  font-size: 0.75rem;
}
.text-\\[0\\.7rem\\] {
  font-size: 0.7rem;
}
.text-\\[0\\.8rem\\] {
  font-size: 0.8rem;
}
.text-\\[0\\.9rem\\] {
  font-size: 0.9rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11\\.74px\\] {
  font-size: 11.74px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[12px\\]\\/4 {
  font-size: 12px;
  line-height: 1rem;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[25px\\] {
  font-size: 25px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[27px\\] {
  font-size: 27px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-\\[2rem\\] {
  font-size: 2rem;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[36px\\] {
  font-size: 36px;
}
.text-\\[38px\\] {
  font-size: 38px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-\\[44px\\] {
  font-size: 44px;
}
.text-\\[48px\\] {
  font-size: 48px;
}
.text-\\[50px\\] {
  font-size: 50px;
}
.text-\\[54px\\] {
  font-size: 54px;
}
.text-\\[70px\\] {
  font-size: 70px;
}
.text-\\[8px\\] {
  font-size: 8px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[400\\] {
  font-weight: 400;
}
.font-\\[500\\] {
  font-weight: 500;
}
.font-\\[500px\\] {
  font-weight: 500px;
}
.font-\\[600\\] {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.font-thin {
  font-weight: 100;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-\\[16px\\] {
  line-height: 16px;
}
.leading-\\[40px\\] {
  line-height: 40px;
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0095FF\\] {
  --tw-text-opacity: 1;
  color: rgb(0 149 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00C331\\] {
  --tw-text-opacity: 1;
  color: rgb(0 195 49 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00c20f\\] {
  --tw-text-opacity: 1;
  color: rgb(0 194 15 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0288D1\\] {
  --tw-text-opacity: 1;
  color: rgb(2 136 209 / var(--tw-text-opacity, 1));
}
.text-\\[\\#03A9F4\\] {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity, 1));
}
.text-\\[\\#09182F\\] {
  --tw-text-opacity: 1;
  color: rgb(9 24 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#12A645\\] {
  --tw-text-opacity: 1;
  color: rgb(18 166 69 / var(--tw-text-opacity, 1));
}
.text-\\[\\#14243E\\] {
  --tw-text-opacity: 1;
  color: rgb(20 36 62 / var(--tw-text-opacity, 1));
}
.text-\\[\\#14243e\\] {
  --tw-text-opacity: 1;
  color: rgb(20 36 62 / var(--tw-text-opacity, 1));
}
.text-\\[\\#15CD54\\] {
  --tw-text-opacity: 1;
  color: rgb(21 205 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#193258\\] {
  --tw-text-opacity: 1;
  color: rgb(25 50 88 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1E88E5\\] {
  --tw-text-opacity: 1;
  color: rgb(30 136 229 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2196F3\\] {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity, 1));
}
.text-\\[\\#263238\\] {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2B589B\\] {
  --tw-text-opacity: 1;
  color: rgb(43 88 155 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2E7D32\\] {
  --tw-text-opacity: 1;
  color: rgb(46 125 50 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2ECC71\\] {
  --tw-text-opacity: 1;
  color: rgb(46 204 113 / var(--tw-text-opacity, 1));
}
.text-\\[\\#386890\\] {
  --tw-text-opacity: 1;
  color: rgb(56 104 144 / var(--tw-text-opacity, 1));
}
.text-\\[\\#388E3C\\] {
  --tw-text-opacity: 1;
  color: rgb(56 142 60 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3FFE69\\] {
  --tw-text-opacity: 1;
  color: rgb(63 254 105 / var(--tw-text-opacity, 1));
}
.text-\\[\\#434F63\\] {
  --tw-text-opacity: 1;
  color: rgb(67 79 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#437DFF\\] {
  --tw-text-opacity: 1;
  color: rgb(67 125 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#455A64\\] {
  --tw-text-opacity: 1;
  color: rgb(69 90 100 / var(--tw-text-opacity, 1));
}
.text-\\[\\#46F5F5\\] {
  --tw-text-opacity: 1;
  color: rgb(70 245 245 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4CAF50\\] {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5B84C1\\] {
  --tw-text-opacity: 1;
  color: rgb(91 132 193 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5B9DFF\\] {
  --tw-text-opacity: 1;
  color: rgb(91 157 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#607D8B\\] {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity, 1));
}
.text-\\[\\#673AB7\\] {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6A9593\\] {
  --tw-text-opacity: 1;
  color: rgb(106 149 147 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6D4C41\\] {
  --tw-text-opacity: 1;
  color: rgb(109 76 65 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6E41DF\\] {
  --tw-text-opacity: 1;
  color: rgb(110 65 223 / var(--tw-text-opacity, 1));
}
.text-\\[\\#748196\\] {
  --tw-text-opacity: 1;
  color: rgb(116 129 150 / var(--tw-text-opacity, 1));
}
.text-\\[\\#795548\\] {
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity, 1));
}
.text-\\[\\#87cefa\\] {
  --tw-text-opacity: 1;
  color: rgb(135 206 250 / var(--tw-text-opacity, 1));
}
.text-\\[\\#89E863\\] {
  --tw-text-opacity: 1;
  color: rgb(137 232 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9BA8C1\\] {
  --tw-text-opacity: 1;
  color: rgb(155 168 193 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9E9E9E\\] {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9fef07\\] {
  --tw-text-opacity: 1;
  color: rgb(159 239 7 / var(--tw-text-opacity, 1));
}
.text-\\[\\#BDBDBD\\] {
  --tw-text-opacity: 1;
  color: rgb(189 189 189 / var(--tw-text-opacity, 1));
}
.text-\\[\\#BF360C\\] {
  --tw-text-opacity: 1;
  color: rgb(191 54 12 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C1744A\\] {
  --tw-text-opacity: 1;
  color: rgb(193 116 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C62828\\] {
  --tw-text-opacity: 1;
  color: rgb(198 40 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#CD2F23\\] {
  --tw-text-opacity: 1;
  color: rgb(205 47 35 / var(--tw-text-opacity, 1));
}
.text-\\[\\#CECECE\\] {
  --tw-text-opacity: 1;
  color: rgb(206 206 206 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D32F2F\\] {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E18DFF\\] {
  --tw-text-opacity: 1;
  color: rgb(225 141 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E28800\\] {
  --tw-text-opacity: 1;
  color: rgb(226 136 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E53935\\] {
  --tw-text-opacity: 1;
  color: rgb(229 57 53 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F4433680\\] {
  color: #F4433680;
}
.text-\\[\\#F44336\\] {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F4D161\\] {
  --tw-text-opacity: 1;
  color: rgb(244 209 97 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F57C00\\] {
  --tw-text-opacity: 1;
  color: rgb(245 124 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F7F8FA\\] {
  --tw-text-opacity: 1;
  color: rgb(247 248 250 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FEE03F\\] {
  --tw-text-opacity: 1;
  color: rgb(254 224 63 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF0000\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF3B2C\\] {
  --tw-text-opacity: 1;
  color: rgb(255 59 44 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF9500\\] {
  --tw-text-opacity: 1;
  color: rgb(255 149 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF9800\\] {
  --tw-text-opacity: 1;
  color: rgb(255 152 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFB300\\] {
  --tw-text-opacity: 1;
  color: rgb(255 179 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFC107\\] {
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFDF0\\] {
  --tw-text-opacity: 1;
  color: rgb(255 253 240 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFFFFCC\\] {
  color: #FFFFFFCC;
}
.text-\\[\\#FFFFFF\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f34336\\] {
  --tw-text-opacity: 1;
  color: rgb(243 67 54 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ffffff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[12\\] {
  color: 12;
}
.text-\\[gray\\] {
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity, 1));
}
.text-\\[green\\] {
  --tw-text-opacity: 1;
  color: rgb(0 128 0 / var(--tw-text-opacity, 1));
}
.text-\\[red\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[yellow\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 0 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-ckblue {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity, 1));
}
.text-errorColorTextBtn {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-green {
  --tw-text-opacity: 1;
  color: rgb(76 175 80 / var(--tw-text-opacity, 1));
}
.text-lcontentUnderline {
  --tw-text-opacity: 1;
  color: rgb(159 239 4 / var(--tw-text-opacity, 1));
}
.text-lightGrayShade {
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity, 1));
}
.text-lightSlateGray {
  --tw-text-opacity: 1;
  color: rgb(120 134 155 / var(--tw-text-opacity, 1));
}
.text-llightSlateGray {
  --tw-text-opacity: 1;
  color: rgb(62 81 110 / var(--tw-text-opacity, 1));
}
.text-lyankeesBlue {
  --tw-text-opacity: 1;
  color: rgb(248 251 255 / var(--tw-text-opacity, 1));
}
.text-maastrichtBlue {
  --tw-text-opacity: 1;
  color: rgb(6 17 35 / var(--tw-text-opacity, 1));
}
.text-platinum {
  --tw-text-opacity: 1;
  color: rgb(228 228 228 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-royalGreen {
  --tw-text-opacity: 1;
  color: rgb(16 101 15 / var(--tw-text-opacity, 1));
}
.text-sheenGreen {
  --tw-text-opacity: 1;
  color: rgb(0 195 16 / var(--tw-text-opacity, 1));
}
.text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-spaceCadet {
  --tw-text-opacity: 1;
  color: rgb(25 50 88 / var(--tw-text-opacity, 1));
}
.text-spanishGray {
  --tw-text-opacity: 1;
  color: rgb(158 158 158 / var(--tw-text-opacity, 1));
}
.text-springBud {
  --tw-text-opacity: 1;
  color: rgb(0 195 49 / var(--tw-text-opacity, 1));
}
.text-sunsetOrange {
  --tw-text-opacity: 1;
  color: rgb(244 67 54 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/60 {
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yankeesBlue {
  --tw-text-opacity: 1;
  color: rgb(20 36 62 / var(--tw-text-opacity, 1));
}
.text-yellow {
  --tw-text-opacity: 1;
  color: rgb(255 160 0 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.overline {
  text-decoration-line: overline;
}
.placeholder-black::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(0 0 0 / var(--tw-placeholder-opacity, 1));
}
.placeholder-lightSlateGray::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(120 134 155 / var(--tw-placeholder-opacity, 1));
}
.placeholder-white::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(255 255 255 / var(--tw-placeholder-opacity, 1));
}
.accent-blue-500 {
  accent-color: #3b82f6;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-45 {
  opacity: 0.45;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.opacity-\\[0\\.5\\] {
  opacity: 0.5;
}
.opacity-\\[0\\.6\\] {
  opacity: 0.6;
}
.opacity-\\[0\\.8\\] {
  opacity: 0.8;
}
.opacity-\\[70\\%\\] {
  opacity: 70%;
}
.bg-blend-difference {
  background-blend-mode: difference;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-10px_0_20px_-5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: -10px 0 20px -5px rgba(0,0,0,0.5);
  --tw-shadow-colored: -10px 0 20px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_30px_\\#061123\\] {
  --tw-shadow: 0 0 0 30px #061123;
  --tw-shadow-colored: 0 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_40px_transparent\\] {
  --tw-shadow: 0 0 0 40px transparent;
  --tw-shadow-colored: 0 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_12px_rgba\\(74\\2c 100\\2c 255\\2c 1\\)\\] {
  --tw-shadow: 0 2px 12px rgba(74,100,255,1);
  --tw-shadow-colored: 0 2px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[10px_0_20px_-5px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
  --tw-shadow: 10px 0 20px -5px rgba(0,0,0,0.5);
  --tw-shadow-colored: 10px 0 20px -5px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-black {
  --tw-shadow-color: #000;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/50 {
  --tw-shadow-color: rgb(0 0 0 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-\\[\\#53ED88\\] {
  outline-color: #53ED88;
}
.outline-yankeesBlue {
  outline-color: #14243e;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale {
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia {
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c box-shadow\\] {
  transition-property: color,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[height\\] {
  transition-property: height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-none {
  transition-property: none;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-0 {
  transition-delay: 0s;
}
.delay-200 {
  transition-delay: 200ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 0.5s;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-\\[300ms\\] {
  transition-duration: 300ms;
}
.ease-\\[cubic-bezier\\(\\.7\\2c 0\\2c \\.3\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(.7,0,.3,1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
@keyframes slide-in {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(0);
    }
  }
.animate-slide-in {
    animation: slide-in 0.7s ease-out forwards;
  }
@keyframes pulseSlow {
    0%,
    100% {
      transform: scale(0.8);
      opacity: 0.6;
    }

    50% {
      transform: scale(1.2);
      opacity: 1;
    }
  }
.animate-pulse-slow {
    animation: pulseSlow 1.2s infinite ease-in-out;
  }
.delay-0 {
    animation-delay: 0ms;
  }
.delay-200 {
    animation-delay: 200ms;
  }
.delay-400 {
    animation-delay: 400ms;
  }
.delay-600 {
    animation-delay: 600ms;
  }

* > * {
  font-family: "Inter", sans-serif;
}

@font-face {
  font-family: Gebes;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

@font-face {
  font-family: AudiowideRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

@font-face {
  font-family: BebasNeue;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

@font-face {
  font-family: goodtime;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@font-face {
  font-family: Digital7;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

@font-face {
  font-family: bartomes;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

@font-face {
  font-family: antonsc;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

@font-face {
  font-family: jaro;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

@font-face {
  font-family: boxigen;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

/* html {
  height: 100%;
} */
body {
  overflow: hidden !important;
}

.light {
  min-height: 100vh;
  display: flex;
  /* background: linear-gradient(45deg, #03184f 0%, #010000 100%); */
  background-color: #020716;
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: white !important;
}

/* .dark .ReactTags__selected, */
.dark .css-2zzet4-control,
.dark .css-1hd0s6e-control,
.dark .css-4byitl-menu {
  background: #dde2e7 !important;
}

.dark {
  color: black !important;
}

.dark h1 {
  color: #ffffff !important;
}

.dark {
  min-height: 100vh;
  display: flex;
  background: #f1f2f7;
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: white;
}

#root {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}

.App {
  width: 100%;
  height: 100vh;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

input,
textarea {
  padding-left: 10px;
}

.rti--container {
  /* background: transparent !important; */
  background: transparent;
  border: 1px solid #14243e !important;
  border-radius: 2px !important;
  padding: 5px !important;
  min-height: 40px !important;
}

.rti--tag {
  color: #fff !important;
  background-color: #14243e !important;
}

.rti--input {
  /* background: transparent !important; */
  background: transparent;
  font-size: small;
}

input[type="checkbox"] {
  background-color: transparent;
  accent-color: #00c310;
  border: 1px solid #00c310;
  border-radius: 2px;
}

input[type="checkbox"]:not(:checked) {
  background-color: transparent;
}

/* dark */
/* .dark .toastui-editor {
  background: #dde2e7;
} */

.dark .toastui-editor-contents blockquote,
.dark .toastui-editor-contents ol li,
.dark .toastui-editor-contents ul li {
  color: #ffffff !important;
}

.dark .ProseMirror p,
.dark .ProseMirror h1,
.dark .ProseMirror h2,
.dark .ProseMirror h3,
.dark .ProseMirror h4,
.dark .ProseMirror h5,
.dark .ProseMirror h6 {
  color: #000 !important;
  /* background: #dde2e7 !important; */
}

/* .dark .toastui-editor {
  color: #fff !important;
  background: #dde2e7 !important;
} */

.dark .toastui-editor-toolbar-icons::after {
  font-weight: bold;
  font-size: 12px;
  color: black;
  font-family: "Font Awesome 5 Free";
}

.dark .toastui-editor-defaultUI-toolbar {
  /* background: #dde2e7 !important; */
  border: 0px !important;
  /* border-radius: 10px !important; */
}

.dark .toastui-editor-md-tab-container {
  background: #dde2e7 !important;
}

.dark .toastui-editor-toolbar-divider {
  display: none !important;
}

.dark .toastui-editor-defaultUI-toolbar {
  border: 1px solid #bec8d5 !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-left: 5px !important;
}

.toastui-editor-defaultUI-toolbar {
  border: 1px solid #193258 !important;
}

.dark button[aria-label="F"] {
  color: #000 !important;
  font-weight: bold;
  height: 20px !important;
  width: 20px !important;
  font-size: 12px !important;
}

.dark .apexcharts-legend-text {
  color: black !important;
}

.apexcharts-legend {
  max-height: 340px !important;
  overflow-y: auto !important;
}

/* light */
.light .toastui-editor {
  background: #14243e;
}

/* makes scrolling buttery smooth */
.scroll-smooth {
  scroll-behavior: smooth;
}

/* safari/iOS momentum scroll */
.momentum-scroll {
  -webkit-overflow-scrolling: touch;
}

.no-click {
  pointer-events: none;
  opacity: 1 !important;
}

.size-input {
  display: none !important;
}

.light .toastui-editor-contents blockquote,
.light .toastui-editor-contents ol li,
.light .toastui-editor-contents ul li {
  color: #ffffff !important;
}

.light .ProseMirror p,
.light .ProseMirror h1,
.light .ProseMirror h2,
.light .ProseMirror h3,
.light .ProseMirror h4,
.light .ProseMirror h5,
.light .ProseMirror h6 {
  color: #fff !important;
  /* background: #14243e !important; */
}

.light .toastui-editor {
  color: #fff !important;
  /* background: #14243e !important; */
}

.light .toastui-editor-defaultUI-toolbar {
  background: #09182f !important;
  border: 0px !important;
}

.light .toastui-editor-toolbar-icons {
  /* background: transparent !important; */
  background: transparent;
}

.toastui-editor-toolbar-icons {
  height: 20px !important;
  width: 20px !important;
}

.light .toastui-editor-md-tab-container {
  background: #bec8d5 !important;
}

.light .toastui-editor-toolbar-icons::after {
  font-weight: bold;
  font-size: 12px;
  color: white;
  font-family: "Font Awesome 5 Free";
}

.toastui-editor-toolbar-group .heading::after {
  content: "H";
}

.toastui-editor-toolbar-group .bold::after {
  content: "B";
}

.toastui-editor-toolbar-group .italic::after {
  content: "I";
}

.color::after {
  content: "A";
}

.toastui-editor-toolbar-divider {
  display: none !important;
}

.light .toastui-editor-defaultUI-toolbar {
  border: 1px solid #193258 !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  padding-left: 5px !important;
}

.light button[aria-label="F"] {
  color: #fff !important;
  font-weight: bold;
  height: 20px !important;
  width: 20px !important;
  font-size: 12px !important;
}

.custom-button::after {
  content: "F";
}

.strike::after {
  content: "S";
  text-decoration: line-through;
}

.hrline::after {
  content: "\\f068";
}

.quote::after {
  content: "\\f10e";
}

.bullet-list::after {
  content: "\\f03a";
}

.ordered-list::after {
  content: "\\f0cb";
}

.task-list::after {
  content: "\\f14a";
}

.indent::after {
  font-family: "Font Awesome 5 Free";
  content: "\\f03c";
  font-weight: 900;
  color: #ff0000 !important;
}

.outdent::after {
  content: "\\f03b";
}

.table::after {
  content: "\\f0ce";
}

.image::after {
  content: "\\f03e";
}

.link::after {
  content: "\\f0c1";
}

.code::after {
  content: "\\f121";
}

.codeblock::after {
  content: "CB";
}

.toastui-editor-popup-body {
  color: #fff !important;
  background: #061123 !important;
}

body.dark .toastui-editor-popup-body {
  color: #000 !important;
  background: #f8fbff !important;
}

.toastui-editor-defaultUI {
  border: 0px !important;
}

.toastui-editor-contents table th,
.toastui-editor-contents table td {
  border: 1px solid #fff !important;
  color: #fff !important;
}

.toastui-editor-contents table td p {
  color: #ffffff !important;
}

.toastui-editor-toolbar-icons {
  background: none !important;
}

.more::after {
  content: "...";
}

.toastui-editor-dropdown-toolbar {
  background: #09182f !important;
}

.icon-wrapper {
  display: inline-block;
  cursor: pointer;
  transition: transform 0.5s ease;
  transform-origin: center;
}

.rotate {
  transform: rotate(180deg);
}

/* loader */
.load-container {
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 100px;
}

.blocks {
  position: relative;
  z-index: 1000;
  width: 6px;
  height: 30px;
  margin-left: 6px;
  float: left;
  background-color: #00c310;
  animation: spiner 1s infinite ease-in-out;
}

.blocks:first-child {
  margin-left: 0;
}

.b-one {
  animation-delay: -1s;
}

.b-two {
  animation-delay: -0.9s;
}

.b-three {
  animation-delay: -0.8s;
}

.b-four {
  animation-delay: -0.7s;
}

.b-five {
  animation-delay: -0.6s;
}

@keyframes spiner {
  0% {
    transform: scaleY(1);
  }

  50% {
    transform: scaleY(2);
  }

  100% {
    transform: scaleY(1);
  }
}

.spinner {
  border-top-color: transparent;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* customize scroll bar */
/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 0;
  cursor: default !important;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  background: grey;
  border-radius: 10px;
  cursor: default !important;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #14243e;
  border-radius: 10px;
  cursor: default !important;
}

.dark ::-webkit-scrollbar-thumb {
  background: #bec8d5 !important;
  cursor: default !important;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #14243e;
  cursor: default !important;
}

.dark ::-webkit-scrollbar-thumb:hover {
  background: #bec8d5 !important;
}

.apexcharts-tooltip-marker {
  background-color: #ffc107 !important;
}

.ReactTags__selected {
  display: flex;
  flex-wrap: wrap !important;
  /* border: 1px solid #193258 !important; */
  color: #fff !important;
  min-height: 40px !important;
  align-items: center !important;
  font-size: 14px !important;
  gap: 10px;
}

.ReactTags__tagInput .ReactTags__tagInputField {
  background-color: transparent !important;
  border: 0px !important;
  height: 36px;
  width: 100%;
  max-width: 100px;
}

.react-tags-active .ReactTags__tagInput input:focus {
  outline: none !important;
  border: transparent !important;
  box-shadow: none !important;
}

.ReactTags__selected .ReactTags__tagInput .ReactTags__tagInputField:focus {
  outline: none !important;
  border: transparent !important;
  box-shadow: none !important;
}

.ReactTags__remove {
  margin-left: 11px !important;
  width: 12px !important;
  height: 12px !important;
}

.ReactTags__tag {
  padding: 5px !important;
  border: 1px solid #193258;
  border-radius: 4px;
  cursor: default !important;
}

.ReactTags__suggestions li {
  border: 1px solid #193258;
  margin-top: 2px;
  cursor: pointer;
  height: 40px;
  border-radius: 4px;
  padding: 10px;
}

.dark .ReactTags__suggestions li {
  border: 1px solid #bec8d5;
  color: black;
}

.ReactTags__suggestions {
  z-index: 9999;
  position: absolute;
  background-color: #14243e !important;
  width: 100%;
  max-width: 250px;
  height: auto !important;
  max-height: 40vh !important;
  overflow-y: auto;
}

.dark .ReactTags__suggestions {
  background-color: #f0f2f5 !important;
}

.react-datepicker-popper {
  z-index: 9999 !important;
}

body.dark .vector {
  filter: hue-rotate(100deg) saturate(9%) brightness(451%) !important;
}

body:not(.dark) .vector {
  filter: none !important;
  /* No filter in light mode */
}

body.dark .vector-44 {
  filter: hue-rotate(100deg) saturate(9%) brightness(330%) !important;
}

body:not(.dark) .vector-44 {
  filter: none !important;
  /* No filter in light mode */
}

body.dark .pics {
  filter: hue-rotate(20deg) saturate(9%) brightness(250%) !important;
}

.animate-btn:hover {
  background: rgba(25, 50, 88, 1);
}

body.dark .animate-btn:hover {
  background: #e2e8f2;
}

.w-heatmap {
  color: #ffffff !important;
}

.w-heatmap > rect {
  display: none !important;
}

body.dark .w-heatmap text {
  fill: #000 !important;
}

/* loader */

.loader {
  width: 25px;
  height: 25px;
  border: 5px dotted white;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: rotation 2s linear infinite;
}

.dark .loader {
  border: 5px dotted black;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* hide reveal button in edge */
::-ms-reveal {
  display: none !important;
}

.custom-react-tags input {
  border-style: none;
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.custom-react-tags input:focus {
  border-style: none;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.tag-wrapper {
  margin-left: 6px;
  height: 24px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #193258;
}

body.dark .tag-wrapper {
  background-color: #4b5058;
}

.ReactTags__remove {
  margin-left: 5rem;
}

input[type="file"]::-webkit-file-upload-button {
  /* chromes and blink button */
  cursor: pointer;
}

/* @keyframes slide-left {
  from {
    transform: translateX(120%);
  }
  to {
    transform: translateX(-170%);
  }
} */

input[type="text"]::placeholder {
  color: #78869b !important;
}

input[type="text"],
input[type="number"],
input[type="password"],
textarea {
  background: transparent;
  font-size: 14px !important;
  color: #dddddd !important;
}

.inputHr:focus {
  border-color: #00c310 !important;
  /* springBud */
  outline: none !important;
  /* remove default browser outline */
}

input[type="text"].correct-border {
  border: 1px solid #00c310 !important;
  /* springBud */
}

input[type="text"].incorrect-border {
  border: 1px solid #ef4444 !important;
  /* red-500 */
}

input[type="text"].default-border {
  border: 1px solid #193258 !important;
}

h1 {
  font-size: 2.25rem;
  line-height: 2.5rem;
  font-weight: 700;
}

h2 {
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 600;
}

h3 {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 600;
}

h4 {
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: 500;
}

h5 {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 500;
}

h6 {
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 500;
}

body.dark input[type="text"],
body.dark input[type="number"],
body.dark input[type="password"],
body.dark textarea {
  color: black !important;
}

body.dark .react-gauge-component .value-text,
body.dark .react-gauge-component .value-text text {
  fill: #000 !important;
  /* Black in dark mode */
}

body:not(.dark) .react-gauge-component .value-text,
body:not(.dark) .react-gauge-component .value-text text {
  fill: #fff !important;
  /* White in light mode */
}

/* src/styles/ApexCharts.css */
body.dark .apexcharts-tooltip {
  background: #1f2937 !important;
  color: #fff !important;
  border: none !important;
}

body.dark .apexcharts-tooltip * {
  color: #fff !important;
}

body:not(.dark) .apexcharts-tooltip {
  background: #fff !important;
  color: #000 !important;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(68%) sepia(15%) saturate(300%) hue-rotate(180deg);
  opacity: 0.8;
  cursor: pointer;
}

input[type="time"]::-webkit-calendar-picker-indicator {
  filter: invert(68%) sepia(15%) saturate(300%) hue-rotate(180deg);
  opacity: 0.8;
  cursor: pointer;
}

input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  filter: invert(68%) sepia(15%) saturate(300%) hue-rotate(180deg);
  opacity: 0.8;
  cursor: pointer;
}

body.dark .apexcharts-tooltip-title {
  background-color: #2b313a !important;
  color: #fff !important;
}

body.dark .cve-logo {
  fill: #000;
  stroke: #000;
}

body.dark .object-contain path {
  fill: #78869b;
  stroke: #fff;
}

.noBorder input {
  outline: none !important;
  border: none !important;
}

.noBorder input[type="text"]:focus {
  border: none !important;
  outline: none !important;
}

input[type="radio"]:checked {
  accent-color: #00c331 !important;
}

.dark input[type="radio"]:checked {
  accent-color: #00c331 !important;
}

.css-1xbattx-container {
  width: 100% !important;
}

::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

input[type="text"]:focus:not(.ticketInput),
input[type="password"]:focus,
textarea:focus {
  border: 1px solid #00c310 !important;
  border-radius: 4px !important;
  outline: none !important;
}

#customTagInput {
  border: none !important;
}

input[type="text"]:focus + label,
input[type="password"]:focus + label,
textarea:focus + label {
  color: #00c310 !important;
  font-size: 10px;
}

.gatewayIpInput {
  background: #193258 !important;
}

input[type="text"],
input[type="password"],
input[type="number"],
textarea {
  border-radius: 4px !important;
  outline: none !important;
}

/* Custom class to hide scrollbar */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.grafana-gauge svg {
  margin-top: -10px !important;
}

.revolve {
  transition: transform 0.2s ease-in-out;
  /* Optional smooth transition */
}

.revolve:hover {
  animation: revolve 0.3s linear infinite;
}

@keyframes revolve {
  from {
    transform: rotateY(0deg);
  }

  to {
    transform: rotateY(360deg);
  }
}

.loaderSpinner {
  width: 48px;
  height: 48px;
  border: 5px solid #fff;
  border-bottom-color: #ff3d00;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* 
.toastSuccess {
  background: #09182f !important;
  color: #ffffff !important;
  border-radius: 4px !important;
  border-color: 1px solid #193258 !important;
}
.toastSuccess .Toastify__zoom-enter {
  color: white !important;
} */
.css-1dimb5e-singleValue {
  color: #ffffff !important;
  font-size: 12px !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
  -webkit-text-fill-color: white !important;
  box-shadow: 0 0 0 1000px #09182f inset !important;
  -webkit-box-shadow: 0 0 0 1000px #09182f inset !important;
  background-color: transparent !important;
  color: white !important;
  caret-color: white !important;
  -webkit-transition: background-color 9999s ease-in-out 0s;
  transition: background-color 9999s ease-in-out 0s;
}

/* toastify */
.Toastify__toast--error,
.Toastify__toast--success,
.Toastify__toast--default {
  /* width:350px !important; */
  /* max-width: 500px !important; */
  /* margin-right: 40px !important; */
  background: #00070f !important;
}

.dark .Toastify__toast--error,
.dark .Toastify__toast--success,
.dark .Toastify__toast--default {
  /* width:350px !important; */
  /* max-width: 500px !important; */
  /* margin-right: 40px !important; */
  background: #dee5ed !important;
}

.toastSucesscus {
  border: 1px solid #00c310 !important;
}

.toastError {
  border: 1px solid #cd2f23 !important;
}

.Toastify__toast--error svg {
  color: #78869b !important;
}

input[type="text"]:focus {
  outline: none !important;
}

/* input {
  padding: 4px !important;
} */

.ProseMirror {
  z-index: 0 !important;
}

.Toastify__toast-container {
  z-index: 999999 !important;
  /* margin-right: 30px !important; */
}

.Toastify__close-button--light {
  color: #78869b !important;
  opacity: 1 !important;
}

.css-1jqq78o-placeholder,
.css-aoxytf-singleValue {
  font-size: 13px !important;
  color: #fff !important;
  font-weight: 400 !important;
}

.ReactTags__selected {
  /* max-height: 40px !important; */
  border-radius: 4px !important;
  overflow-y: auto !important;
  padding: 1px !important;
  display: flex !important;
  align-items: center !important;
}

@keyframes popIn {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }

  75% {
    transform: scale(1.05);
    opacity: 1;
  }

  100% {
    transform: scale(1);
  }
}

.modal-box {
  animation: popIn 0.3s ease-out;
}

.slick-list {
  text-align: left !important;
  justify-content: flex-start !important;
  /* height: 100% !important;
  width: 100% !important; */
}

.slick-track {
  display: flex !important;
  justify-content: flex-start !important;
  /* width: 100% !important; */
  align-items: center !important;
}

.slick-slider {
  height: fit-content !important;
}

.slick-slide {
  width: none !important;
}

.noTail h1 {
  font-size: 2.25rem;
  /* 36px */
  font-weight: 800;
  line-height: 1.25;
}

.noTail h2 {
  font-size: 1.875rem;
  /* 30px */
  font-weight: 700;
  line-height: 1.3;
}

.noTail h3 {
  font-size: 1.5rem;
  /* 24px */
  font-weight: 600;
  line-height: 1.4;
}

.noTail h4 {
  font-size: 1.25rem;
  /* 20px */
  font-weight: 600;
  line-height: 1.5;
}

.noTail h5 {
  font-size: 1.125rem;
  /* 18px */
  font-weight: 600;
  line-height: 1.6;
}

.noTail h6 {
  font-size: 1rem;
  /* 16px */
  font-weight: 600;
  line-height: 1.75;
}

.toastui-editor-popup-add-image,
.toastui-editor-popup-add-link {
  background: #09182f !important;
  color: #78869b !important;
  border: 1px solid #193258 !important;
}

.dark .toastui-editor-popup-add-image,
.dark .toastui-editor-popup-add-link {
  background: #f2f4f7 !important;
  color: #78869b !important;
  border: 1px solid #e6edf8 !important;
}

body.dark .toastui-editor-popup-add-image,
body.dark .toastui-editor-popup-add-link {
  background: #edf0f5 !important;
  color: #78869b !important;
  border: 1px solid #e6edf8 !important;
}

.toastui-editor-file-name {
  border: 1px solid #193258 !important;
}

.dark .toastui-editor-file-name {
  border: 1px solid #e6edf8 !important;
}

body.dark .toastui-editor-file-name::placeholder {
  color: #b5c6e0 !important;
}

.toastui-editor-popup-add-image .toastui-editor-tabs .tab-item.active {
  color: #fff !important;
}

body.dark
  .toastui-editor-popup-add-image
  .toastui-editor-tabs
  .tab-item.active {
  color: #000 !important;
}

.toastui-editor-popup-add-image .toastui-editor-tabs .tab-item {
  color: #78869b !important;
}

.css-u18htb:hover {
  background-color: transparent !important;
}

.ReactTags__remove svg {
  height: 9px !important;
  width: 9px !important;
  font-weight: bold !important;
}

.toastui-editor-popup-add-image .toastui-editor-file-name.has-file {
  color: #fff !important;
}

body.dark .toastui-editor-popup-add-image .toastui-editor-file-name.has-file {
  color: #000 !important;
}

.toastui-editor-popup-body label {
  color: #78869b !important;
}

.docx-wrapper {
  background: transparent !important;
}

/* Hide arrows in Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Hide arrows in Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.border-dotted {
  border-style: dotted;
}

/* .adminModule > div > svg{
 height: 200px !important;
} */

/* .grafana-gauge > svg{
 width: 450px;
} */

body.dark .slick-prev:before,
body.dark .slick-next:before {
  color: black;
}

.html-content img {
  width: 150px;
  height: 120px;
  object-fit: cover;
  /* optional, for better image scaling */
}

/* .bucket-cut {
  --r: 50px;
  height: 150px;
  aspect-ratio: 1.2;
  border-radius: 20px;
  background: #F07818;
  mask: radial-gradient(var(--r) at 50% var(--r),#0000 calc(100% - 1px),#000) 0 calc(-1*var(--r));
  border: 2px solid white;
} */

.userStats .grafana-gauge svg {
  width: 500px !important;
  height: 350px !important;
}

/* HTML: <div class="inverted-radius"></div> */
.inverted-radius {
  --r: 20px;
  /* the radius */
  --s: 30px;
  /* size of inner curve */
  --x: 5px;
  /* horizontal offset (no percentage) */
  --y: 5px;
  /* vertical offset (no percentage) */

  aspect-ratio: 1;
  /* background: #3fb8af; */
  border-radius: var(--r);
  --_m: /calc(2 * var(--r)) calc(2 * var(--r))
    radial-gradient(#000 70%, #0000 72%);
  --_g: conic-gradient(at calc(100% - var(--r)) var(--r), #0000 25%, #000 0);
  --_d: (var(--s) + var(--r));
  mask:
    calc(100% - var(--_d) - var(--x)) 0 var(--_m),
    100% calc(var(--_d) + var(--y)) var(--_m),
    radial-gradient(var(--s) at 100% 0, #0000 99%, #000 calc(100% + 1px))
      calc(-1 * var(--r) - var(--x)) calc(var(--r) + var(--y)),
    var(--_g) calc(-1 * var(--_d) - var(--x)) 0,
    var(--_g) 0 calc(var(--_d) + var(--y));
  mask-repeat: no-repeat;
}

.css-fyq6mk-container {
  /* border: 1px solid #193258 !important; */
  border-radius: 4px !important;
}

/* input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #ccc;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

input[type="radio"]:checked {
  border-color: #00c310;
}

input[type="radio"]:checked::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 9px; 
  height: 9px;
  background-color: #00c310;
  border-radius: 50%;
  box-sizing: border-box;
} */

.tnc {
  background-image: radial-gradient(
    circle 60vh at 50% 250%,
    #1b68a9 40%,
    transparent
  );
  background-size: 100% 20vh;
  background-repeat: no-repeat;
}

.skillContainer:hover {
  background-image: radial-gradient(
    circle 10vh at 50% 100%,
    #1b68a9 40%,
    transparent
  );
  background-size: 100% 10vh;
  background-repeat: no-repeat;
}

.dark .skillContainer:hover {
  background-image: radial-gradient(
    circle 10vh at 50% 100%,
    #2196f3 40%,
    transparent
  );
  background-size: 100% 10vh;
  background-repeat: no-repeat;
}

.achContainer {
  background-image: radial-gradient(
    circle 50vh at 70% -220px,
    /* Move to top */ #1b68a9 0%,
    /* Start strong */ #106eff 0%,
    /* Hold color longer */ transparent 100% /* Fade fully */
  );
  background-size: 100% 100%;
  /* Make it spread more vertically */
  background-repeat: no-repeat;
  background-position: top center;
  /* Stick it to top edge */
}

@keyframes scroll-left {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

/* profile spikes line */
.outer1 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.between1 {
  width: 120px;
  height: 0.5px;
  background: #045d0b;
  position: relative;
  top: -0.5px;
}

.dark .between1 {
  background: #00c331;
}

.container1 {
  position: relative;
  background: #ffffff;
  border-top: 1px solid #045d0b;
  width: 50px;
}

.dark .container1 {
  border-top: 1px solid #00c331;
}

.container1::before,
.container1::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
}

.container1::before {
  border-bottom-color: #045d0b;
}

.dark .container1::before {
  border-bottom-color: #00c331;
}

.container1::after {
  border-width: 4px;
  border-bottom-color: #14243e;
}

.dark .container1::after {
  border-bottom-color: #f8fbff;
}

/* profile spikes line end */

/* profile spikes line2 start */
.outer2 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.between2 {
  width: 120px;
  height: 0.5px;
  background: #045d0b;
}

.dark .between2 {
  background: #00c331;
}

.container2 {
  position: relative;
  background: #ffffff;
  border-bottom: 1px solid #045d0b;
  width: 50px;
}

.dark .container2 {
  border-bottom: 1px solid #00c331;
}

.container2::before,
.container2::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
}

.container2::before {
  border-top-color: #045d0b;
}

.dark .container2::before {
  border-top-color: #00c331;
}

.container2::after {
  border-width: 4px;
  border-top-color: #14243e;
}

.dark .container2::after {
  border-top-color: #f8fbff;
}

/* profile spikes line2 end */

/* #react-select-7-input {
  display: none !important;
} */

.gradient-borders {
  border: 2px solid transparent;
  border-radius: 6px;
}

.gradient-borders:hover {
  border-image: linear-gradient(
    to right,
    rgb(222, 222, 222) 0%,
    transparent 70%
  );
  border-image-slice: 1;
}

.dark .gradient-borders:hover {
  border-image: linear-gradient(to right, rgb(0, 195, 60) 0%, transparent 70%);
  border-image-slice: 1;
}

/* gradient-borders bottom */
.gradient-borders-bottom {
  position: relative;
  border-radius: 6px;
  /* Works fine */
}

.gradient-borders-bottom::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 2px;
  /* thickness of border */
  border-radius: 6px;
  background: linear-gradient(to top, #00c310 0%, transparent 70%);
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
  /* for Firefox */
  pointer-events: none;

  opacity: 0;
  /* hidden by default */
  /* transition: opacity 0s ease-in-out; */
}

.gradient-borders-bottom:hover::before {
  opacity: 1;
  /* show on hover */
}

input.size-input[type="number"] {
  color: #fff !important;
}

body.dark input.size-input[type="number"] {
  color: #000 !important;
}

.drop-down-item:hover {
  background-color: rgb(6, 26, 58) !important;
}

body.dark .drop-down-item:hover {
  background-color: #ebedef !important;
}

body.dark .toastui-editor-contents ol > li::before {
  color: #000 !important;
}

body.dark .toastui-editor-contents ul > li::before {
  background-color: #000 !important;
}

.apexcharts-toolbar {
  display: none !important;
}

/* #react-select-2-input,
#react-select-3-input,
#react-select-4-input,
#react-select-5-input {
  display: none !important;
} */
/* Firefox */
.react-tags-active {
  border: 1px solid #00c310 !important;
}

.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgb(25, 50, 88) rgb(8, 24, 48);
}

.dark .custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #999 #f0f0f0 !important;
  /* green thumb, dark track */
}

.apexcharts-legend-text {
  color: #ffffff !important;
}

.apexcharts-yaxis-label {
  color: #ffffff !important;
}

/* Chrome, Edge, Safari */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: rgb(8, 24, 48);
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgb(25, 50, 88);
  border-radius: 6px;
}

.clip-triangle {
  clip-path: polygon(100% 0, 0 100%, 100% 100%);
}

@keyframes blinkBackground {
  0%,
  100% {
    background-color: rgba(244, 67, 54, 0.2);
    /* red, faint */
  }

  50% {
    background-color: rgba(244, 67, 54, 10, 0.6);
    border: 1px solid #f44336;
  }
}

.blink-bg {
  animation: blinkBackground 1s infinite;
}

.toastui-editor-defaultUI-toolbar {
  border-radius: 4px 4px 0 0 !important;
}

.toastui-editor-main {
  border: 1px solid #193258 !important;
  border-top: 0 !important;
  margin-top: -2px !important;
  border-radius: 0 0 4px 4px !important;
}

.dark .toastui-editor-main {
  border: 1px solid #bec8d5 !important;
}

.ww-mode {
  padding: 5px !important;
}

/* for announcement structure */
.custom-clip {
  clip-path: polygon(95% 85%, 26% 85%, 25% 100%, 0% 100%, 5% 0%, 100% 0%);
  z-index: 20;
}

.custom-clip::after {
  content: "";
  height: 50px;
  width: 7%;
  background: #1f81d1;
  position: absolute;
  right: 0px;
  clip-path: polygon(100% 100%, 0% 100%, 91% 0%, 100% 0%);
}

.blink-message {
  font-weight: 600;
  color: #00e676;
  /* success green (change for error/warning) */
  animation: zomatoBlink 1.5s ease-in-out infinite;
}

@keyframes zomatoBlink {
  0% {
    opacity: 0;
    transform: translateY(5px);
  }

  50% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0.9;
    transform: translateY(-2px);
  }
}

/* ContextMenu.css */
.context-menu {
  position: absolute;
  /* instead of fixed */
  z-index: 1000;
  display: none;
}

.context-menu.active {
  display: block;
}

.inputField {
  background: transparent;
  border: 1px solid #193258 !important;
  font-size: 14px !important;
  color: #dddddd !important;
  width: 100%;
}

.dark .inputField {
  border: 1px solid #bec8d5 !important;
}

.css-ofedx2-container {
  border: 1px solid #193258 !important;
  border-radius: 4px !important;
}

.dark .css-ofedx2-container {
  border: 1px solid #e6edf8 !important;
  border-radius: 4px !important;
}

.errorField {
  background: transparent;

  font-size: 14px !important;
  color: #dddddd !important;
  width: 100%;
  border: 1px solid red !important;
}

.taskinput:focus {
  outline: none !important;
  border: none !important;
}

.toastui-editor-popup-add-heading ul li:hover {
  background-color: #193258 !important;
}

.toastui-editor-popup {
  border: 1px solid #193258 !important;
  top: 43px !important;
}

.dark .toastui-editor-popup {
  border: 1px solid #e6edf8 !important;
  top: 43px !important;
}

.toastui-editor-toolbar-icons {
  border: none !important;
}

.light button[aria-label="F"] {
  border: none !important;
}

.light .toastui-editor-toolbar-icons:hover::after,
.light .toastui-editor-toolbar-icons:active::after {
  color: #ffffff !important;
}

.dark .toastui-editor-toolbar-icons:hover::after,
.dark .toastui-editor-toolbar-icons:active::after {
  color: #000000 !important;
}

.light .tui-tool-item.tui-tool-active::after,
.light .tui-tool-item[aria-pressed="true"]::after {
  color: #ffffff !important;
}

.light button[aria-label="F"]:hover,
.light button[aria-label="F"]:active {
  color: #fff !important;
}

/* Hover & active (when pressed/clicked) */
.light .toastui-editor-toolbar-icons:hover::after,
.light .toastui-editor-toolbar-icons:active::after {
  color: #ffffff !important;
}

/* Proper active state: Toast UI marks active buttons with .tui-tool-active or aria-pressed="true" */
.light .tui-tool-item.tui-tool-active .toastui-editor-toolbar-icons::after,
.light
  .toastui-editor-toolbar
  button[aria-pressed="true"]
  .toastui-editor-toolbar-icons::after {
  color: #ffffff !important;
}

.toastui-editor-toolbar button.active::after,
.toastui-editor-toolbar button.active::before {
  color: #ffffff !important;
}

.dark .toastui-editor-toolbar button.active::after,
.dark .toastui-editor-toolbar button.active::before {
  color: #000000 !important;
}

.toastui-editor-file-select-button {
  background-color: #193258 !important;
  border: none !important;
  color: white !important;
}

.toastui-editor-file-select-button:hover {
  background-color: #2b589b !important;
}

.dark .toastui-editor-file-select-button {
  background-color: #e6edf8 !important;
  color: black !important;
}

.dark .toastui-editor-file-select-button:hover {
  background-color: #b5c6e0 !important;
}

#toastuiLinkUrlInput:focus ~ label[for="toastuiLinkTextInput"] {
  color: #78869b !important;
  font-size: 12px !important;
}

.toastui-editor-close-button {
  background-color: #193258 !important;
  color: white !important;
  border: none !important;
  border-radius: 4px !important;
}

.toastui-editor-close-button:hover {
  background-color: #2b589b !important;
}

.dark .toastui-editor-close-button {
  background-color: #e6edf8 !important;
  color: black !important;
}

.dark .toastui-editor-close-button:hover {
  background-color: #b5c6e0 !important;
}

.toastui-editor-ok-button {
  background-color: #00c310 !important;
  color: black !important;
  border: none !important;
}

.toastui-editor-ok-button:hover {
  background-color: #00ea13 !important;
}

.toastui-editor-popup-add-image .toastui-editor-tabs .tab-item.active {
  border-bottom: 2px solid #00c310 !important;
}

.toastui-editor-popup-add-link .toastui-editor-popup-body,
.toastui-editor-popup-add-image .toastui-editor-popup-body {
  padding: 0px !important;
}

.toastui-editor-popup-body {
  padding: 0px !important;
}

.toastui-editor-popup-body > div {
  padding: 0 16px !important;
}

.toastui-editor-popup-body input[type="text"] {
  border: 1px solid #193258 !important;
}

.dark .toastui-editor-popup-body input[type="text"] {
  border: 1px solid #e6edf8 !important;
}

.toastui-editor-button-container {
  padding: 8px 0px !important;
  /* x-axis padding */
}

/* .toastui-editor-popup-body .toastui-editor-button-container {
  margin-top: 0px !important;
} */

.toastui-editor-popup-body input[type="text"] {
  width: 365px !important;
  display: flex !important;
  align-items: start !important;
  justify-content: start !important;
}

.toastui-editor-popup-add-image .toastui-editor-file-name {
  width: 65% !important;
}

.toastui-editor-popup-body label {
  padding: 8px 0px !important;
  margin: 0px 0 5px !important;
}

.toastui-editor-defaultUI .ProseMirror {
  padding: 8px 8px !important;
}

.toastui-editor-popup-add-image .toastui-editor-tabs {
  margin: 0px 0 10px !important;
}

.apexcharts-tooltip {
  z-index: 9999 !important;
}

.apexcharts-series .apexcharts-pie-series {
  border: none !important;
}

.apexcharts-tooltip {
  z-index: 9999 !important;
}

.sidebarheight {
  height: calc(96vh - 60px);
}

/* Force autofill background to match your theme */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px var(--autofill-bg) inset !important;
  -webkit-text-fill-color: var(--autofill-text) !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

:root {
  --autofill-bg: #061123;
  --autofill-text: #fdfeff;
}

.dark {
  --autofill-bg: #fdfeff;
  --autofill-text: #061123;
}

.toastui-editor-contents a {
  color: #4b96e6 !important;
}

.react-select__input input:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(-3px);
  }

  75% {
    transform: translateX(3px);
  }
}

.animate-shake {
  animation: shake 0.2s ease-in-out;
}

.sample-canvas {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) !important;
}

.dark .sample-canvas {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) !important;
}

.dark text[fill] {
  fill: #000000 !important;
}

.light text[fill] {
  fill: #ffffff !important;
}

.dark input:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.light input:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.dark textarea:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.light textarea:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.thumbnail-image {
  height: 200px !important;
}

.chrome-tab {
  position: relative;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

/* Left curve */
.chrome-tab::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: -10px;
  width: 12px;
  height: 12px;
  background: inherit;
  border-bottom-right-radius: 10px;
}

/* Right curve */
.chrome-tab::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: -10px;
  width: 12px;
  height: 12px;
  background: inherit;
  border-bottom-left-radius: 10px;
}

.dark .toastui-editor-contents h1 span {
  color: #000 !important;
}

/* Dark mode: force all H1 and nested spans inside H1 */
.dark .toastui-editor-contents h1,
.dark .toastui-editor-contents h1 * {
  color: #000 !important;
  /* Change to your dark-theme heading color */
}

.dark .toastui-editor-contents span {
  color: #000 !important;
  /* change to your dark theme text color */
}

/* 
.slide-text {
  animation: slide-left 30s linear forwards;
  animation-play-state: running;
}

.slide-text.paused {
  animation-play-state: paused;
} */

.customEditorForComment .toastui-editor-defaultUI-toolbar {
  visibility: hidden !important;
  height: 1px !important;
}

.customEditorForComment .toastui-editor-toolbar {
  height: 1px;
}

.customEditorForComment .toastui-editor-main-container {
  height: 115px;
  position: relative;
  top: 3px;
}

.customEditorForComment .toastui-editor-popup {
  width: 100%;
  left: 4px !important;
  top: -40px !important;
}

.customEditorForComment .toastui-editor-popup-add-image {
  top: -94px !important;
}

.customEditorForComment #toastuiAltTextInput {
  width: 100% !important;
}

.customEditorForComment #toastuiLinkUrlInput {
  width: 100% !important;
}

.customEditorForComment #toastuiLinkTextInput {
  width: 100% !important;
}

.customEditorForComment #toastuiImageUrlInput {
  width: 100% !important;
}

.customEditorForComment .toastui-editor {
  height: 100% !important;
}

.customEditorForComment .toastui-editor-main {
  border: none !important;
}

.custom-height-ticket {
  height: calc(100vh - 100px);
}

.light .commentSection p,
.light .commentSection h1,
.light .commentSection h2,
.light .commentSection h3,
.light .commentSection h4,
.light .commentSection h5,
.light .commentSection h6,
.light .commentSection div,
.light .commentSection span,
.light .commentSection label,
.light .commentSection {
  color: #ffffff !important;
}

#toastuiAltTextInput {
  display: none !important;
}

label[for="toastuiAltTextInput"] {
  display: none !important;
}

.toastui-editor-button-container {
  margin-top: 20px !important;
}

.placeholder\\:text-\\[14px\\]::placeholder {
  font-size: 14px;
}

.placeholder\\:text-\\[gray\\]::placeholder {
  --tw-text-opacity: 1;
  color: rgb(128 128 128 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-lightSlateGray::placeholder {
  --tw-text-opacity: 1;
  color: rgb(120 134 155 / var(--tw-text-opacity, 1));
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:left-\\[3px\\]::after {
  content: var(--tw-content);
  left: 3px;
}

.after\\:start-\\[2\\.5px\\]::after {
  content: var(--tw-content);
  inset-inline-start: 2.5px;
}

.after\\:start-\\[3\\.2px\\]::after {
  content: var(--tw-content);
  inset-inline-start: 3.2px;
}

.after\\:start-\\[3\\.5px\\]::after {
  content: var(--tw-content);
  inset-inline-start: 3.5px;
}

.after\\:top-\\[1\\.5px\\]::after {
  content: var(--tw-content);
  top: 1.5px;
}

.after\\:top-\\[2\\.5px\\]::after {
  content: var(--tw-content);
  top: 2.5px;
}

.after\\:top-\\[2px\\]::after {
  content: var(--tw-content);
  top: 2px;
}

.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}

.after\\:h-\\[18px\\]::after {
  content: var(--tw-content);
  height: 18px;
}

.after\\:h-\\[20px\\]::after {
  content: var(--tw-content);
  height: 20px;
}

.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}

.after\\:w-\\[18px\\]::after {
  content: var(--tw-content);
  width: 18px;
}

.after\\:w-\\[20px\\]::after {
  content: var(--tw-content);
  width: 20px;
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:border::after {
  content: var(--tw-content);
  border-width: 1px;
}

.after\\:border-gray-300::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.even\\:bg-gray-100:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.focus-within\\:ring-1:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-springBud:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 195 49 / var(--tw-ring-opacity, 1));
}

.hover\\:z-0:hover {
  z-index: 0;
}

.hover\\:h-\\[47\\%\\]:hover {
  height: 47%;
}

.hover\\:h-\\[57\\%\\]:hover {
  height: 57%;
}

.hover\\:h-\\[70\\%\\]:hover {
  height: 70%;
}

.hover\\:w-\\[184px\\]:hover {
  width: 184px;
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-50:hover {
  --tw-scale-x: .5;
  --tw-scale-y: .5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-x-\\[-1\\]:hover {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:overflow-y-auto:hover {
  overflow-y: auto;
}

.hover\\:border:hover {
  border-width: 1px;
}

.hover\\:border-b-2:hover {
  border-bottom-width: 2px;
}

.hover\\:border-none:hover {
  border-style: none;
}

.hover\\:border-lightSlateGray:hover {
  --tw-border-opacity: 1;
  border-color: rgb(120 134 155 / var(--tw-border-opacity, 1));
}

.hover\\:border-lsecondaryHover:hover {
  --tw-border-opacity: 1;
  border-color: rgb(181 198 224 / var(--tw-border-opacity, 1));
}

.hover\\:border-spaceCadet:hover {
  --tw-border-opacity: 1;
  border-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
}

.hover\\:border-springBud:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 195 49 / var(--tw-border-opacity, 1));
}

.hover\\:border-white:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-b-\\[\\#1169c6\\]:hover {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(17 105 198 / var(--tw-border-opacity, 1));
}

.hover\\:\\!bg-\\[\\#00EA13\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 234 19 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-\\[\\#C4170B\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(196 23 11 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-secondaryHover:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(43 88 155 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-springBudHover:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 234 19 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#0166B7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(1 102 183 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#12203A\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(18 32 58 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#13b94b\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(19 185 75 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#234270\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(35 66 112 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#254078\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 64 120 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#BD9F05\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(189 159 5 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#C4170B\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(196 23 11 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#C97A05\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(201 122 5 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#ff7b4a\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 123 74 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-black\\/20:hover {
  background-color: rgb(0 0 0 / 0.2);
}

.hover\\:bg-black\\/60:hover {
  background-color: rgb(0 0 0 / 0.6);
}

.hover\\:bg-black\\/80:hover {
  background-color: rgb(0 0 0 / 0.8);
}

.hover\\:bg-black\\/90:hover {
  background-color: rgb(0 0 0 / 0.9);
}

.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-errorColorTextBtn:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-insideDiv:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(9 24 47 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-llightGrayShade:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 17 35 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-lsunsetOrange:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 86 86 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-lyankeesBlue\\/10:hover {
  background-color: rgb(248 251 255 / 0.1);
}

.hover\\:bg-maastrichtBlue:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(6 17 35 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-secondaryHover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(43 88 155 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-sheenGreen:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 195 16 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-spaceCadet:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(25 50 88 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-spaceCadet\\/60:hover {
  background-color: rgb(25 50 88 / 0.6);
}

.hover\\:bg-springBud:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 195 49 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-springBudHover:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 234 19 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yankeesBlue:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(20 36 62 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-opacity-80:hover {
  --tw-bg-opacity: 0.8;
}

.hover\\:bg-opacity-90:hover {
  --tw-bg-opacity: 0.9;
}

.hover\\:stroke-white:hover {
  stroke: #fff;
}

.hover\\:font-medium:hover {
  font-weight: 500;
}

.hover\\:font-semibold:hover {
  font-weight: 600;
}

.hover\\:\\!text-black:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-\\[\\#1976D2\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(25 118 210 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[white\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-400:hover {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}

.hover\\:text-ckblue:hover {
  --tw-text-opacity: 1;
  color: rgb(33 150 243 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-300:hover {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-lightGrayShade:hover {
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity, 1));
}

.hover\\:text-lightSlateGray:hover {
  --tw-text-opacity: 1;
  color: rgb(120 134 155 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-springBud:hover {
  --tw-text-opacity: 1;
  color: rgb(0 195 49 / var(--tw-text-opacity, 1));
}

.hover\\:text-springBudHover:hover {
  --tw-text-opacity: 1;
  color: rgb(0 234 19 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-yankeesBlue:hover {
  --tw-text-opacity: 1;
  color: rgb(20 36 62 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.focus\\:border:focus {
  border-width: 1px;
}

.focus\\:border-none:focus {
  border-style: none;
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.focus\\:border-lsheenGreen:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 195 16 / var(--tw-border-opacity, 1));
}

.focus\\:border-spaceCadet:focus {
  --tw-border-opacity: 1;
  border-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:border-white:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.focus\\:text-springBud:focus {
  --tw-text-opacity: 1;
  color: rgb(0 195 49 / var(--tw-text-opacity, 1));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-spaceCadet:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(25 50 88 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-springBud:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 195 49 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.active\\:cursor-grabbing:active {
  cursor: grabbing;
}

.active\\:text-lspaceCadet:active {
  --tw-text-opacity: 1;
  color: rgb(230 237 248 / var(--tw-text-opacity, 1));
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.group:hover .group-hover\\:pointer-events-auto {
  pointer-events: auto;
}

.group:hover .group-hover\\:visible {
  visibility: visible;
}

.group:hover .group-hover\\:right-2 {
  right: 0.5rem;
}

.group:hover .group-hover\\:top-\\[163px\\] {
  top: 163px;
}

.group:hover .group-hover\\:flex {
  display: flex;
}

.group:hover .group-hover\\:h-\\[100px\\] {
  height: 100px;
}

.group:hover .group-hover\\:h-\\[120px\\] {
  height: 120px;
}

.group:hover .group-hover\\:max-h-40 {
  max-height: 10rem;
}

.group:hover .group-hover\\:-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-125 {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.2\\] {
  --tw-scale-x: 1.2;
  --tw-scale-y: 1.2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.6\\] {
  --tw-scale-x: 1.6;
  --tw-scale-y: 1.6;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[2\\] {
  --tw-scale-x: 2;
  --tw-scale-y: 2;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-t {
  border-top-width: 1px;
}

.group:hover .group-hover\\:border-t-\\[\\#184cc5\\] {
  --tw-border-opacity: 1;
  border-top-color: rgb(24 76 197 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:bg-\\[\\#dedddd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(222 221 221 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-spaceCadet {
  --tw-bg-opacity: 1;
  background-color: rgb(25 50 88 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:fill-\\[var\\(--g\\)\\] {
  fill: var(--g);
}

.group:hover .group-hover\\:stroke-\\[var\\(--hoverStroke\\)\\] {
  stroke: var(--hoverStroke);
}

.group:hover .group-hover\\:text-\\[\\#dedddd\\] {
  --tw-text-opacity: 1;
  color: rgb(222 221 221 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-springBud {
  --tw-text-opacity: 1;
  color: rgb(0 195 49 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:placeholder-white::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(255 255 255 / var(--tw-placeholder-opacity, 1));
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

.group:active .group-active\\:font-semibold {
  font-weight: 600;
}

.peer:checked ~ .peer-checked\\:bg-springBud {
  --tw-bg-opacity: 1;
  background-color: rgb(0 195 49 / var(--tw-bg-opacity, 1));
}

.peer:checked ~ .peer-checked\\:after\\:translate-x-\\[20px\\]::after {
  content: var(--tw-content);
  --tw-translate-x: 20px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.dark\\:block:is(.dark *) {
  display: block;
}

.dark\\:border:is(.dark *) {
  border-width: 1px;
}

.dark\\:border-\\[2px\\]:is(.dark *) {
  border-width: 2px;
}

.dark\\:border-b:is(.dark *) {
  border-bottom-width: 1px;
}

.dark\\:border-b-\\[0\\.5px\\]:is(.dark *) {
  border-bottom-width: 0.5px;
}

.dark\\:border-\\[\\#15CD5480\\]:is(.dark *) {
  border-color: #15CD5480;
}

.dark\\:border-\\[\\#313a55\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(49 58 85 / var(--tw-border-opacity, 1));
}

.dark\\:border-\\[\\#434F63\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(67 79 99 / var(--tw-border-opacity, 1));
}

.dark\\:border-\\[\\#BEC8D5\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(190 200 213 / var(--tw-border-opacity, 1));
}

.dark\\:border-\\[\\#DDE7F6\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(221 231 246 / var(--tw-border-opacity, 1));
}

.dark\\:border-\\[\\#dde7f6\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(221 231 246 / var(--tw-border-opacity, 1));
}

.dark\\:border-black:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}

.dark\\:border-black\\/50:is(.dark *) {
  border-color: rgb(0 0 0 / 0.5);
}

.dark\\:border-gray-200:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.dark\\:border-lborder:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(221 231 246 / var(--tw-border-opacity, 1));
}

.dark\\:border-lckblue:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(33 150 243 / var(--tw-border-opacity, 1));
}

.dark\\:border-lightSlateGray:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(120 134 155 / var(--tw-border-opacity, 1));
}

.dark\\:border-linsideDiv:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(242 244 247 / var(--tw-border-opacity, 1));
}

.dark\\:border-llightSlateGray:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(62 81 110 / var(--tw-border-opacity, 1));
}

.dark\\:border-lsecondaryHover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(181 198 224 / var(--tw-border-opacity, 1));
}

.dark\\:border-lsheenGreen:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(0 195 16 / var(--tw-border-opacity, 1));
}

.dark\\:border-lspaceCadet:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(230 237 248 / var(--tw-border-opacity, 1));
}

.dark\\:border-lspringBud:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(0 195 49 / var(--tw-border-opacity, 1));
}

.dark\\:border-lyankeesBlue:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(248 251 255 / var(--tw-border-opacity, 1));
}

.dark\\:border-sheenGreen:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(0 195 16 / var(--tw-border-opacity, 1));
}

.dark\\:border-spaceCadet:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(25 50 88 / var(--tw-border-opacity, 1));
}

.dark\\:border-spaceCadet\\/70:is(.dark *) {
  border-color: rgb(25 50 88 / 0.7);
}

.dark\\:border-white:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.dark\\:border-b-lborder:is(.dark *) {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(221 231 246 / var(--tw-border-opacity, 1));
}

.dark\\:border-b-lspaceCadet:is(.dark *) {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(230 237 248 / var(--tw-border-opacity, 1));
}

.dark\\:\\!bg-transparent:is(.dark *) {
  background-color: transparent !important;
}

.dark\\:bg-\\[\\#00C31026\\]:is(.dark *) {
  background-color: #00C31026;
}

.dark\\:bg-\\[\\#1b2340\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(27 35 64 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#232c4f\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(35 44 79 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#3cc3df\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(60 195 223 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#434F6366\\]\\/10:is(.dark *) {
  background-color: rgb(67 79 99 / 0.1);
}

.dark\\:bg-\\[\\#8979FF\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(137 121 255 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#C0CEE5\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(192 206 229 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#DCE3ED\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(220 227 237 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#EDF0F5\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(237 240 245 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#F7F8FA\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(247 248 250 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#e2e2e291\\]:is(.dark *) {
  background-color: #e2e2e291;
}

.dark\\:bg-\\[\\#e5e7eb\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#eaecf0\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(234 236 240 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#f1f2f7\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(241 242 247 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#ff928a\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 146 138 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-black:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-black\\/10:is(.dark *) {
  background-color: rgb(0 0 0 / 0.1);
}

.dark\\:bg-black\\/20:is(.dark *) {
  background-color: rgb(0 0 0 / 0.2);
}

.dark\\:bg-black\\/30:is(.dark *) {
  background-color: rgb(0 0 0 / 0.3);
}

.dark\\:bg-errorColorTextBtn:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(244 67 54 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lborder:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(221 231 246 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lcardTitleBg:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(181 198 224 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lcontentUnderline:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(159 239 4 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lgreen:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(76 175 80 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-linsideDiv:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-llightGrayShade:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(6 17 35 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-llightSlateGray:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(62 81 110 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lmaastrichtBlue:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 254 255 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lmainBg:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(241 242 247 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lmalachite:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 215 96 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lplatinum:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(9 24 47 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lsecondaryHover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(181 198 224 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lsheenGreen:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 195 16 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lspaceCadet:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(230 237 248 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lspaceCadet\\/40:is(.dark *) {
  background-color: rgb(230 237 248 / 0.4);
}

.dark\\:bg-lspaceCadet\\/50:is(.dark *) {
  background-color: rgb(230 237 248 / 0.5);
}

.dark\\:bg-lspringBud:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 195 49 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lstatusType:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(181 198 224 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lsunsetOrange:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 86 86 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lyankeesBlue:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 251 255 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lyellow:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 160 0 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-secondaryHover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(43 88 155 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-spaceCadet:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(25 50 88 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-spaceCadet\\/30:is(.dark *) {
  background-color: rgb(25 50 88 / 0.3);
}

.dark\\:bg-springBud:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 195 49 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-tableHead:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(237 240 245 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-transparent:is(.dark *) {
  background-color: transparent;
}

.dark\\:bg-white:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-white\\/20:is(.dark *) {
  background-color: rgb(255 255 255 / 0.2);
}

.dark\\:bg-yankeesBlue:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(20 36 62 / var(--tw-bg-opacity, 1));
}

.dark\\:dark\\:bg-lmaastrichtBlue:is(.dark *):is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 254 255 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-opacity-40:is(.dark *) {
  --tw-bg-opacity: 0.4;
}

.dark\\:bg-none:is(.dark *) {
  background-image: none;
}

.dark\\:from-linsideDiv:is(.dark *) {
  --tw-gradient-from: #f2f4f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(242 244 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-lmaastrichtBlue:is(.dark *) {
  --tw-gradient-from: #FDFEFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 254 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-lsecondaryHover:is(.dark *) {
  --tw-gradient-from: #b5c6e0 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(181 198 224 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:via-linsideDiv:is(.dark *) {
  --tw-gradient-to: rgb(242 244 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f2f4f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-lmaastrichtBlue:is(.dark *) {
  --tw-gradient-to: rgb(253 254 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #FDFEFF var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-lspaceCadet:is(.dark *) {
  --tw-gradient-to: rgb(230 237 248 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E6EDF8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-lyankeesBlue:is(.dark *) {
  --tw-gradient-to: rgb(248 251 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F8FBFF var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-transparent:is(.dark *) {
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:to-lborder:is(.dark *) {
  --tw-gradient-to: #DDE7F6 var(--tw-gradient-to-position);
}

.dark\\:to-linsideDiv:is(.dark *) {
  --tw-gradient-to: #f2f4f7 var(--tw-gradient-to-position);
}

.dark\\:to-lspaceCadet:is(.dark *) {
  --tw-gradient-to: #E6EDF8 var(--tw-gradient-to-position);
}

.dark\\:to-lyankeesBlue:is(.dark *) {
  --tw-gradient-to: #F8FBFF var(--tw-gradient-to-position);
}

.dark\\:fill-black:is(.dark *) {
  fill: #000;
}

.dark\\:\\!text-black:is(.dark *) {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:\\!text-white:is(.dark *) {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:text-\\[\\#021648\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(2 22 72 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#14243e\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(20 36 62 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#56606f\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(86 96 111 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#a17a05\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(161 122 5 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[llightSlateGray\\]:is(.dark *) {
  color: llightSlateGray;
}

.dark\\:text-black:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.dark\\:text-black\\/50:is(.dark *) {
  color: rgb(0 0 0 / 0.5);
}

.dark\\:text-black\\/80:is(.dark *) {
  color: rgb(0 0 0 / 0.8);
}

.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-lightSlateGray:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(120 134 155 / var(--tw-text-opacity, 1));
}

.dark\\:text-llightGrayShade:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(6 17 35 / var(--tw-text-opacity, 1));
}

.dark\\:text-llightSlateGray:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(62 81 110 / var(--tw-text-opacity, 1));
}

.dark\\:text-lplatinum:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(9 24 47 / var(--tw-text-opacity, 1));
}

.dark\\:text-lraisinBlack:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(35 35 35 / var(--tw-text-opacity, 1));
}

.dark\\:text-lspaceCadet:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(230 237 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-lspringBud:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 195 49 / var(--tw-text-opacity, 1));
}

.dark\\:text-maastrichtBlue:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(6 17 35 / var(--tw-text-opacity, 1));
}

.dark\\:text-spaceCadet:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(25 50 88 / var(--tw-text-opacity, 1));
}

.dark\\:text-springBud:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 195 49 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:placeholder-black\\/50:is(.dark *)::placeholder {
  color: rgb(0 0 0 / 0.5);
}

.dark\\:shadow-\\[0_0_0_30px_\\#FDFEFF\\]:is(.dark *) {
  --tw-shadow: 0 0 0 30px #FDFEFF;
  --tw-shadow-colored: 0 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-gray-200:is(.dark *) {
  --tw-shadow-color: #e5e7eb;
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:outline-lborder:is(.dark *) {
  outline-color: #DDE7F6;
}

.dark\\:invert:is(.dark *) {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.dark\\:hover\\:border-black:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-maastrichtBlue:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 17 35 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-malachite:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(30 215 96 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-springBud:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(0 195 49 / var(--tw-border-opacity, 1));
}

.hover\\:dark\\:border-black:is(.dark *):hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:\\!bg-lsecondaryHover:hover:is(.dark *) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(181 198 224 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:hover\\:bg-\\[\\#C4170B\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(196 23 11 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-\\[\\#c7ccd4\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(199 204 212 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-\\[\\#d2d8e1\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(210 216 225 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-lightSlateGray:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(120 134 155 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-linsideDiv:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(242 244 247 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-lmaastrichtBlue:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 254 255 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-lsecondaryHover:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(181 198 224 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-lsecondaryHover\\/50:hover:is(.dark *) {
  background-color: rgb(181 198 224 / 0.5);
}

.dark\\:hover\\:bg-lspaceCadet:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(230 237 248 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-lyankeesBlue:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 251 255 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-secondaryHover:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(43 88 155 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-secondaryHover\\/20:hover:is(.dark *) {
  background-color: rgb(43 88 155 / 0.2);
}

.dark\\:hover\\:bg-springBudHover:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 234 19 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-white:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:dark\\:bg-lsecondaryHover:is(.dark *):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(181 198 224 / var(--tw-bg-opacity, 1));
}

.hover\\:dark\\:bg-lspaceCadet:is(.dark *):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 237 248 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:stroke-springBud:hover:is(.dark *) {
  stroke: #00C331;
}

.dark\\:hover\\:text-black:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-gray-700:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-lightSlateGray:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(120 134 155 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-llightSlateGray:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(62 81 110 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-lspaceCadet:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(230 237 248 / var(--tw-text-opacity, 1));
}

.hover\\:dark\\:text-black:is(.dark *):hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-\\[\\#2e2e2e\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(46 46 46 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-black:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-\\[\\#2e2e2e\\]:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(46 46 46 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-black:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-llightSlateGray:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(62 81 110 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-springBud:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(0 195 49 / var(--tw-text-opacity, 1));
}

@media (min-width: 640px) {

  .sm\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .sm\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .sm\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .sm\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:ml-5 {
    margin-left: 1.25rem;
  }

  .sm\\:ml-auto {
    margin-left: auto;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-3 {
    margin-top: 0.75rem;
  }

  .sm\\:mt-\\[0px\\] {
    margin-top: 0px;
  }

  .sm\\:mt-\\[8px\\] {
    margin-top: 8px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:grid {
    display: grid;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-2 {
    height: 0.5rem;
  }

  .sm\\:h-3 {
    height: 0.75rem;
  }

  .sm\\:h-4 {
    height: 1rem;
  }

  .sm\\:h-\\[200px\\] {
    height: 200px;
  }

  .sm\\:h-\\[32px\\] {
    height: 32px;
  }

  .sm\\:h-\\[50px\\] {
    height: 50px;
  }

  .sm\\:h-full {
    height: 100%;
  }

  .sm\\:w-2 {
    width: 0.5rem;
  }

  .sm\\:w-3 {
    width: 0.75rem;
  }

  .sm\\:w-4 {
    width: 1rem;
  }

  .sm\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .sm\\:w-\\[140px\\] {
    width: 140px;
  }

  .sm\\:w-\\[150px\\] {
    width: 150px;
  }

  .sm\\:w-\\[32px\\] {
    width: 32px;
  }

  .sm\\:w-\\[33\\%\\] {
    width: 33%;
  }

  .sm\\:w-\\[400px\\] {
    width: 400px;
  }

  .sm\\:w-\\[450px\\] {
    width: 450px;
  }

  .sm\\:w-\\[66\\%\\] {
    width: 66%;
  }

  .sm\\:w-\\[67\\%\\] {
    width: 67%;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-fit {
    width: fit-content;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:flex-none {
    flex: none;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:p-2 {
    padding: 0.5rem;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .sm\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .sm\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .sm\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .sm\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .sm\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 768px) {

  .md\\:inset-0 {
    inset: 0px;
  }

  .md\\:right-3 {
    right: 0.75rem;
  }

  .md\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .md\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .md\\:me-0 {
    margin-inline-end: 0px;
  }

  .md\\:ms-4 {
    margin-inline-start: 1rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-0\\.5 {
    margin-top: 0.125rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-4 {
    height: 1rem;
  }

  .md\\:h-\\[220px\\] {
    height: 220px;
  }

  .md\\:h-\\[250px\\] {
    height: 250px;
  }

  .md\\:h-\\[260px\\] {
    height: 260px;
  }

  .md\\:h-\\[85px\\] {
    height: 85px;
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-4 {
    width: 1rem;
  }

  .md\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .md\\:w-\\[100px\\] {
    width: 100px;
  }

  .md\\:w-\\[13\\%\\] {
    width: 13%;
  }

  .md\\:w-\\[20\\%\\] {
    width: 20%;
  }

  .md\\:w-\\[23\\%\\] {
    width: 23%;
  }

  .md\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .md\\:w-\\[35\\%\\] {
    width: 35%;
  }

  .md\\:w-\\[350px\\] {
    width: 350px;
  }

  .md\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .md\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .md\\:w-\\[450px\\] {
    width: 450px;
  }

  .md\\:w-\\[49\\%\\] {
    width: 49%;
  }

  .md\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .md\\:w-\\[52\\%\\] {
    width: 52%;
  }

  .md\\:w-\\[550px\\] {
    width: 550px;
  }

  .md\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .md\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-fit {
    width: fit-content;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:max-w-screen-md {
    max-width: 768px;
  }

  .md\\:flex-1 {
    flex: 1 1;
  }

  .md\\:flex-none {
    flex: none;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-0 {
    gap: 0px;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:pl-0 {
    padding-left: 0px;
  }

  .md\\:pt-0 {
    padding-top: 0px;
  }

  .md\\:text-\\[10px\\] {
    font-size: 10px;
  }

  .md\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .md\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .md\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:bottom-\\[0px\\] {
    bottom: 0px;
  }

  .lg\\:top-\\[450px\\] {
    top: 450px;
  }

  .lg\\:top-\\[90\\%\\] {
    top: 90%;
  }

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .lg\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:ml-1 {
    margin-left: 0.25rem;
  }

  .lg\\:ml-2 {
    margin-left: 0.5rem;
  }

  .lg\\:ml-3 {
    margin-left: 0.75rem;
  }

  .lg\\:ml-4 {
    margin-left: 1rem;
  }

  .lg\\:ml-5 {
    margin-left: 1.25rem;
  }

  .lg\\:ms-0 {
    margin-inline-start: 0px;
  }

  .lg\\:ms-auto {
    margin-inline-start: auto;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-1 {
    margin-top: 0.25rem;
  }

  .lg\\:mt-2 {
    margin-top: 0.5rem;
  }

  .lg\\:mt-\\[-3rem\\] {
    margin-top: -3rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-5 {
    height: 1.25rem;
  }

  .lg\\:h-\\[130px\\] {
    height: 130px;
  }

  .lg\\:h-\\[176px\\] {
    height: 176px;
  }

  .lg\\:h-\\[188px\\] {
    height: 188px;
  }

  .lg\\:h-\\[205px\\] {
    height: 205px;
  }

  .lg\\:h-\\[250px\\] {
    height: 250px;
  }

  .lg\\:h-\\[253px\\] {
    height: 253px;
  }

  .lg\\:h-\\[258px\\] {
    height: 258px;
  }

  .lg\\:h-\\[340px\\] {
    height: 340px;
  }

  .lg\\:h-\\[35px\\] {
    height: 35px;
  }

  .lg\\:h-\\[40px\\] {
    height: 40px;
  }

  .lg\\:h-\\[600px\\] {
    height: 600px;
  }

  .lg\\:h-\\[60px\\] {
    height: 60px;
  }

  .lg\\:h-\\[620px\\] {
    height: 620px;
  }

  .lg\\:h-\\[70px\\] {
    height: 70px;
  }

  .lg\\:h-\\[84vh\\] {
    height: 84vh;
  }

  .lg\\:h-\\[92vh\\] {
    height: 92vh;
  }

  .lg\\:h-\\[96vh\\] {
    height: 96vh;
  }

  .lg\\:max-h-\\[100px\\] {
    max-height: 100px;
  }

  .lg\\:max-h-\\[75vh\\] {
    max-height: 75vh;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }

  .lg\\:w-2\\/3 {
    width: 66.666667%;
  }

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:w-3\\/5 {
    width: 60%;
  }

  .lg\\:w-5 {
    width: 1.25rem;
  }

  .lg\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .lg\\:w-\\[15\\%\\] {
    width: 15%;
  }

  .lg\\:w-\\[18\\%\\] {
    width: 18%;
  }

  .lg\\:w-\\[190px\\] {
    width: 190px;
  }

  .lg\\:w-\\[20\\%\\] {
    width: 20%;
  }

  .lg\\:w-\\[212px\\] {
    width: 212px;
  }

  .lg\\:w-\\[25\\%\\] {
    width: 25%;
  }

  .lg\\:w-\\[26\\%\\] {
    width: 26%;
  }

  .lg\\:w-\\[272px\\] {
    width: 272px;
  }

  .lg\\:w-\\[276px\\] {
    width: 276px;
  }

  .lg\\:w-\\[28\\%\\] {
    width: 28%;
  }

  .lg\\:w-\\[280px\\] {
    width: 280px;
  }

  .lg\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .lg\\:w-\\[300px\\] {
    width: 300px;
  }

  .lg\\:w-\\[32\\%\\] {
    width: 32%;
  }

  .lg\\:w-\\[320px\\] {
    width: 320px;
  }

  .lg\\:w-\\[330px\\] {
    width: 330px;
  }

  .lg\\:w-\\[360px\\] {
    width: 360px;
  }

  .lg\\:w-\\[380px\\] {
    width: 380px;
  }

  .lg\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .lg\\:w-\\[400px\\] {
    width: 400px;
  }

  .lg\\:w-\\[41\\%\\] {
    width: 41%;
  }

  .lg\\:w-\\[41\\.2\\%\\] {
    width: 41.2%;
  }

  .lg\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .lg\\:w-\\[450px\\] {
    width: 450px;
  }

  .lg\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .lg\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .lg\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .lg\\:w-\\[600px\\] {
    width: 600px;
  }

  .lg\\:w-\\[70\\%\\] {
    width: 70%;
  }

  .lg\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .lg\\:w-\\[85\\%\\] {
    width: 85%;
  }

  .lg\\:w-\\[978px\\] {
    width: 978px;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-fit {
    width: fit-content;
  }

  .lg\\:min-w-\\[130px\\] {
    min-width: 130px;
  }

  .lg\\:max-w-screen-lg {
    max-width: 1024px;
  }

  .lg\\:flex-grow-0 {
    flex-grow: 0;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:justify-evenly {
    justify-content: space-evenly;
  }

  .lg\\:gap-0 {
    gap: 0px;
  }

  .lg\\:gap-3 {
    gap: 0.75rem;
  }

  .lg\\:gap-8 {
    gap: 2rem;
  }

  .lg\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .lg\\:border-b {
    border-bottom-width: 1px;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:pb-0 {
    padding-bottom: 0px;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .lg\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .lg\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .lg\\:text-\\[38px\\] {
    font-size: 38px;
  }

  .lg\\:text-\\[60px\\] {
    font-size: 60px;
  }

  .lg\\:font-semibold {
    font-weight: 600;
  }
}

@media (min-width: 1280px) {

  .xl\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .xl\\:max-w-screen-xl {
    max-width: 1280px;
  }

  .xl\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

.peer:checked ~ .rtl\\:peer-checked\\:after\\:-translate-x-full:where([dir="rtl"], [dir="rtl"] *)::after {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.\\[\\&_\\.toastui-editor-contents_\\*\\]\\:text-lspaceCadet .toastui-editor-contents * {
  --tw-text-opacity: 1;
  color: rgb(230 237 248 / var(--tw-text-opacity, 1));
}

.dark\\:\\[\\&_\\.toastui-editor-contents_\\*\\]\\:text-lightSlateGray .toastui-editor-contents *:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(120 134 155 / var(--tw-text-opacity, 1));
}

.\\[\\&_img\\]\\:h-\\[120px\\] img {
  height: 120px;
}

.\\[\\&_img\\]\\:w-\\[150px\\] img {
  width: 150px;
}

.\\[\\&_span\\]\\:\\!bg-transparent span {
  background-color: transparent !important;
}

.\\[\\&_span\\]\\:\\!text-white span {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:\\[\\&_span\\]\\:\\!text-black span:is(.dark *) {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B;;AAA1B;EAAA,wBAA0B;EAA1B,wBAA0B;EAA1B,mBAA0B;EAA1B,mBAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,cAA0B;EAA1B,eAA0B;EAA1B,eAA0B;EAA1B,aAA0B;EAA1B,aAA0B;EAA1B,kBAA0B;EAA1B,sCAA0B;EAA1B,8BAA0B;EAA1B,6BAA0B;EAA1B,4BAA0B;EAA1B,eAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,kBAA0B;EAA1B,2BAA0B;EAA1B,4BAA0B;EAA1B,sCAA0B;EAA1B,kCAA0B;EAA1B,2BAA0B;EAA1B,sBAA0B;EAA1B,8BAA0B;EAA1B,YAA0B;EAA1B,kBAA0B;EAA1B,gBAA0B;EAA1B,iBAA0B;EAA1B,kBAA0B;EAA1B,cAA0B;EAA1B,gBAA0B;EAA1B,aAA0B;EAA1B,mBAA0B;EAA1B,qBAA0B;EAA1B,2BAA0B;EAA1B,yBAA0B;EAA1B,0BAA0B;EAA1B,2BAA0B;EAA1B,uBAA0B;EAA1B,wBAA0B;EAA1B,yBAA0B;EAA1B,sBAA0B;EAA1B,oBAA0B;EAA1B,sBAA0B;EAA1B,qBAA0B;EAA1B;AAA0B,CAA1B;;CAA0B,CAA1B;;;CAA0B;;AAA1B;;;EAAA,sBAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,mBAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;EAAA,gBAA0B;AAAA;;AAA1B;;;;;;;;CAA0B;;AAA1B;;EAAA,gBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B,EAA1B,MAA0B;EAA1B,WAA0B,EAA1B,MAA0B;EAA1B,+HAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,wCAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,SAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,yCAA0B;UAA1B,iCAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;EAAA,kBAA0B;EAA1B,oBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,mBAA0B;AAAA;;AAA1B;;;;;CAA0B;;AAA1B;;;;EAAA,+GAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,+BAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,cAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,cAA0B;EAA1B,cAA0B;EAA1B,kBAA0B;EAA1B,wBAA0B;AAAA;;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;EAAA,WAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,qBAA0B,EAA1B,MAA0B;EAA1B,yBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;EAAA,oBAA0B,EAA1B,MAA0B;EAA1B,8BAA0B,EAA1B,MAA0B;EAA1B,gCAA0B,EAA1B,MAA0B;EAA1B,eAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;EAA1B,uBAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;EAA1B,SAA0B,EAA1B,MAA0B;EAA1B,UAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,oBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;;;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,6BAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,aAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,YAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,6BAA0B,EAA1B,MAA0B;EAA1B,oBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,wBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;EAAA,0BAA0B,EAA1B,MAA0B;EAA1B,aAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,kBAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;;;;;;;;;;;;EAAA,SAA0B;AAAA;;AAA1B;EAAA,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;;EAAA,gBAA0B;EAA1B,SAA0B;EAA1B,UAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,UAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;EAAA,gBAA0B;AAAA;;AAA1B;;;CAA0B;;AAA1B;;EAAA,UAA0B,EAA1B,MAA0B;EAA1B,cAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;AAAA;;AAA1B;;CAA0B;AAA1B;EAAA,eAA0B;AAAA;;AAA1B;;;;CAA0B;;AAA1B;;;;;;;;EAAA,cAA0B,EAA1B,MAA0B;EAA1B,sBAA0B,EAA1B,MAA0B;AAAA;;AAA1B;;CAA0B;;AAA1B;;EAAA,eAA0B;EAA1B,YAA0B;AAAA;;AAA1B,wEAA0B;AAA1B;EAAA,aAA0B;AAAA;AAC1B;EAAA;AAAgC;AAAhC;EAAA;AAAgC;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAAhC;;EAAA;IAAA;EAAgC;;EAAhC;IAAA;EAAgC;AAAA;AAChC;EAAA,kBAA+B;EAA/B,UAA+B;EAA/B,WAA+B;EAA/B,UAA+B;EAA/B,YAA+B;EAA/B,gBAA+B;EAA/B,sBAA+B;EAA/B,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,QAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,oBAA+B;EAA/B,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,yBAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,yBAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,yBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,0BAA+B;EAA/B;AAA+B;AAA/B;EAAA,yBAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B,eAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA,mBAA+B;IAA/B;EAA+B;;EAA/B;IAAA,qBAA+B;IAA/B;EAA+B;;EAA/B;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA,0BAA+B;IAA/B;EAA+B;;EAA/B;IAAA,wBAA+B;IAA/B;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,yBAA+B;UAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,oDAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,oCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B;AAA+B;AAA/B;EAAA,gCAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iCAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,iEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,8DAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,iEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,oEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,yDAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,4DAA+B;EAA/B,iEAA+B;EAA/B;AAA+B;AAA/B;EAAA,gEAA+B;EAA/B,+DAA+B;EAA/B;AAA+B;AAA/B;EAAA,2EAA+B;EAA/B,qEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,sEAA+B;EAA/B;AAA+B;AAA/B;EAAA,kEAA+B;EAA/B;AAA+B;AAA/B;EAAA,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA,gEAA+B;EAA/B;AAA+B;AAA/B;EAAA,mEAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,qBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,gBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,iBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,eAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA,kBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,0EAA+B;EAA/B,8FAA+B;EAA/B;AAA+B;AAA/B;EAAA,gDAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,8CAA+B;EAA/B,6DAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,0CAA+B;EAA/B,sDAA+B;EAA/B;AAA+B;AAA/B;EAAA,6CAA+B;EAA/B,4DAA+B;EAA/B;AAA+B;AAA/B;EAAA,+EAA+B;EAA/B,mGAA+B;EAA/B;AAA+B;AAA/B;EAAA,6EAA+B;EAA/B,iGAA+B;EAA/B;AAA+B;AAA/B;EAAA,sBAA+B;EAA/B,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA,0CAA+B;EAA/B,uDAA+B;EAA/B;AAA+B;AAA/B;EAAA,gFAA+B;EAA/B,oGAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA,mCAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,2GAA+B;EAA/B,yGAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,oBAA+B;EAA/B;AAA+B;AAA/B;EAAA,+BAA+B;EAA/B;AAA+B;AAA/B;EAAA,yBAA+B;EAA/B;AAA+B;AAA/B;EAAA,uBAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,6BAA+B;EAA/B;AAA+B;AAA/B;EAAA,wJAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,qCAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,2BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,wBAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,+FAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA,4BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA,8BAA+B;EAA/B,wDAA+B;EAA/B;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AAA/B;EAAA;AAA+B;AA8tB7B;IACE;MACE,4BAA4B;IAC9B;;IAEA;MACE,wBAAwB;IAC1B;EACF;AAEA;IACE,0CAA0C;EAC5C;AAqhBA;IACE;;MAEE,qBAAqB;MACrB,YAAY;IACd;;IAEA;MACE,qBAAqB;MACrB,UAAU;IACZ;EACF;AAEA;IACE,8CAA8C;EAChD;AAEA;IACE,oBAAoB;EACtB;AAEA;IACE,sBAAsB;EACxB;AAEA;IACE,sBAAsB;EACxB;AAEA;IACE,sBAAsB;EACxB;;AAzxCF;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,4CAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,4CAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,4CAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,4CAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,4CAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,4CAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,4CAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,4CAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,4CAAgC;AAClC;;AAEA;;GAEG;AACH;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kEAAkE;EAClE,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;EAK5B,uBAAuB;AAHzB;;AAMA,gCAAgC;AAChC;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,SAAS;AACT;;GAEG;;AAEH;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;GAGG;;AAEH;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAKE,gBAAgB;AAHlB;;AAMA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,yBAAyB;AACzB,UAAU;AACV;EACE,UAAU;EACV,SAAS;EACT,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,0CAA0C;EAC1C,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,WAAW;;AAEX;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,+BAA+B;AAC/B;EACE,wBAAwB;AAC1B;;AAGE;EAAA,kBAAqE;EAArE,8BAAqE;EAArE,mBAAqE;EAArE,2GAAqE;EAArE,yGAAqE;EAArE;AAAqE;;AAArE;EAAA,kBAAqE;EAArE,2GAAqE;EAArE,yGAAqE;EAArE;AAAqE;;AAGvE;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAkBA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;;;;;;GAOG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAGE;EAAA,kBAAyB;EAAzB,mBAAyB;EAAzB;AAAyB;;AAIzB;EAAA,mBAA6B;EAA7B,oBAA6B;EAA7B;AAA6B;;AAI7B;EAAA,iBAA6B;EAA7B,iBAA6B;EAA7B;AAA6B;;AAI7B;EAAA,kBAA0B;EAA1B,oBAA0B;EAA1B;AAA0B;;AAI1B;EAAA,mBAA0B;EAA1B,oBAA0B;EAA1B;AAA0B;;AAI1B;EAAA,eAA4B;EAA5B,mBAA4B;EAA5B;AAA4B;;AAG9B;;;;EAIE,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;EAChE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gEAAgE;EAChE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gEAAgE;EAChE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,oCAAoC;EACpC,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,mCAAmC;AACnC;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;;GASG;AACH;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;;EAGE,yCAAyC;EACzC,iDAAiD;EACjD,yDAAyD;EACzD,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA,aAAa;AACb;;;EAGE,4BAA4B;EAC5B,iCAAiC;EACjC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;;;EAGE,4BAA4B;EAC5B,iCAAiC;EACjC,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;GAEG;;AAEH;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC;2BACyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,mDAAmD;AACnD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;GAEG;;AAEH;;GAEG;;AAqCH;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;;;;;;;;GAQG;;AAEH;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,8CAA8C;AAC9C;EACE,SAAS;EACT,eAAe;EACf,SAAS;EACT,wBAAwB;EACxB,QAAQ;EACR,sCAAsC;EACtC,QAAQ;EACR,oCAAoC;;EAEpC,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB;wCACsC;EACtC,0EAA0E;EAC1E,2BAA2B;EAC3B;;;;;;0CAMwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgCG;;AAEH;EACE;;;;GAIC;EACD,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE;;;;GAIC;EACD,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE;;;;GAIC;EACD,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,4BAA4B;;AAE5B,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;;AAE7B;;GAEG;;AAEH;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;;;;GAIC;EACD,qBAAqB;AACvB;;AAEA;EACE,4EAA4E;EAC5E,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gEAAgE;EAChE;;6BAE2B;EAE3B,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;;EAEpB,UAAU;EACV,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;GAKG;AACH,YAAY;AACZ;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;;IAEE,wCAAwC;IACxC,eAAe;EACjB;;EAEA;IACE,4CAA4C;IAC5C,yBAAyB;EAC3B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,uEAAuE;EACvE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,uDAAuD;AACzD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;;EAEvB,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;;EAEE,yBAAyB;AAC3B;;AAEA,oGAAoG;AACpG;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;;;;;;;;;EASE,sEAAsE;EACtE,wDAAwD;EACxD,yDAAiD;EAAjD,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qEAAkE;AACpE;;AAEA;EACE,qEAAwE;AAC1E;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,uDAAuD;AACvD;;EAEE,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;;;;;;;;GAQG;;AAEH;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;;;;;;EAWE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAjtEA;EAAA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA,wBAktEA;EAltEA,wDAktEA;EAltEA;AAktEA;;AAltEA;EAAA,gBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,2GAktEA;EAltEA,yGAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,iBAktEA;EAltEA,iBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,gBAktEA;EAltEA,gBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,gBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,6BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,6BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,6BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,6BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,+BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,8BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,2GAktEA;EAltEA,yGAktEA;EAltEA;AAktEA;;AAltEA;EAAA,2GAktEA;EAltEA,yGAktEA;EAltEA;AAktEA;;AAltEA;EAAA,2GAktEA;EAltEA,yGAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,2GAktEA;EAltEA,yGAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,uBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,qBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,qBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,eAktEA;EAltEA,eAktEA;EAltEA;AAktEA;;AAltEA;EAAA,iBAktEA;EAltEA,iBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,iBAktEA;EAltEA,iBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,iBAktEA;EAltEA,iBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,iBAktEA;EAltEA,iBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,eAktEA;EAltEA,eAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,2BAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,qBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,uBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,iBAktEA;EAltEA,iBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,4DAktEA;EAltEA,qEAktEA;EAltEA;AAktEA;;AAltEA;EAAA,4DAktEA;EAltEA,qEAktEA;EAltEA;AAktEA;;AAltEA;EAAA,4DAktEA;EAltEA,qEAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sEAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sEAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sEAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sEAktEA;EAltEA;AAktEA;;AAltEA;EAAA,gEAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,+BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,+BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,+BAktEA;EAltEA,sDAktEA;EAltEA;AAktEA;;AAltEA;EAAA,0BAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,yBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,sBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,6BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,kBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;;EAAA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA,iBAktEA;IAltEA;EAktEA;;EAltEA;IAAA,kBAktEA;IAltEA;EAktEA;;EAltEA;IAAA,oBAktEA;IAltEA;EAktEA;;EAltEA;IAAA,gBAktEA;IAltEA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA,eAktEA;IAltEA;EAktEA;;EAltEA;IAAA,mBAktEA;IAltEA;EAktEA;;EAltEA;IAAA,kBAktEA;IAltEA;EAktEA;AAAA;;AAltEA;;EAAA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA,gBAktEA;IAltEA;EAktEA;;EAltEA;IAAA,kBAktEA;IAltEA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA,eAktEA;IAltEA;EAktEA;AAAA;;AAltEA;;EAAA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA,iBAktEA;IAltEA;EAktEA;;EAltEA;IAAA,kBAktEA;IAltEA;EAktEA;;EAltEA;IAAA,oBAktEA;IAltEA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA,iBAktEA;IAltEA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;AAAA;;AAltEA;;EAAA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;;EAltEA;IAAA;EAktEA;AAAA;;AAltEA;EAAA,0BAktEA;EAltEA,uBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA,oBAktEA;EAltEA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA;AAktEA;;AAltEA;EAAA,+BAktEA;EAltEA;AAktEA;;AAltEA;EAAA,+BAktEA;EAltEA;AAktEA","sourcesContent":["@import \"tailwindcss/base\";\n@import \"tailwindcss/components\";\n@import \"tailwindcss/utilities\";\n\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap\");\n\n* > * {\n  font-family: \"Inter\", sans-serif;\n}\n\n@font-face {\n  font-family: Gebes;\n  src: url(\"./Fonts/Gebes.ttf\");\n}\n\n@font-face {\n  font-family: AudiowideRegular;\n  src: url(\"./Fonts/AudiowideRegular.ttf\");\n}\n\n@font-face {\n  font-family: BebasNeue;\n  src: url(\"./Fonts/BebasNeue-Regular.ttf\");\n}\n\n@font-face {\n  font-family: goodtime;\n  src: url(\"./Fonts/Good\\ Times\\ Rg.otf\");\n}\n\n@font-face {\n  font-family: Digital7;\n  src: url(\"./Fonts/digital-7.ttf\");\n}\n\n@font-face {\n  font-family: bartomes;\n  src: url(\"./Fonts/Bartomes.otf\");\n}\n\n@font-face {\n  font-family: antonsc;\n  src: url(\"./Fonts/AntonSC-Regular.ttf\");\n}\n\n@font-face {\n  font-family: jaro;\n  src: url(\"./Fonts//Jaro-Regular-VariableFont_opsz.ttf\");\n}\n\n@font-face {\n  font-family: boxigen;\n  src: url(\"./Fonts//BOXIGEN.ttf\");\n}\n\n/* html {\n  height: 100%;\n} */\nbody {\n  overflow: hidden !important;\n}\n\n.light {\n  min-height: 100vh;\n  display: flex;\n  /* background: linear-gradient(45deg, #03184f 0%, #010000 100%); */\n  background-color: #020716;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  color: white;\n}\n\n.light {\n  color: white !important;\n}\n\n/* .dark .ReactTags__selected, */\n.dark .css-2zzet4-control,\n.dark .css-1hd0s6e-control,\n.dark .css-4byitl-menu {\n  background: #dde2e7 !important;\n}\n\n.dark {\n  color: black !important;\n}\n\n.dark h1 {\n  color: #ffffff !important;\n}\n\n.dark {\n  min-height: 100vh;\n  display: flex;\n  background: #f1f2f7;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  color: white;\n}\n\n#root {\n  flex-grow: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow-y: auto;\n}\n\n.App {\n  width: 100%;\n  height: 100vh;\n  max-width: 1280px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\ninput,\ntextarea {\n  padding-left: 10px;\n}\n\n.rti--container {\n  /* background: transparent !important; */\n  background: transparent;\n  border: 1px solid #14243e !important;\n  border-radius: 2px !important;\n  padding: 5px !important;\n  min-height: 40px !important;\n}\n\n.rti--tag {\n  color: #fff !important;\n  background-color: #14243e !important;\n}\n\n.rti--input {\n  /* background: transparent !important; */\n  background: transparent;\n  font-size: small;\n}\n\ninput[type=\"checkbox\"] {\n  background-color: transparent;\n  accent-color: #00c310;\n  border: 1px solid #00c310;\n  border-radius: 2px;\n}\n\ninput[type=\"checkbox\"]:not(:checked) {\n  background-color: transparent;\n}\n\n/* dark */\n/* .dark .toastui-editor {\n  background: #dde2e7;\n} */\n\n.dark .toastui-editor-contents blockquote,\n.dark .toastui-editor-contents ol li,\n.dark .toastui-editor-contents ul li {\n  color: #ffffff !important;\n}\n\n.dark .ProseMirror p,\n.dark .ProseMirror h1,\n.dark .ProseMirror h2,\n.dark .ProseMirror h3,\n.dark .ProseMirror h4,\n.dark .ProseMirror h5,\n.dark .ProseMirror h6 {\n  color: #000 !important;\n  /* background: #dde2e7 !important; */\n}\n\n/* .dark .toastui-editor {\n  color: #fff !important;\n  background: #dde2e7 !important;\n} */\n\n.dark .toastui-editor-toolbar-icons::after {\n  font-weight: bold;\n  font-size: 12px;\n  color: black;\n  font-family: \"Font Awesome 5 Free\";\n}\n\n.dark .toastui-editor-defaultUI-toolbar {\n  /* background: #dde2e7 !important; */\n  border: 0px !important;\n  /* border-radius: 10px !important; */\n}\n\n.dark .toastui-editor-md-tab-container {\n  background: #dde2e7 !important;\n}\n\n.dark .toastui-editor-toolbar-divider {\n  display: none !important;\n}\n\n.dark .toastui-editor-defaultUI-toolbar {\n  border: 1px solid #bec8d5 !important;\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n  padding-left: 5px !important;\n}\n\n.toastui-editor-defaultUI-toolbar {\n  border: 1px solid #193258 !important;\n}\n\n.dark button[aria-label=\"F\"] {\n  color: #000 !important;\n  font-weight: bold;\n  height: 20px !important;\n  width: 20px !important;\n  font-size: 12px !important;\n}\n\n.dark .apexcharts-legend-text {\n  color: black !important;\n}\n\n.apexcharts-legend {\n  max-height: 340px !important;\n  overflow-y: auto !important;\n}\n\n/* light */\n.light .toastui-editor {\n  background: #14243e;\n}\n\n/* makes scrolling buttery smooth */\n.scroll-smooth {\n  scroll-behavior: smooth;\n}\n\n/* safari/iOS momentum scroll */\n.momentum-scroll {\n  -webkit-overflow-scrolling: touch;\n}\n\n.no-click {\n  pointer-events: none;\n  opacity: 1 !important;\n}\n\n.size-input {\n  display: none !important;\n}\n\n.light .toastui-editor-contents blockquote,\n.light .toastui-editor-contents ol li,\n.light .toastui-editor-contents ul li {\n  color: #ffffff !important;\n}\n\n.light .ProseMirror p,\n.light .ProseMirror h1,\n.light .ProseMirror h2,\n.light .ProseMirror h3,\n.light .ProseMirror h4,\n.light .ProseMirror h5,\n.light .ProseMirror h6 {\n  color: #fff !important;\n  /* background: #14243e !important; */\n}\n\n.light .toastui-editor {\n  color: #fff !important;\n  /* background: #14243e !important; */\n}\n\n.light .toastui-editor-defaultUI-toolbar {\n  background: #09182f !important;\n  border: 0px !important;\n}\n\n.light .toastui-editor-toolbar-icons {\n  /* background: transparent !important; */\n  background: transparent;\n}\n\n.toastui-editor-toolbar-icons {\n  height: 20px !important;\n  width: 20px !important;\n}\n\n.light .toastui-editor-md-tab-container {\n  background: #bec8d5 !important;\n}\n\n.light .toastui-editor-toolbar-icons::after {\n  font-weight: bold;\n  font-size: 12px;\n  color: white;\n  font-family: \"Font Awesome 5 Free\";\n}\n\n.toastui-editor-toolbar-group .heading::after {\n  content: \"H\";\n}\n\n.toastui-editor-toolbar-group .bold::after {\n  content: \"B\";\n}\n\n.toastui-editor-toolbar-group .italic::after {\n  content: \"I\";\n}\n\n.color::after {\n  content: \"A\";\n}\n\n.toastui-editor-toolbar-divider {\n  display: none !important;\n}\n\n.light .toastui-editor-defaultUI-toolbar {\n  border: 1px solid #193258 !important;\n  padding-top: 5px !important;\n  padding-bottom: 5px !important;\n  padding-left: 5px !important;\n}\n\n.light button[aria-label=\"F\"] {\n  color: #fff !important;\n  font-weight: bold;\n  height: 20px !important;\n  width: 20px !important;\n  font-size: 12px !important;\n}\n\n.custom-button::after {\n  content: \"F\";\n}\n\n.strike::after {\n  content: \"S\";\n  text-decoration: line-through;\n}\n\n.hrline::after {\n  content: \"\\f068\";\n}\n\n.quote::after {\n  content: \"\\f10e\";\n}\n\n.bullet-list::after {\n  content: \"\\f03a\";\n}\n\n.bullet-list::after {\n  content: \"\\f03a\";\n}\n\n.ordered-list::after {\n  content: \"\\f0cb\";\n}\n\n.task-list::after {\n  content: \"\\f14a\";\n}\n\n.indent::after {\n  font-family: \"Font Awesome 5 Free\";\n  content: \"\\f03c\";\n  font-weight: 900;\n  color: #ff0000 !important;\n}\n\n.outdent::after {\n  content: \"\\f03b\";\n}\n\n.table::after {\n  content: \"\\f0ce\";\n}\n\n.image::after {\n  content: \"\\f03e\";\n}\n\n.link::after {\n  content: \"\\f0c1\";\n}\n\n.code::after {\n  content: \"\\f121\";\n}\n\n.codeblock::after {\n  content: \"CB\";\n}\n\n.toastui-editor-popup-body {\n  color: #fff !important;\n  background: #061123 !important;\n}\n\nbody.dark .toastui-editor-popup-body {\n  color: #000 !important;\n  background: #f8fbff !important;\n}\n\n.toastui-editor-defaultUI {\n  border: 0px !important;\n}\n\n.toastui-editor-contents table th,\n.toastui-editor-contents table td {\n  border: 1px solid #fff !important;\n  color: #fff !important;\n}\n\n.toastui-editor-contents table td p {\n  color: #ffffff !important;\n}\n\n.toastui-editor-toolbar-icons {\n  background: none !important;\n}\n\n.more::after {\n  content: \"...\";\n}\n\n.toastui-editor-dropdown-toolbar {\n  background: #09182f !important;\n}\n\n.icon-wrapper {\n  display: inline-block;\n  cursor: pointer;\n  transition: transform 0.5s ease;\n  transform-origin: center;\n}\n\n.rotate {\n  transform: rotate(180deg);\n}\n\n/* loader */\n.load-container {\n  position: absolute;\n  margin: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 60px;\n  height: 100px;\n}\n\n.blocks {\n  position: relative;\n  z-index: 1000;\n  width: 6px;\n  height: 30px;\n  margin-left: 6px;\n  float: left;\n  background-color: #00c310;\n  animation: spiner 1s infinite ease-in-out;\n}\n\n.blocks:first-child {\n  margin-left: 0;\n}\n\n.b-one {\n  animation-delay: -1s;\n}\n\n.b-two {\n  animation-delay: -0.9s;\n}\n\n.b-three {\n  animation-delay: -0.8s;\n}\n\n.b-four {\n  animation-delay: -0.7s;\n}\n\n.b-five {\n  animation-delay: -0.6s;\n}\n\n@keyframes spiner {\n  0% {\n    transform: scaleY(1);\n  }\n\n  50% {\n    transform: scaleY(2);\n  }\n\n  100% {\n    transform: scaleY(1);\n  }\n}\n\n.spinner {\n  border-top-color: transparent;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* customize scroll bar */\n/* width */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 0;\n  cursor: default !important;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px grey;\n  background: grey;\n  border-radius: 10px;\n  cursor: default !important;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #14243e;\n  border-radius: 10px;\n  cursor: default !important;\n}\n\n.dark ::-webkit-scrollbar-thumb {\n  background: #bec8d5 !important;\n  cursor: default !important;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #14243e;\n  cursor: default !important;\n}\n\n.dark ::-webkit-scrollbar-thumb:hover {\n  background: #bec8d5 !important;\n}\n\n.apexcharts-tooltip-marker {\n  background-color: #ffc107 !important;\n}\n\n.ReactTags__selected {\n  display: flex;\n  flex-wrap: wrap !important;\n  /* border: 1px solid #193258 !important; */\n  color: #fff !important;\n  min-height: 40px !important;\n  align-items: center !important;\n  font-size: 14px !important;\n  gap: 10px;\n}\n\n.ReactTags__tagInput .ReactTags__tagInputField {\n  background-color: transparent !important;\n  border: 0px !important;\n  height: 36px;\n  width: 100%;\n  max-width: 100px;\n}\n\n.react-tags-active .ReactTags__tagInput input:focus {\n  outline: none !important;\n  border: transparent !important;\n  box-shadow: none !important;\n}\n\n.ReactTags__selected .ReactTags__tagInput .ReactTags__tagInputField:focus {\n  outline: none !important;\n  border: transparent !important;\n  box-shadow: none !important;\n}\n\n.ReactTags__remove {\n  margin-left: 11px !important;\n  width: 12px !important;\n  height: 12px !important;\n}\n\n.ReactTags__tag {\n  padding: 5px !important;\n  border: 1px solid #193258;\n  border-radius: 4px;\n  cursor: default !important;\n}\n\n.ReactTags__suggestions li {\n  border: 1px solid #193258;\n  margin-top: 2px;\n  cursor: pointer;\n  height: 40px;\n  border-radius: 4px;\n  padding: 10px;\n}\n\n.dark .ReactTags__suggestions li {\n  border: 1px solid #bec8d5;\n  color: black;\n}\n\n.ReactTags__suggestions {\n  z-index: 9999;\n  position: absolute;\n  background-color: #14243e !important;\n  width: 100%;\n  max-width: 250px;\n  height: auto !important;\n  max-height: 40vh !important;\n  overflow-y: auto;\n}\n\n.dark .ReactTags__suggestions {\n  background-color: #f0f2f5 !important;\n}\n\n.react-datepicker-popper {\n  z-index: 9999 !important;\n}\n\nbody.dark .vector {\n  filter: hue-rotate(100deg) saturate(9%) brightness(451%) !important;\n}\n\nbody:not(.dark) .vector {\n  filter: none !important;\n  /* No filter in light mode */\n}\n\nbody.dark .vector-44 {\n  filter: hue-rotate(100deg) saturate(9%) brightness(330%) !important;\n}\n\nbody:not(.dark) .vector-44 {\n  filter: none !important;\n  /* No filter in light mode */\n}\n\nbody.dark .pics {\n  filter: hue-rotate(20deg) saturate(9%) brightness(250%) !important;\n}\n\n.animate-btn:hover {\n  background: rgba(25, 50, 88, 1);\n}\n\nbody.dark .animate-btn:hover {\n  background: #e2e8f2;\n}\n\n.w-heatmap {\n  color: #ffffff !important;\n}\n\n.w-heatmap > rect {\n  display: none !important;\n}\n\nbody.dark .w-heatmap text {\n  fill: #000 !important;\n}\n\n/* loader */\n\n.loader {\n  width: 25px;\n  height: 25px;\n  border: 5px dotted white;\n  border-radius: 50%;\n  display: inline-block;\n  position: relative;\n  box-sizing: border-box;\n  animation: rotation 2s linear infinite;\n}\n\n.dark .loader {\n  border: 5px dotted black;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* hide reveal button in edge */\n::-ms-reveal {\n  display: none !important;\n}\n\n.custom-react-tags input {\n  @apply border-none outline-none ring-0 focus:ring-0 focus:border-none;\n}\n\n.tag-wrapper {\n  margin-left: 6px;\n  height: 24px !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #193258;\n}\n\nbody.dark .tag-wrapper {\n  background-color: #4b5058;\n}\n\n.ReactTags__remove {\n  margin-left: 5rem;\n}\n\n@layer utilities {\n  @keyframes slide-in {\n    0% {\n      transform: translateX(-100%);\n    }\n\n    100% {\n      transform: translateX(0);\n    }\n  }\n\n  .animate-slide-in {\n    animation: slide-in 0.7s ease-out forwards;\n  }\n}\n\ninput[type=\"file\"]::-webkit-file-upload-button {\n  /* chromes and blink button */\n  cursor: pointer;\n}\n\n/* @keyframes slide-left {\n  from {\n    transform: translateX(120%);\n  }\n  to {\n    transform: translateX(-170%);\n  }\n} */\n\ninput[type=\"text\"]::placeholder {\n  color: #78869b !important;\n}\n\ninput[type=\"text\"],\ninput[type=\"number\"],\ninput[type=\"password\"],\ntextarea {\n  background: transparent;\n  font-size: 14px !important;\n  color: #dddddd !important;\n}\n\n.inputHr:focus {\n  border-color: #00c310 !important;\n  /* springBud */\n  outline: none !important;\n  /* remove default browser outline */\n}\n\ninput[type=\"text\"].correct-border {\n  border: 1px solid #00c310 !important;\n  /* springBud */\n}\n\ninput[type=\"text\"].incorrect-border {\n  border: 1px solid #ef4444 !important;\n  /* red-500 */\n}\n\ninput[type=\"text\"].default-border {\n  border: 1px solid #193258 !important;\n}\n\nh1 {\n  @apply text-4xl font-bold;\n}\n\nh2 {\n  @apply text-3xl font-semibold;\n}\n\nh3 {\n  @apply text-2xl font-semibold;\n}\n\nh4 {\n  @apply text-xl font-medium;\n}\n\nh5 {\n  @apply text-lg font-medium;\n}\n\nh6 {\n  @apply text-base font-medium;\n}\n\nbody.dark input[type=\"text\"],\nbody.dark input[type=\"number\"],\nbody.dark input[type=\"password\"],\nbody.dark textarea {\n  color: black !important;\n}\n\nbody.dark .react-gauge-component .value-text,\nbody.dark .react-gauge-component .value-text text {\n  fill: #000 !important;\n  /* Black in dark mode */\n}\n\nbody:not(.dark) .react-gauge-component .value-text,\nbody:not(.dark) .react-gauge-component .value-text text {\n  fill: #fff !important;\n  /* White in light mode */\n}\n\n/* src/styles/ApexCharts.css */\nbody.dark .apexcharts-tooltip {\n  background: #1f2937 !important;\n  color: #fff !important;\n  border: none !important;\n}\n\nbody.dark .apexcharts-tooltip * {\n  color: #fff !important;\n}\n\nbody:not(.dark) .apexcharts-tooltip {\n  background: #fff !important;\n  color: #000 !important;\n}\n\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n  filter: invert(68%) sepia(15%) saturate(300%) hue-rotate(180deg);\n  opacity: 0.8;\n  cursor: pointer;\n}\n\ninput[type=\"time\"]::-webkit-calendar-picker-indicator {\n  filter: invert(68%) sepia(15%) saturate(300%) hue-rotate(180deg);\n  opacity: 0.8;\n  cursor: pointer;\n}\n\ninput[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n  filter: invert(68%) sepia(15%) saturate(300%) hue-rotate(180deg);\n  opacity: 0.8;\n  cursor: pointer;\n}\n\nbody.dark .apexcharts-tooltip-title {\n  background-color: #2b313a !important;\n  color: #fff !important;\n}\n\nbody.dark .cve-logo {\n  fill: #000;\n  stroke: #000;\n}\n\nbody.dark .object-contain path {\n  fill: #78869b;\n  stroke: #fff;\n}\n\n.noBorder input {\n  outline: none !important;\n  border: none !important;\n}\n\n.noBorder input[type=\"text\"]:focus {\n  border: none !important;\n  outline: none !important;\n}\n\ninput[type=\"radio\"]:checked {\n  accent-color: #00c331 !important;\n}\n\n.dark input[type=\"radio\"]:checked {\n  accent-color: #00c331 !important;\n}\n\n.css-1xbattx-container {\n  width: 100% !important;\n}\n\n::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n}\n\ninput[type=\"text\"]:focus:not(.ticketInput),\ninput[type=\"password\"]:focus,\ntextarea:focus {\n  border: 1px solid #00c310 !important;\n  border-radius: 4px !important;\n  outline: none !important;\n}\n\n#customTagInput {\n  border: none !important;\n}\n\ninput[type=\"text\"]:focus + label,\ninput[type=\"password\"]:focus + label,\ntextarea:focus + label {\n  color: #00c310 !important;\n  font-size: 10px;\n}\n\n.gatewayIpInput {\n  background: #193258 !important;\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"number\"],\ntextarea {\n  border-radius: 4px !important;\n  outline: none !important;\n}\n\n/* Custom class to hide scrollbar */\n.scrollbar-hide::-webkit-scrollbar {\n  display: none;\n}\n\n.scrollbar-hide {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.grafana-gauge svg {\n  margin-top: -10px !important;\n}\n\n.revolve {\n  transition: transform 0.2s ease-in-out;\n  /* Optional smooth transition */\n}\n\n.revolve:hover {\n  animation: revolve 0.3s linear infinite;\n}\n\n@keyframes revolve {\n  from {\n    transform: rotateY(0deg);\n  }\n\n  to {\n    transform: rotateY(360deg);\n  }\n}\n\n.loaderSpinner {\n  width: 48px;\n  height: 48px;\n  border: 5px solid #fff;\n  border-bottom-color: #ff3d00;\n  border-radius: 50%;\n  display: inline-block;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* \n.toastSuccess {\n  background: #09182f !important;\n  color: #ffffff !important;\n  border-radius: 4px !important;\n  border-color: 1px solid #193258 !important;\n}\n.toastSuccess .Toastify__zoom-enter {\n  color: white !important;\n} */\n.css-1dimb5e-singleValue {\n  color: #ffffff !important;\n  font-size: 12px !important;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus {\n  -webkit-text-fill-color: white !important;\n  box-shadow: 0 0 0 1000px #09182f inset !important;\n  -webkit-box-shadow: 0 0 0 1000px #09182f inset !important;\n  background-color: transparent !important;\n  color: white !important;\n  caret-color: white !important;\n  transition: background-color 9999s ease-in-out 0s;\n}\n\n/* toastify */\n.Toastify__toast--error,\n.Toastify__toast--success,\n.Toastify__toast--default {\n  /* width:350px !important; */\n  /* max-width: 500px !important; */\n  /* margin-right: 40px !important; */\n  background: #00070f !important;\n}\n\n.dark .Toastify__toast--error,\n.dark .Toastify__toast--success,\n.dark .Toastify__toast--default {\n  /* width:350px !important; */\n  /* max-width: 500px !important; */\n  /* margin-right: 40px !important; */\n  background: #dee5ed !important;\n}\n\n.toastSucesscus {\n  border: 1px solid #00c310 !important;\n}\n\n.toastError {\n  border: 1px solid #cd2f23 !important;\n}\n\n.Toastify__toast--error svg {\n  color: #78869b !important;\n}\n\ninput[type=\"text\"]:focus {\n  outline: none !important;\n}\n\n/* input {\n  padding: 4px !important;\n} */\n\n.ProseMirror {\n  z-index: 0 !important;\n}\n\n.Toastify__toast-container {\n  z-index: 999999 !important;\n  /* margin-right: 30px !important; */\n}\n\n.Toastify__close-button--light {\n  color: #78869b !important;\n  opacity: 1 !important;\n}\n\n.css-1jqq78o-placeholder,\n.css-aoxytf-singleValue {\n  font-size: 13px !important;\n  color: #fff !important;\n  font-weight: 400 !important;\n}\n\n.ReactTags__selected {\n  /* max-height: 40px !important; */\n  border-radius: 4px !important;\n  overflow-y: auto !important;\n  padding: 1px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n@keyframes popIn {\n  0% {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n\n  75% {\n    transform: scale(1.05);\n    opacity: 1;\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n.modal-box {\n  animation: popIn 0.3s ease-out;\n}\n\n.slick-list {\n  text-align: left !important;\n  justify-content: flex-start !important;\n  /* height: 100% !important;\n  width: 100% !important; */\n}\n\n.slick-track {\n  display: flex !important;\n  justify-content: flex-start !important;\n  /* width: 100% !important; */\n  align-items: center !important;\n}\n\n.slick-slider {\n  height: fit-content !important;\n}\n\n.slick-slide {\n  width: none !important;\n}\n\n.noTail h1 {\n  font-size: 2.25rem;\n  /* 36px */\n  font-weight: 800;\n  line-height: 1.25;\n}\n\n.noTail h2 {\n  font-size: 1.875rem;\n  /* 30px */\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.noTail h3 {\n  font-size: 1.5rem;\n  /* 24px */\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.noTail h4 {\n  font-size: 1.25rem;\n  /* 20px */\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.noTail h5 {\n  font-size: 1.125rem;\n  /* 18px */\n  font-weight: 600;\n  line-height: 1.6;\n}\n\n.noTail h6 {\n  font-size: 1rem;\n  /* 16px */\n  font-weight: 600;\n  line-height: 1.75;\n}\n\n.toastui-editor-popup-add-image,\n.toastui-editor-popup-add-link {\n  background: #09182f !important;\n  color: #78869b !important;\n  border: 1px solid #193258 !important;\n}\n\n.dark .toastui-editor-popup-add-image,\n.dark .toastui-editor-popup-add-link {\n  background: #f2f4f7 !important;\n  color: #78869b !important;\n  border: 1px solid #e6edf8 !important;\n}\n\nbody.dark .toastui-editor-popup-add-image,\nbody.dark .toastui-editor-popup-add-link {\n  background: #edf0f5 !important;\n  color: #78869b !important;\n  border: 1px solid #e6edf8 !important;\n}\n\n.toastui-editor-file-name {\n  border: 1px solid #193258 !important;\n}\n\n.dark .toastui-editor-file-name {\n  border: 1px solid #e6edf8 !important;\n}\n\nbody.dark .toastui-editor-file-name::placeholder {\n  color: #b5c6e0 !important;\n}\n\n.toastui-editor-popup-add-image .toastui-editor-tabs .tab-item.active {\n  color: #fff !important;\n}\n\nbody.dark\n  .toastui-editor-popup-add-image\n  .toastui-editor-tabs\n  .tab-item.active {\n  color: #000 !important;\n}\n\n.toastui-editor-popup-add-image .toastui-editor-tabs .tab-item {\n  color: #78869b !important;\n}\n\n.css-u18htb:hover {\n  background-color: transparent !important;\n}\n\n.ReactTags__remove svg {\n  height: 9px !important;\n  width: 9px !important;\n  font-weight: bold !important;\n}\n\n.toastui-editor-popup-add-image .toastui-editor-file-name.has-file {\n  color: #fff !important;\n}\n\nbody.dark .toastui-editor-popup-add-image .toastui-editor-file-name.has-file {\n  color: #000 !important;\n}\n\n.toastui-editor-popup-body label {\n  color: #78869b !important;\n}\n\n.docx-wrapper {\n  background: transparent !important;\n}\n\n/* Hide arrows in Chrome, Safari, Edge, and Opera */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Hide arrows in Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.border-dotted {\n  border-style: dotted;\n}\n\n/* .adminModule > div > svg{\n height: 200px !important;\n} */\n\n/* .grafana-gauge > svg{\n width: 450px;\n} */\n\n@layer utilities {\n  @keyframes pulseSlow {\n    0%,\n    100% {\n      transform: scale(0.8);\n      opacity: 0.6;\n    }\n\n    50% {\n      transform: scale(1.2);\n      opacity: 1;\n    }\n  }\n\n  .animate-pulse-slow {\n    animation: pulseSlow 1.2s infinite ease-in-out;\n  }\n\n  .delay-0 {\n    animation-delay: 0ms;\n  }\n\n  .delay-200 {\n    animation-delay: 200ms;\n  }\n\n  .delay-400 {\n    animation-delay: 400ms;\n  }\n\n  .delay-600 {\n    animation-delay: 600ms;\n  }\n}\n\nbody.dark .slick-prev:before,\nbody.dark .slick-next:before {\n  color: black;\n}\n\n.html-content img {\n  width: 150px;\n  height: 120px;\n  object-fit: cover;\n  /* optional, for better image scaling */\n}\n\n/* .bucket-cut {\n  --r: 50px;\n  height: 150px;\n  aspect-ratio: 1.2;\n  border-radius: 20px;\n  background: #F07818;\n  mask: radial-gradient(var(--r) at 50% var(--r),#0000 calc(100% - 1px),#000) 0 calc(-1*var(--r));\n  border: 2px solid white;\n} */\n\n.userStats .grafana-gauge svg {\n  width: 500px !important;\n  height: 350px !important;\n}\n\n/* HTML: <div class=\"inverted-radius\"></div> */\n.inverted-radius {\n  --r: 20px;\n  /* the radius */\n  --s: 30px;\n  /* size of inner curve */\n  --x: 5px;\n  /* horizontal offset (no percentage) */\n  --y: 5px;\n  /* vertical offset (no percentage) */\n\n  aspect-ratio: 1;\n  /* background: #3fb8af; */\n  border-radius: var(--r);\n  --_m: /calc(2 * var(--r)) calc(2 * var(--r))\n    radial-gradient(#000 70%, #0000 72%);\n  --_g: conic-gradient(at calc(100% - var(--r)) var(--r), #0000 25%, #000 0);\n  --_d: (var(--s) + var(--r));\n  mask:\n    calc(100% - var(--_d) - var(--x)) 0 var(--_m),\n    100% calc(var(--_d) + var(--y)) var(--_m),\n    radial-gradient(var(--s) at 100% 0, #0000 99%, #000 calc(100% + 1px))\n      calc(-1 * var(--r) - var(--x)) calc(var(--r) + var(--y)),\n    var(--_g) calc(-1 * var(--_d) - var(--x)) 0,\n    var(--_g) 0 calc(var(--_d) + var(--y));\n  mask-repeat: no-repeat;\n}\n\n.css-fyq6mk-container {\n  /* border: 1px solid #193258 !important; */\n  border-radius: 4px !important;\n}\n\n/* input[type=\"radio\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  background-color: transparent;\n  border: 1px solid #ccc;\n  width: 17px;\n  height: 17px;\n  border-radius: 50%;\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\ninput[type=\"radio\"]:checked {\n  border-color: #00c310;\n}\n\ninput[type=\"radio\"]:checked::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 9px; \n  height: 9px;\n  background-color: #00c310;\n  border-radius: 50%;\n  box-sizing: border-box;\n} */\n\n.tnc {\n  background-image: radial-gradient(\n    circle 60vh at 50% 250%,\n    #1b68a9 40%,\n    transparent\n  );\n  background-size: 100% 20vh;\n  background-repeat: no-repeat;\n}\n\n.skillContainer:hover {\n  background-image: radial-gradient(\n    circle 10vh at 50% 100%,\n    #1b68a9 40%,\n    transparent\n  );\n  background-size: 100% 10vh;\n  background-repeat: no-repeat;\n}\n\n.dark .skillContainer:hover {\n  background-image: radial-gradient(\n    circle 10vh at 50% 100%,\n    #2196f3 40%,\n    transparent\n  );\n  background-size: 100% 10vh;\n  background-repeat: no-repeat;\n}\n\n.achContainer {\n  background-image: radial-gradient(\n    circle 50vh at 70% -220px,\n    /* Move to top */ #1b68a9 0%,\n    /* Start strong */ #106eff 0%,\n    /* Hold color longer */ transparent 100% /* Fade fully */\n  );\n  background-size: 100% 100%;\n  /* Make it spread more vertically */\n  background-repeat: no-repeat;\n  background-position: top center;\n  /* Stick it to top edge */\n}\n\n@keyframes scroll-left {\n  0% {\n    transform: translateX(100%);\n  }\n\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n/* profile spikes line */\n.outer1 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.between1 {\n  width: 120px;\n  height: 0.5px;\n  background: #045d0b;\n  position: relative;\n  top: -0.5px;\n}\n\n.dark .between1 {\n  background: #00c331;\n}\n\n.container1 {\n  position: relative;\n  background: #ffffff;\n  border-top: 1px solid #045d0b;\n  width: 50px;\n}\n\n.dark .container1 {\n  border-top: 1px solid #00c331;\n}\n\n.container1::before,\n.container1::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n}\n\n.container1::before {\n  border-bottom-color: #045d0b;\n}\n\n.dark .container1::before {\n  border-bottom-color: #00c331;\n}\n\n.container1::after {\n  border-width: 4px;\n  border-bottom-color: #14243e;\n}\n\n.dark .container1::after {\n  border-bottom-color: #f8fbff;\n}\n\n/* profile spikes line end */\n\n/* profile spikes line2 start */\n.outer2 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.between2 {\n  width: 120px;\n  height: 0.5px;\n  background: #045d0b;\n}\n\n.dark .between2 {\n  background: #00c331;\n}\n\n.container2 {\n  position: relative;\n  background: #ffffff;\n  border-bottom: 1px solid #045d0b;\n  width: 50px;\n}\n\n.dark .container2 {\n  border-bottom: 1px solid #00c331;\n}\n\n.container2::before,\n.container2::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n}\n\n.container2::before {\n  border-top-color: #045d0b;\n}\n\n.dark .container2::before {\n  border-top-color: #00c331;\n}\n\n.container2::after {\n  border-width: 4px;\n  border-top-color: #14243e;\n}\n\n.dark .container2::after {\n  border-top-color: #f8fbff;\n}\n\n/* profile spikes line2 end */\n\n/* #react-select-7-input {\n  display: none !important;\n} */\n\n.gradient-borders {\n  border: 2px solid transparent;\n  border-radius: 6px;\n}\n\n.gradient-borders:hover {\n  border-image: linear-gradient(\n    to right,\n    rgb(222, 222, 222) 0%,\n    transparent 70%\n  );\n  border-image-slice: 1;\n}\n\n.dark .gradient-borders:hover {\n  border-image: linear-gradient(to right, rgb(0, 195, 60) 0%, transparent 70%);\n  border-image-slice: 1;\n}\n\n/* gradient-borders bottom */\n.gradient-borders-bottom {\n  position: relative;\n  border-radius: 6px;\n  /* Works fine */\n}\n\n.gradient-borders-bottom::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  padding: 2px;\n  /* thickness of border */\n  border-radius: 6px;\n  background: linear-gradient(to top, #00c310 0%, transparent 70%);\n  -webkit-mask:\n    linear-gradient(#fff 0 0) content-box,\n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  /* for Firefox */\n  pointer-events: none;\n\n  opacity: 0;\n  /* hidden by default */\n  /* transition: opacity 0s ease-in-out; */\n}\n\n.gradient-borders-bottom:hover::before {\n  opacity: 1;\n  /* show on hover */\n}\n\ninput.size-input[type=\"number\"] {\n  color: #fff !important;\n}\n\nbody.dark input.size-input[type=\"number\"] {\n  color: #000 !important;\n}\n\n.drop-down-item:hover {\n  background-color: rgb(6, 26, 58) !important;\n}\n\nbody.dark .drop-down-item:hover {\n  background-color: #ebedef !important;\n}\n\nbody.dark .toastui-editor-contents ol > li::before {\n  color: #000 !important;\n}\n\nbody.dark .toastui-editor-contents ul > li::before {\n  background-color: #000 !important;\n}\n\n.apexcharts-toolbar {\n  display: none !important;\n}\n\n/* #react-select-2-input,\n#react-select-3-input,\n#react-select-4-input,\n#react-select-5-input {\n  display: none !important;\n} */\n/* Firefox */\n.react-tags-active {\n  border: 1px solid #00c310 !important;\n}\n\n.custom-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: rgb(25, 50, 88) rgb(8, 24, 48);\n}\n\n.dark .custom-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: #999 #f0f0f0 !important;\n  /* green thumb, dark track */\n}\n\n.apexcharts-legend-text {\n  color: #ffffff !important;\n}\n\n.apexcharts-yaxis-label {\n  color: #ffffff !important;\n}\n\n/* Chrome, Edge, Safari */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: rgb(8, 24, 48);\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: rgb(25, 50, 88);\n  border-radius: 6px;\n}\n\n.clip-triangle {\n  clip-path: polygon(100% 0, 0 100%, 100% 100%);\n}\n\n@keyframes blinkBackground {\n  0%,\n  100% {\n    background-color: rgba(244, 67, 54, 0.2);\n    /* red, faint */\n  }\n\n  50% {\n    background-color: rgba(244, 67, 54, 10, 0.6);\n    border: 1px solid #f44336;\n  }\n}\n\n.blink-bg {\n  animation: blinkBackground 1s infinite;\n}\n\n.toastui-editor-defaultUI-toolbar {\n  border-radius: 4px 4px 0 0 !important;\n}\n\n.toastui-editor-main {\n  border: 1px solid #193258 !important;\n  border-top: 0 !important;\n  margin-top: -2px !important;\n  border-radius: 0 0 4px 4px !important;\n}\n\n.dark .toastui-editor-main {\n  border: 1px solid #bec8d5 !important;\n}\n\n.ww-mode {\n  padding: 5px !important;\n}\n\n/* for announcement structure */\n.custom-clip {\n  clip-path: polygon(95% 85%, 26% 85%, 25% 100%, 0% 100%, 5% 0%, 100% 0%);\n  z-index: 20;\n}\n\n.custom-clip::after {\n  content: \"\";\n  height: 50px;\n  width: 7%;\n  background: #1f81d1;\n  position: absolute;\n  right: 0px;\n  clip-path: polygon(100% 100%, 0% 100%, 91% 0%, 100% 0%);\n}\n\n.blink-message {\n  font-weight: 600;\n  color: #00e676;\n  /* success green (change for error/warning) */\n  animation: zomatoBlink 1.5s ease-in-out infinite;\n}\n\n@keyframes zomatoBlink {\n  0% {\n    opacity: 0;\n    transform: translateY(5px);\n  }\n\n  50% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  100% {\n    opacity: 0.9;\n    transform: translateY(-2px);\n  }\n}\n\n/* ContextMenu.css */\n.context-menu {\n  position: absolute;\n  /* instead of fixed */\n  z-index: 1000;\n  display: none;\n}\n\n.context-menu.active {\n  display: block;\n}\n\n.inputField {\n  background: transparent;\n  border: 1px solid #193258 !important;\n  font-size: 14px !important;\n  color: #dddddd !important;\n  width: 100%;\n}\n\n.dark .inputField {\n  border: 1px solid #bec8d5 !important;\n}\n\n.css-ofedx2-container {\n  border: 1px solid #193258 !important;\n  border-radius: 4px !important;\n}\n\n.dark .css-ofedx2-container {\n  border: 1px solid #e6edf8 !important;\n  border-radius: 4px !important;\n}\n\n.errorField {\n  background: transparent;\n\n  font-size: 14px !important;\n  color: #dddddd !important;\n  width: 100%;\n  border: 1px solid red !important;\n}\n\n.taskinput:focus {\n  outline: none !important;\n  border: none !important;\n}\n\n.toastui-editor-popup-add-heading ul li:hover {\n  background-color: #193258 !important;\n}\n\n.toastui-editor-popup {\n  border: 1px solid #193258 !important;\n  top: 43px !important;\n}\n\n.dark .toastui-editor-popup {\n  border: 1px solid #e6edf8 !important;\n  top: 43px !important;\n}\n\n.toastui-editor-toolbar-icons {\n  border: none !important;\n}\n\n.light button[aria-label=\"F\"] {\n  border: none !important;\n}\n\n.light .toastui-editor-toolbar-icons:hover::after,\n.light .toastui-editor-toolbar-icons:active::after {\n  color: #ffffff !important;\n}\n\n.dark .toastui-editor-toolbar-icons:hover::after,\n.dark .toastui-editor-toolbar-icons:active::after {\n  color: #000000 !important;\n}\n\n.light .tui-tool-item.tui-tool-active::after,\n.light .tui-tool-item[aria-pressed=\"true\"]::after {\n  color: #ffffff !important;\n}\n\n.light button[aria-label=\"F\"]:hover,\n.light button[aria-label=\"F\"]:active {\n  color: #fff !important;\n}\n\n/* Hover & active (when pressed/clicked) */\n.light .toastui-editor-toolbar-icons:hover::after,\n.light .toastui-editor-toolbar-icons:active::after {\n  color: #ffffff !important;\n}\n\n/* Proper active state: Toast UI marks active buttons with .tui-tool-active or aria-pressed=\"true\" */\n.light .tui-tool-item.tui-tool-active .toastui-editor-toolbar-icons::after,\n.light\n  .toastui-editor-toolbar\n  button[aria-pressed=\"true\"]\n  .toastui-editor-toolbar-icons::after {\n  color: #ffffff !important;\n}\n\n.toastui-editor-toolbar button.active::after,\n.toastui-editor-toolbar button.active::before {\n  color: #ffffff !important;\n}\n\n.dark .toastui-editor-toolbar button.active::after,\n.dark .toastui-editor-toolbar button.active::before {\n  color: #000000 !important;\n}\n\n.toastui-editor-file-select-button {\n  background-color: #193258 !important;\n  border: none !important;\n  color: white !important;\n}\n\n.toastui-editor-file-select-button:hover {\n  background-color: #2b589b !important;\n}\n\n.dark .toastui-editor-file-select-button {\n  background-color: #e6edf8 !important;\n  color: black !important;\n}\n\n.dark .toastui-editor-file-select-button:hover {\n  background-color: #b5c6e0 !important;\n}\n\n#toastuiLinkUrlInput:focus ~ label[for=\"toastuiLinkTextInput\"] {\n  color: #78869b !important;\n  font-size: 12px !important;\n}\n\n.toastui-editor-close-button {\n  background-color: #193258 !important;\n  color: white !important;\n  border: none !important;\n  border-radius: 4px !important;\n}\n\n.toastui-editor-close-button:hover {\n  background-color: #2b589b !important;\n}\n\n.dark .toastui-editor-close-button {\n  background-color: #e6edf8 !important;\n  color: black !important;\n}\n\n.dark .toastui-editor-close-button:hover {\n  background-color: #b5c6e0 !important;\n}\n\n.toastui-editor-ok-button {\n  background-color: #00c310 !important;\n  color: black !important;\n  border: none !important;\n}\n\n.toastui-editor-ok-button:hover {\n  background-color: #00ea13 !important;\n}\n\n.toastui-editor-popup-add-image .toastui-editor-tabs .tab-item.active {\n  border-bottom: 2px solid #00c310 !important;\n}\n\n.toastui-editor-popup-add-link .toastui-editor-popup-body,\n.toastui-editor-popup-add-image .toastui-editor-popup-body {\n  padding: 0px !important;\n}\n\n.toastui-editor-popup-body {\n  padding: 0px !important;\n}\n\n.toastui-editor-popup-body > div {\n  padding: 0 16px !important;\n}\n\n.toastui-editor-popup-body input[type=\"text\"] {\n  border: 1px solid #193258 !important;\n}\n\n.dark .toastui-editor-popup-body input[type=\"text\"] {\n  border: 1px solid #e6edf8 !important;\n}\n\n.toastui-editor-button-container {\n  padding: 8px 0px !important;\n  /* x-axis padding */\n}\n\n/* .toastui-editor-popup-body .toastui-editor-button-container {\n  margin-top: 0px !important;\n} */\n\n.toastui-editor-popup-body input[type=\"text\"] {\n  width: 365px !important;\n  display: flex !important;\n  align-items: start !important;\n  justify-content: start !important;\n}\n\n.toastui-editor-popup-add-image .toastui-editor-file-name {\n  width: 65% !important;\n}\n\n.toastui-editor-popup-body label {\n  padding: 8px 0px !important;\n  margin: 0px 0 5px !important;\n}\n\n.toastui-editor-defaultUI .ProseMirror {\n  padding: 8px 8px !important;\n}\n\n.toastui-editor-popup-add-image .toastui-editor-tabs {\n  margin: 0px 0 10px !important;\n}\n\n.apexcharts-tooltip {\n  z-index: 9999 !important;\n}\n\n.apexcharts-series .apexcharts-pie-series {\n  border: none !important;\n}\n\n.apexcharts-tooltip {\n  z-index: 9999 !important;\n}\n\n.sidebarheight {\n  height: calc(96vh - 60px);\n}\n\n/* Force autofill background to match your theme */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0px 1000px var(--autofill-bg) inset !important;\n  -webkit-text-fill-color: var(--autofill-text) !important;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n:root {\n  --autofill-bg: #061123;\n  --autofill-text: #fdfeff;\n}\n\n.dark {\n  --autofill-bg: #fdfeff;\n  --autofill-text: #061123;\n}\n\n.toastui-editor-contents a {\n  color: #4b96e6 !important;\n}\n\n.react-select__input input:focus {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n@keyframes shake {\n  0%,\n  100% {\n    transform: translateX(0);\n  }\n\n  25% {\n    transform: translateX(-3px);\n  }\n\n  75% {\n    transform: translateX(3px);\n  }\n}\n\n.animate-shake {\n  animation: shake 0.2s ease-in-out;\n}\n\n.sample-canvas {\n  background-image: url(\"../public/images/dotted_bg.svg\") !important;\n}\n\n.dark .sample-canvas {\n  background-image: url(\"../public/images/dotted_bg_light.svg\") !important;\n}\n\n.dark text[fill] {\n  fill: #000000 !important;\n}\n\n.light text[fill] {\n  fill: #ffffff !important;\n}\n\n.dark input:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.light input:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.dark textarea:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.light textarea:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n.thumbnail-image {\n  height: 200px !important;\n}\n\n.chrome-tab {\n  position: relative;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n/* Left curve */\n.chrome-tab::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: -10px;\n  width: 12px;\n  height: 12px;\n  background: inherit;\n  border-bottom-right-radius: 10px;\n}\n\n/* Right curve */\n.chrome-tab::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: -10px;\n  width: 12px;\n  height: 12px;\n  background: inherit;\n  border-bottom-left-radius: 10px;\n}\n\n.dark .toastui-editor-contents h1 span {\n  color: #000 !important;\n}\n\n/* Dark mode: force all H1 and nested spans inside H1 */\n.dark .toastui-editor-contents h1,\n.dark .toastui-editor-contents h1 * {\n  color: #000 !important;\n  /* Change to your dark-theme heading color */\n}\n\n.dark .toastui-editor-contents span {\n  color: #000 !important;\n  /* change to your dark theme text color */\n}\n\n/* \n.slide-text {\n  animation: slide-left 30s linear forwards;\n  animation-play-state: running;\n}\n\n.slide-text.paused {\n  animation-play-state: paused;\n} */\n\n.customEditorForComment .toastui-editor-defaultUI-toolbar {\n  visibility: hidden !important;\n  height: 1px !important;\n}\n\n.customEditorForComment .toastui-editor-toolbar {\n  height: 1px;\n}\n\n.customEditorForComment .toastui-editor-main-container {\n  height: 115px;\n  position: relative;\n  top: 3px;\n}\n\n.customEditorForComment .toastui-editor-popup {\n  width: 100%;\n  left: 4px !important;\n  top: -40px !important;\n}\n\n.customEditorForComment .toastui-editor-popup-add-image {\n  top: -94px !important;\n}\n\n.customEditorForComment #toastuiAltTextInput {\n  width: 100% !important;\n}\n\n.customEditorForComment #toastuiLinkUrlInput {\n  width: 100% !important;\n}\n\n.customEditorForComment #toastuiLinkTextInput {\n  width: 100% !important;\n}\n\n.customEditorForComment #toastuiImageUrlInput {\n  width: 100% !important;\n}\n\n.customEditorForComment .toastui-editor {\n  height: 100% !important;\n}\n\n.customEditorForComment .toastui-editor-main {\n  border: none !important;\n}\n\n.custom-height-ticket {\n  height: calc(100vh - 100px);\n}\n\n.light .commentSection p,\n.light .commentSection h1,\n.light .commentSection h2,\n.light .commentSection h3,\n.light .commentSection h4,\n.light .commentSection h5,\n.light .commentSection h6,\n.light .commentSection div,\n.light .commentSection span,\n.light .commentSection label,\n.light .commentSection {\n  color: #ffffff !important;\n}\n\n#toastuiAltTextInput {\n  display: none !important;\n}\n\nlabel[for=\"toastuiAltTextInput\"] {\n  display: none !important;\n}\n\n.toastui-editor-button-container {\n  margin-top: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
